export default {
  utils: {
    components: {
      input: {
        max_chars: 'Máx. de caracteres: {{chars}}',
      },
      button: {
        save_as_draft: 'Salvar como rascunho',
        next: 'Próximo',
        cancel: 'Cancelar',
        create: 'Criar',
        save_changes: 'Salvar alterações',
        close: 'Fechar',
        save_and_next: 'Salvar e continuar',
      },
    },

    schema: {
      required: 'Campo obrigatório',
      select_image: 'Selecione uma imagem',
    },
  },

  common: {
    million: 'M',
    thousand: 'mil',
    yes: 'Sim',
    no: 'Não',
    actions: 'Ações',
  },

  team_autocomplete: {
    team_label: 'Time:',
    team_select_all: 'Todos',
  },

  calendar: {
    timestamp: {
      day: 'dia',
      day_plural: 'dias',
      hour: 'hora',
      hour_plural: 'horas',
      minute: 'min',
      minute_plural: 'min',
      second: 'seg',
      second_plural: 'seg',
    },
    today: 'Hoje',
    year: 'Ano',
    years: 'Anos',
    january: 'Janeiro',
    february: 'Fevereiro',
    march: 'Março',
    april: 'Abril',
    may: 'Maio',
    june: 'Junho',
    july: 'Julho',
    august: 'Agosto',
    september: 'Setembro',
    october: 'Outubro',
    november: 'Novembro',
    december: 'Dezembro',
    month: 'Mês',
    short_month: {
      jan: 'jan',
      feb: 'feb',
      mar: 'mar',
      apr: 'apr',
      may: 'may',
      jun: 'jun',
      jul: 'jul',
      aug: 'aug',
      sep: 'sep',
      oct: 'oct',
      nov: 'nov',
      dec: 'dec',
    },
    days_of_week: {
      monday: 'Segunda-feira',
      tuesday: 'Terça-feira',
      wednesday: 'Quarta-feira',
      thursday: 'Quinta-feira',
      friday: 'Sexta-feira',
      saturday: 'Sábado',
      sunday: 'Domingo',
    },
    short_days_of_week: {
      mon: 'Seg',
      tue: 'Ter',
      wed: 'Qua',
      thu: 'Qui',
      fri: 'Sex',
      sat: 'Sáb',
      sun: 'Dom',
    },
    relative: {
      minutes_ago_one: 'Há {{count}} minuto',
      minutes_ago_other: 'Há {{count}} minutos',
      hours_ago_one: 'Há {{count}} hora',
      hours_ago_other: 'Há {{count}} horas',
      days_ago_one: 'Há {{count}} dia',
      days_ago_other: 'Há {{count}} dias',
      on_date: 'Em {{date}}',
    },
  },

  components: {
    audio_upload: {
      audio_upload_help_text: 'Formato: MP3 ou WAV',
      audio_upload_default_file_name: 'audio.mp3',
      audio_upload_delete_button_label: 'Deletar imagem',
    },

    auth_banner: {
      auth_banner_title: 'Portal do cliente',
    },

    confirmation_modal: {
      confirmation_modal_confirm_label: 'Confirmar',
      confirmation_modal_cancel_label: 'Cancelar',
    },
    confirmation_password_modal: {
      confirmation_password_modal_title: 'Confirmar senha',
      confirmation_password_modal_description: 'Insira sua senha de acesso para confirmar a ação',
      confirmation_password_modal_confirm_label: 'Confirmar',
      confirmation_password_modal_cancel_label: 'Cancelar',
      confirmation_password_modal_password_label: 'Senha *',
    },

    controlled_input: {
      input_file_delete_button_label: 'Deletar imagem',
    },

    controlled_select: {
      controlled_select_placeholder: 'Selecione',
    },

    date_range_filter_fields: {
      date_range_filter_fields_date_label: 'Data:',
      date_range_filter_fields_start_date_label: 'Data inicial:',
      date_range_filter_fields_end_date_label: 'Data final:',

      date_range_filter_fields_option_all: 'Todos',
      date_range_filter_fields_option_seven_days: '7 dias',
      date_range_filter_fields_option_fifteen_days: '15 dias',
      date_range_filter_fields_option_thirty_days: '30 dias',
      date_range_filter_fields_option_ninety_days: '90 dias',
      date_range_filter_fields_option_define_date: 'Definir data',
    },

    edit_media_modal: {
      edit_media_modal_title: 'Editar mídia',
      edit_media_modal_delete_button: 'Excluir mídia',
      edit_media_modal_cancel_button: 'Cancelar',
      edit_media_modal_save_button: 'Salvar',
    },

    empty_table_row: {
      empty_table_row_message: 'Nenhum conteúdo encontrado',
    },

    file_upload: {
      file_upload_help_text: 'Formato: PNG ou JPG | Dimensões 1024 x 1024 px',
      file_upload_modal_title: 'Excluir arquivo',
      file_upload_modal_description: 'Tem certeza que deseja excluir o arquivo ?',
      file_upload_download_button_label: 'Baixar imagem',
      file_upload_delete_button_label: 'Deletar imagem',
    },

    icon_select: {
      icon_select_label: 'Ícone',
      icon_select_placeholder: 'Selecionar',
      icon_select_menu_button_label: 'Mostrar mais ações',
    },

    image_cropper: {
      image_cropper_save_button: 'Salvar alterações',
    },

    image_upload: {
      image_upload_help_text: 'Formato: PNG ou JPG | Dimensões 1024 x 1024 px',
      image_upload_download_button_label: 'Baixar imagem',
      image_upload_delete_button_label: 'Deletar imagem',
    },

    list_pagination_control: {
      list_pagination_control_next_page: 'Próxima página',
      list_pagination_control_previous_page: 'Página anterior',
      list_pagination_control_formlabel: 'Itens por página:',
    },

    notification_modal: {
      notification_modal_create_title: 'Criar nova notificação',
      notification_modal_edit_title: 'Editar notificação',
      notification_modal_create_button: 'Criar',
      notification_modal_edit_button: 'Salvar alterações',
      notification_modal_cancel_button: 'Cancelar',
      notification_modal_name_label: 'Nome*:',
      notification_modal_name_helper_text: '(Máx. de caracteres: 50)',
      notification_modal_description_label: 'Descrição*:',
      notification_modal_description_helper_text: '(Máx. de caracteres: 200)',
      notification_modal_direct_label: 'Direcionar',
      notification_modal_app_area_label: 'Área do aplicativo:',
      notification_modal_app_area_placeholder: 'Selecione',
      notification_modal_external_link_label: 'Link externo:',

      notification_modal_form: {
        notification_modal_form_name_required: 'Campo obrigatório',
        notification_modal_form_direct_type_required: 'Selecione um tipo para direcionar',
        notification_modal_form_app_area_required: 'Selecione uma área',
        notification_modal_form_external_link_required: 'Insira um link',
      },
    },

    notifications_table: {
      notifications_table_header_date_label: 'DATA DE CRIAÇÃO',
      notifications_table_header_name_label: 'NOME',
      notifications_table_header_description_label: 'DESCRIÇÃO',
      notifications_table_header_actions_label: 'AÇÕES',

      notifications_table_row: {
        notifications_table_row_menu_button_label: 'Mostrar mais ações',
        notifications_table_row_view_details: 'Ver detalhes',
      },
    },

    password_check: {
      password_check_instruction: 'Sua senha deve conter, no mínimo:',
    },

    password_input: {
      password_input_aria_label: 'Senha',
    },

    pdf_viewer: {
      pdf_viewer_loading_message: 'Carregando documento...',
      pdf_viewer_error_message: 'Falha ao carregar documento',
    },

    profile_image: {
      profile_image_change_text: 'Alterar foto de perfil',
      profile_image_invalid_file_title: 'Tipo de arquivo inválido',
      profile_image_invalid_file_description: 'Selecione apenas arquivo de imagem.',
    },

    profile_menu: {
      profile_menu_my_data: 'Meus dados',
      profile_menu_logout: 'Sair',
    },

    select_list: {
      select_list_available_label: 'Disponíveis:',
      select_list_selected_label: 'Selecionados:',
    },

    simple_breadcrumb: {
      simple_breadcrumb_back_button: 'VOLTAR',

      home_breadcrumb_item: {
        home_breadcrumb: 'INÍCIO',
      },
    },

    table_simple_controls: {
      export_button_label: 'Exportar',
      export_button_excel_option: 'Exportar para EXCEL',
      export_button_csv_option: 'Exportar para CSV',
      update_button_list: 'Atualizar lista',
    },

    vertical_layout: {
      header_portal_label: 'PORTAL DO CLIENTE',
      menu_item_home: 'Início',
      menu_item_users: 'Usuários',
      menu_item_application: 'Aplicativo',
      menu_item_partners: 'Parceiros',
      menu_item_access_control: 'Controle de Acesso',
      menu_item_communication_central: 'Central de Comunicação',
    },
  },

  pages: {
    access_control: {
      components: {
        filter_box: {
          heading: 'Filtros',
          label_user: 'Usuário:',
          button_clear: 'Limpar filtros',
        },
        users_table: {
          column_created_at: 'DATA DA CRIAÇÃO',
          column_name: 'USUÁRIO',
          column_document: 'CPF',
          column_email: 'EMAIL',
          column_last_access: 'ÚLTIMO ACESSO',
          column_status: 'SITUAÇÃO',
          column_actions: 'Ações',
          action_view_details: 'Editar',
          action_delete: 'Excluir',
          aria_label_more_actions: 'Mostrar mais ações',
        },
        user: {
          heading: 'Cadastrar novo usuário',
          form: {
            name: 'Nome:',
            document: 'CPF:',
            phone: 'Telefone:',
            email: 'Email:',
            email_confirmation: 'Confirmar email:',
            button_submit: 'Cadastrar novo usuário',
          },

          schema: {
            required: 'Campo obrigatório',
            invalid_document: 'Documento inválido',
            invalid_phone: 'Telefone inválido',
            invalid_email: 'E-mail inválido',
            email_mismatch: 'Os e-mails não conferem',
          },

          success_toast: 'Usuário cadastrado com sucesso!',
          error_toast: 'Ocorreu um erro ao cadastrar usuário. Tente novamente.',
        },
      },

      breadcrumb: {
        label: 'CONTROLE DE ACESSO',
      },

      title: 'CONTROLE DE ACESSO',

      toast: {
        delete_success: 'Conta excluída com sucesso',
        delete_error: 'Houve um erro ao excluir a conta. Tente novamente',
      },
    },

    access_control_permission_type_edit: {
      breadcrumb: {
        label1: 'CONTROLE DE ACESSO',
        label2: 'PERMISSÕES PADRÃO',
        label3: 'DETALHES',
      },

      title: 'DETALHES DO TIPO DE PERMISSÃO',

      form: {
        section_title: 'Dados do Tipo de Permissão',
        label_name: 'Nome do tipo:',
        button_submit_desktop: 'Salvar alterações',
        button_submit_mobile: 'Salvar alterações',
        permissions_section_title: 'Permissões Padrão',
      },

      permissions_labels: {
        HOME: 'Home',
        USERS: 'Usuários',
        SUBSCRIBERS: 'Sócio Torcedores',
        ACCESS_PLANS: 'Planos de Sócio',
        APPLICATION: 'Aplicativo',
        FINANCIAL: 'Financeiro',
        PARTNERS: 'Parceiros',
        ACCESS_CONTROL: 'Controle de Acesso',
        COMMUNICATION_CENTRAL: 'Central de Comunicação',
      },

      toast: {
        success: 'Tipo de permissão alterado com sucesso',
        error: 'Erro ao alterar tipo de permissão. Tente novamente.',
      },

      schema: {
        required: 'Campo obrigatório',
        required_permissions: 'Selecione pelo menos uma permissão',
      },
    },

    access_control_permission_types: {
      components: {
        filter_box: {
          heading: 'Filtros',
          label_name: 'Nome:',
          button_clear: 'Limpar filtros',
        },
        permission_table_header: {
          column_created_at: 'DATA DE CRIAÇÃO',
          column_name: 'NOME',
          column_actions: 'AÇÕES',
        },

        permission_table_row: {
          action_view_permissions: 'Ver permissões',
          aria_label_more_actions: 'Mostrar mais ações',
        },
      },
      breadcrumb: {
        label1: 'CONTROLE DE ACESSO',
        label2: 'PERMISSÕES PADRÃO',
      },
      button_new_permission_type: 'Novo tipo de permissão',
      title: 'PERMISSÕES PADRÃO',
    },

    access_control_permission_types_new: {
      breadcrumb: {
        label1: 'CONTROLE DE ACESSO',
        label2: 'PERMISSÕES PADRÃO',
        label3: 'CRIAR NOVO TIPO',
      },
      title: 'NOVO TIPO DE PERMISSÃO',
      permission_data: 'Dados do Tipo de Permissão',
      name_label: 'Nome do tipo:',
      submit_button: 'Salvar tipo de permissão',
      permissions_section: 'Permissões Padrão',
      error_permission_message: 'Erro ao criar tipo de permissão. Tente novamente.',
      home: 'Home',
      users: 'Usuários',
      subscribers: 'Sócio Torcedores',
      access_plans: 'Planos de Sócio',
      application: 'Aplicativo',
      financial: 'Financeiro',
      partners: 'Parceiros',
      access_control: 'Controle de Acesso',
      communication_central: 'Central de Comunicação',

      schema: {
        required: 'Campo obrigatório',
        required_permissions: 'Selecione pelo menos uma permissão',
      },
    },

    access_control_user_edit: {
      breadcrumb: {
        label1: 'CONTROLE DE ACESSO',
        label2: 'PERMISSÕES DO USUÁRIO',
      },

      title: 'PERMISSÕES DO USUÁRIO',
      section_user_data: 'Dados do Usuário',
      name: 'Nome:',
      email: 'E-mail:',
      creation_date: 'Data da criação:',
      document: 'CPF:',
      phone: 'Telefone:',
      last_access: 'Último acesso:',
      type_label: 'Tipo de permissão:',
      placeholder: 'Selecione',
      save_changes: 'Salvar alterações',
      section_user_status: 'Situação do Usuário',
      blocked: 'Bloqueado',
      section_user_permissions: 'Permissões do Usuário',
      home: 'Home',
      users: 'Usuários',
      subscribers: 'Sócio Torcedores',
      access_plans: 'Planos de Sócio',
      application: 'Aplicativo',
      financial: 'Financeiro',
      partners: 'Parceiros',
      access_control: 'Controle de Acesso',
      communication_central: 'Central de Comunicação',
      success_toast: 'Permissões do usuário alteradas com sucesso',
      error_toast: 'Erro ao alterar permissões do usuário. Tente novamente.',

      schema: {
        required: 'Campo obrigatório',
        required_permissions: 'Selecione pelo menos uma permissão',
      },
    },

    accountdetail: {
      components: {
        tabs: {
          tabs: {
            personal_data: 'Dados pessoais',
            localization: 'Localização',
            contact: 'Contato',
            notifications: 'Notificações',
          },
          contacttab: {
            title: 'Contato',
            email_label: 'E-mail',
            phone_label: 'Telefone',
            button_submit: 'Salvar alterações',
            success: 'Contato do usuário alterado com sucesso',
            error: 'Houve um erro ao alterar contato do usuário. Tente novamente',
            schema: {
              required: 'Campo obrigatório',
              invalid_phone: 'Telefone inválido',
            },
          },
          localizationtab: {
            title: 'Localização',
            postal_code_label: 'CEP',
            street_label: 'Logradouro',
            number_label: 'Número',
            complement_label: 'Complemento',
            neighborhood_label: 'Bairro',
            city_label: 'Cidade',
            state_label: 'Estado',
            country_label: 'País',
            button_submit: 'Salvar alterações',
            success: 'Endereço do usuário alterado com sucesso',
            error: 'Houve um erro ao alterar endereço do usuário. Tente novamente',
            schema: {
              required: 'Campo obrigatório',
              invalid_postal_code: 'CEP inválido',
            },
          },
          notificationstab: {
            title: 'Notificações',
            button_create: 'Criar nova notificação',
            create_success: 'Notificação criada com sucesso',
            update_success: 'Notificação alterada com sucesso',
          },
          personal_data_tab: {
            title: 'Dados pessoais',
            first_name_label: 'Nome',
            last_name_label: 'Sobrenome',
            document_label: 'Documento',
            nickname_label: 'Apelido',
            birthdate_label: 'Data de nascimento',
            gender_label: 'Gênero*:',
            select_option: 'Selecione',
            button_submit: 'Salvar alterações',
            success: 'Dados do usuário alterados com sucesso',
            error: 'Houve um erro ao alterar dados do usuário. Tente novamente',
            schema: {
              required: 'Campo obrigatório',
              invalid_document: 'Documento inválido',
            },
          },
        },
        filter_box: {
          heading: 'Filtros',
          notification_label: 'Notificação:',
          start_date_label: 'Data inicial:',
          end_date_label: 'Data final:',
          button_clear: 'Limpar filtros',
        },
        header_info: {
          creation_date: 'Data de criação:',
          last_access: 'Último acesso:',
          app_version: 'Versão do aplicativo:',
          terms_of_use: 'Termos de uso:',
        },
      },

      breadcrumb: {
        label1: 'USUÁRIOS',
        label2: 'DETALHES DO USUÁRIO',
      },

      title: 'DETALHES DO USUÁRIO',
      success_image: 'Imagem de perfil alterada com sucesso',
      error: 'Houve um erro ao alterar a imagem de perfil. Tente novamente',
      button: 'Excluir conta',
      modal_title: 'Excluir conta',
      modal_description: 'Ao excluir essa conta, todos os dados do usuário serão apagados definitivamente. Deseja continuar?',
      button_continue: 'Continuar',
      password_description: 'Insira sua senha de acesso para confirmar a exclusão da conta:',
      button_confirm: 'Excluir conta',
      delete_success: 'Usuário excluído com sucesso!',
      delete_error: 'Erro ao excluir usuário. Tente novamente.',
    },

    accountlist: {
      components: {
        account_table: {
          created_at: 'DATA DE CADASTRO',
          name: 'NOME',
          id: 'ID',
          last_access: 'ÚLTIMO ACESSO',
          actions: 'Ações',
          action_view_details: 'Editar',
          aria_label_more_actions: 'Mostrar mais ações',
        },
        filter_box: {
          heading: 'Filtros',
          label_register: 'Cadastro:',
          label_access: 'Acesso:',
          option_all: 'Todos',
          button_clear: 'Limpar filtros',
        },
      },
      breadcrumb: {
        label: 'USUÁRIOS',
      },
      title: 'USUÁRIOS',
    },

    application_banner: {
      components: {
        banner_create_modal: {
          title: 'Criar novo banner',
          team_label: 'Time:',
          title_label: 'Título*:',
          title_helper: '(Máx. de caracteres: 100)',
          size_label: 'Tamanho:',
          size_placeholder: 'Nenhum',
          link_label: 'Link*:',
          link_helper:
            'Informe a URL completa da página de destino. Ao clicar no banner, o usuário será redirecionado para o navegador externo do dispositivo.',
          image_label: 'Imagem*:',
          image_helper: 'Formato: PNG, JPG ou JPEG | Proporção: 4:3 ou 16:9',
          start_at_label: 'Começa em:',
          end_at_label: 'Termina em:',
          partner_switch: 'Vincular à parceiro',
          partner_label: 'Parceiro:',
          partner_placeholder: 'Todos',
          cancel: 'Cancelar',
          create: 'Criar',
          success: 'Banner criado com sucesso!',
          error: 'Não foi possível criar o Banner. Tente novamente.',

          schema: {
            title_required: 'Campo obrigatório',
            size_required: 'Campo obrigatório',
            url_required: 'Campo obrigatório',
            invalid_image: 'Extensão inválida. Utilize .jpg, .jpeg ou .png',
            period_required: 'Selecione o período',
            partner_required: 'Selecione um parceiro',
            image_required: 'Campo obrigatório',
          },
        },

        banner_edit_modal: {
          title: 'Editar banner',
          team_label: 'Time:',
          title_label: 'Título*:',
          title_helper: '(Máx. de caracteres: 100)',
          size_label: 'Tamanho:',
          size_placeholder: 'Nenhum',
          link_label: 'Link*:',
          link_helper:
            'Informe a URL completa da página de destino. Ao clicar no banner, o usuário será redirecionado para o navegador externo do dispositivo.',
          image_label: 'Imagem*:',
          image_helper: 'Formato: PNG, JPG ou JPEG | Proporção: 4:3 ou 16:9',
          start_at_label: 'Começa em:',
          end_at_label: 'Termina em:',
          partner_switch: 'Vincular à parceiro',
          partner_label: 'Parceiro:',
          partner_placeholder: 'Todos',
          cancel: 'Cancelar',
          save: 'Salvar alterações',
          success: 'Banner atualizado com sucesso!',
          error: 'Não foi possível atualizar o Banner. Tente novamente.',

          schema: {
            required_field: 'Campo obrigatório',
            invalid_image: 'Extensão inválida. Utilize .jpg, .jpeg ou .png',
            period_required: 'Selecione o período',
            partner_required: 'Selecione um parceiro',
          },
        },

        filter_box: {
          title: 'Filtros',
          team: 'Time',
          team_select_all: 'Todos',
          title_label: 'Título:',
          partner: 'Parceiro:',
          start_date: 'Data inicial:',
          end_date: 'Data final:',
          all_partners: 'Todos',
          clear: 'Limpar filtros',
        },

        banner_table: {
          created_at: 'DATA DA CRIAÇÃO',
          title: 'TÍTULO',
          team: 'TIME',
          partner_name: 'PARCEIRO',
          period: 'PERÍODO',
          size: 'TAMANHO',
          actions: 'AÇÕES',
          aria_label: 'Mostrar mais ações',
          view_details: 'Editar',
          delete: 'Excluir',
        },
      },

      breadcrumb: {
        label1: 'APLICATIVO',
        label2: 'BANNERS NA HOME',
      },

      banner_title: 'BANNERS NA HOME',
      banner_title_text: 'Banners na Home',
      banner_page_description:
        'Gerencie banners de parceiros e patrocinadores. Utilize este espaço para divulgar produtos, serviços e campanhas comerciais. Ao clicar no banner, o usuário será direcionado para uma página externa através do link configurado.',
      banner_enabled: 'Habilitado',
      banner_disabled: 'Desabilitado',
      banner_add_banner: 'Adicionar banner',
      banner_area_toggled_enable: 'Área de banner habilitada com sucesso',
      banner_area_toggled_disable: 'Área de banner desabilitada com sucesso',
      banner_area_toggle_failed_enable: 'Ocorreu um erro ao habilitar área de banner. Recarregue a página e tente novamente.',
      banner_area_toggle_failed_disable: 'Ocorreu um erro ao desabilitar área de banner. Recarregue a página e tente novamente.',
      banner_delete_success: 'Banner excluído com sucesso!',
      banner_delete_failed: 'Ocorreu um erro ao excluir o banner. Recarregue e tente novamente.',
      banner_not_found: 'Banner não encontrado.',
      banner_delete_title: 'Excluir banner',
      banner_delete_description: 'Tem certeza que deseja excluir o banner "{{title}}"?',
      banner_description_enabled: 'Tem certeza que deseja habilitar os Banners na Home?',
      banner_description_disabled: 'Tem certeza que deseja desabilitar os Banners na Home?',
      banner_enable_action: 'habilitar',
      banner_disable_action: 'desabilitar',
      banner_enabled_action: 'habilitada',
      banner_disabled_action: 'desabilitada',
    },

    application_calendar: {
      breadcrumb: {
        calendar_label1: 'APLICATIVO',
        calendar_label2: 'CALENDÁRIO',
      },

      calendar_title: 'CALENDÁRIO',
      calendar_title_text: 'Calendário',
      calendar_enabled: 'Habilitado',
      calendar_disabled: 'Desabilitado',
      calendar_area_toggled_enable: 'Área de calendário habilitada com sucesso',
      calendar_area_toggled_disable: 'Área de calendário desabilitada com sucesso',
      calendar_area_toggle_failed_enable:
        'Ocorreu um erro ao habilitar área de calendário. Recarregue a página e tente novamente.',
      calendar_area_toggle_failed_disable:
        'Ocorreu um erro ao desabilitar área de calendário. Recarregue a página e tente novamente.',
      calendar_description_enabled:
        'Ao habilitar este componente, todos os componentes associados serão automaticamente habilitados. Deseja continuar?',
      calendar_description_disabled:
        'Ao desabilitar este componente, todos os componentes associados serão automaticamente desabilitados. Deseja continuar?',
      calendar_matches: 'Calendário de Partidas',
      calendar_events: 'Calendário de Eventos',
      calendar_week_schedule: 'Programação da Semana',
      calendar_league: 'Competições',
      calendar_teams: 'Times',
      calendar_enable_action: 'habilitar',
      calendar_disable_action: 'desabilitar',
      calendar_enabled_action: 'habilitada',
      calendar_disabled_action: 'desabilitada',
    },

    application_calendar_events: {
      components: {
        calendar_create_modal: {
          title: 'Criar evento',
          date_label: 'Data:',
          team_label: 'Time:',
          event_name_label: 'Nome do evento*:',
          event_name_helper: '(Máx. de caracteres: 100)',
          place_label: 'Local*:',
          place_helper: '(Máx. de caracteres: 100)',
          display_label: 'Exibir detalhes',
          ticket_link_label: 'Link de compra de ingressos:',
          ticket_link_helper: '(Máx. de caracteres: 255)',
          ticket_link_target_label: 'Abrir link em:',
          ticket_link_target_external: 'Navegador externo',
          ticket_link_target_internal: 'Dentro do app',
          ticket_link_target_partner: 'BaladApp',
          ticket_link_target_helper: 'Define como o app abre o link.',
          ticket_link_target_helper_empty: 'Informe o link acima para escolher onde ele abre.',
          tickets_section_title: 'Ingressos',
          description_label: 'Descrição:',
          description_helper: '(Máx. de caracteres: 1.000)',
          image_label: 'Imagem*:',
          image_helper: 'Formato: PNG, JPG ou JPEG | Proporção: 4:3 ou 16:9',
          cancel: 'Cancelar',
          create: 'Criar',
          success: 'Evento criado com sucesso!',
          error: 'Não foi possível criar o evento. Tente novamente.',

          schema: {
            calendar_events_create_required_field: 'Campo obrigatório',
            calendar_events_create_invalid_file_extension: 'Extensão inválida. Utilize .jpg, .jpeg ou .png',
          },
        },

        calendar_event_edit_modal: {
          title: 'Editar evento',
          date_label: 'Data:',
          team_label: 'Time:',
          event_name_label: 'Nome do evento*:',
          event_name_helper: '(Máx. de caracteres: 100)',
          place_label: 'Local*:',
          place_helper: '(Máx. de caracteres: 100)',
          display_label: 'Exibir detalhes',
          ticket_link_label: 'Link de compra de ingressos:',
          ticket_link_helper: '(Máx. de caracteres: 255)',
          ticket_link_target_label: 'Abrir link em:',
          ticket_link_target_external: 'Navegador externo',
          ticket_link_target_internal: 'Dentro do app',
          ticket_link_target_partner: 'BaladApp',
          ticket_link_target_helper: 'Define como o app abre o link.',
          ticket_link_target_helper_empty: 'Informe o link acima para escolher onde ele abre.',
          tickets_section_title: 'Ingressos',
          description_label: 'Descrição:',
          description_helper: '(Máx. de caracteres: 1.000)',
          image_label: 'Imagem*:',
          image_helper: 'Formato: PNG, JPG ou JPEG | Proporção: 4:3 ou 16:9',
          cancel: 'Cancelar',
          save: 'Salvar alterações',
          success: 'Evento alterado com sucesso!',
          error: 'Não foi possível alterar o evento. Tente novamente.',

          schema: {
            calendar_events_edit_required_field: 'Campo obrigatório',
            calendar_events_edit_invalid_extension: 'Extensão inválida. Utilize .jpg, .jpeg ou .png',
          },
        },

        calendar_events_filter_box: {
          title: 'Filtros',
          team: 'Time',
          team_all: 'Todos',
          event_name: 'Nome do evento:',
          month: 'Mês:',
          start_date: 'Data inicial:',
          end_date: 'Data final:',
          clear_filters: 'Limpar filtros',
          all: 'Todos',
          january: 'Janeiro',
          february: 'Fevereiro',
          march: 'Março',
          april: 'Abril',
          may: 'Maio',
          june: 'Junho',
          july: 'Julho',
          august: 'Agosto',
          september: 'Setembro',
          october: 'Outubro',
          november: 'Novembro',
          december: 'Dezembro',
        },

        calendar_events_table: {
          date: 'DATA',
          team: 'TIME',
          time: 'HORÁRIO',
          place: 'LOCAL',
          event_name: 'NOME DO EVENTO',
          actions: 'Ações',
          view_details: 'Editar',
          delete: 'Excluir',
          menu_button_label: 'Mostrar mais ações',
        },
      },

      breadcrumb: {
        application_calendar_events_label1: 'APLICATIVO',
        application_calendar_events_label2: 'CALENDÁRIO',
        application_calendar_events_label3: 'EVENTOS',
      },

      calendar_events_title: 'CALENDÁRIO DE EVENTOS',
      calendar_events_title_text: 'Calendário de Eventos',
      calendar_events_enabled: 'Habilitado',
      calendar_events_disabled: 'Desabilitado',
      calendar_events_add_event: 'Adicionar evento',
      calendar_events_area_toggled_enable: 'Área de evento habilitada com sucesso',
      calendar_events_area_toggled_disable: 'Área de evento desabilitada com sucesso',
      calendar_events_area_toggle_failed_enable:
        'Ocorreu um erro ao habilitar área de evento. Recarregue a página e tente novamente.',
      calendar_events_area_toggle_failed_disable:
        'Ocorreu um erro ao desabilitar área de evento. Recarregue a página e tente novamente.',
      calendar_events_delete_success: 'Evento deletado com sucesso!',
      calendar_events_delete_failed: 'Ocorreu um erro ao deletar o evento. Recarregue e tente novamente.',
      calendar_events_not_found: 'Evento não encontrado.',
      calendar_events_delete_title: 'Excluir evento',
      calendar_events_delete_description: 'Tem certeza que deseja excluir o evento "{{name}}"?',
      calendar_events_description_enabled: 'Tem certeza que deseja habilitar este componente?',
      calendar_events_description_disabled: 'Tem certeza que deseja desabilitar este componente?',
    },

    application_calendar_matches: {
      components: {
        application_calendar_matches_filter_box: {
          filter_box_title: 'Filtros',
          filter_box_team_label: 'Time:',
          filter_box_league_label: 'Competição:',
          filter_box_match_status_label: 'Situação da partida:',
          filter_box_all_option: 'Todos',
          filter_box_clear_filters_button: 'Limpar filtros',

          date_range_filter_fields: {
            month_label: 'Mês:',
            all_option: 'Todos',
            january: 'Janeiro',
            february: 'Fevereiro',
            march: 'Março',
            april: 'Abril',
            may: 'Maio',
            june: 'Junho',
            july: 'Julho',
            august: 'Agosto',
            september: 'Setembro',
            october: 'Outubro',
            november: 'Novembro',
            december: 'Dezembro',
            start_date_label: 'Data inicial:',
            end_date_label: 'Data final:',
            set_month_button: 'Definir mês',
            set_date_button: 'Definir data',
          },
        },

        match_create_modal: {
          match_create_modal_title: 'Criar nova partida',
          match_create_date_label: 'Data:',
          match_create_league_label: 'Competição*:',
          match_create_league_placeholder: 'Selecione',
          match_create_local_label: 'Local*:',
          match_create_home_team_label: 'Time da casa*:',
          match_create_away_team_label: 'Time de fora*:',
          match_create_hyperlink_label: 'Link para compra de ingressos:',
          match_create_description_label: 'Descrição:',
          match_create_last_matches_label: 'Últimos confrontos',
          match_create_add_match_button: 'Adicionar confronto',
          match_create_delete_match_button_label: 'Deletar confronto',
          match_create_history_label: 'Histórico',
          match_create_wins_label: 'Vitórias',
          match_create_draws_label: 'Empates',
          match_create_losses_label: 'Derrotas',
          match_create_save_draft_button: 'Salvar como rascunho',
          match_create_cancel_button: 'Cancelar',
          match_create_create_button: 'Criar',
          match_create_success_toast_title: 'Partida criada com sucesso!',
          match_create_error_toast_title: 'Não foi possível criar a partida. Tente novamente.',

          schema: {
            required_field_error: 'Campo obrigatório',
            same_team_error: 'Time de fora não pode ser o mesmo time da casa',
            select_team_error: 'Selecione um time',
            last_matches_empty_error: 'Adicione pelo menos um confronto',
          },
        },

        match_edit_modal: {
          match_edit_modal_title: 'Editar partida',
          match_edit_date_label: 'Data:',
          match_edit_league_label: 'Competição*:',
          match_edit_league_placeholder: 'Selecione',
          match_edit_local_label: 'Local*:',
          match_edit_home_team_label: 'Time da casa*:',
          match_edit_away_team_label: 'Time de fora*:',
          match_edit_hyperlink_label: 'Link para compra de ingressos:',
          match_edit_description_label: 'Descrição:',
          match_edit_last_matches_label: 'Últimos confrontos',
          match_edit_add_match_button: 'Adicionar confronto',
          match_edit_delete_match_button_label: 'Deletar confronto',
          match_edit_history_label: 'Histórico',
          match_edit_wins_label: 'Vitórias',
          match_edit_draws_label: 'Empates',
          match_edit_losses_label: 'Derrotas',
          match_edit_cancel_button: 'Cancelar',
          match_edit_save_button: 'Salvar alterações',
          match_edit_success_toast_title: 'Partida alterada com sucesso!',
          match_edit_error_toast_title: 'Não foi possível alterar a partida. Tente novamente.',

          schema: {
            required_field_error: 'Campo obrigatório',
            same_team_error: 'Time de fora não pode ser o mesmo time da casa',
            select_team_error: 'Selecione um time',
            last_matches_empty_error: 'Adicione pelo menos um confronto',
          },
        },

        match_modal: {
          match_modal_create_title: 'Adicionar partida',
          match_modal_edit_title: 'Editar partida',
          match_modal_date_label: 'Data:',
          match_modal_league_label: 'Competição*:',
          match_modal_league_placeholder: 'Selecione',
          match_modal_local_label: 'Local*:',
          match_modal_home_team_label: 'Time da casa*:',
          match_modal_away_team_label: 'Time de fora*:',
          match_modal_ticket_url_label: 'Link para compra de ingressos:',
          match_modal_description_label: 'Descrição:',
          match_modal_last_matches_label: 'Últimos confrontos',
          match_modal_add_match_button: 'Adicionar confronto',
          match_modal_delete_match_button_label: 'Deletar confronto',
          match_modal_history_label: 'Histórico',
          match_modal_wins_label: 'Vitórias',
          match_modal_draws_label: 'Empates',
          match_modal_losses_label: 'Derrotas',
          match_modal_cancel_button: 'Cancelar',
          match_modal_create_button: 'Salvar',
          match_modal_edit_button: 'Salvar alterações',

          schema: {
            required_field_error: 'Campo obrigatório',
            same_team_error: 'Time de fora não pode ser o mesmo time da casa',
            select_team_error: 'Selecione um time',
            last_matches_empty_error: 'Adicione pelo menos um confronto',
          },
        },

        match_table: {
          match_table_date_header: 'DATA',
          match_table_time_header: 'HORÁRIO',
          match_table_league_header: 'COMPETIÇÃO',
          match_table_local_header: 'LOCAL',
          match_table_home_team_header: 'TIME DA CASA',
          match_table_score_header: 'PLACAR',
          match_table_away_team_header: 'TIME VISITANTE',
          match_table_status_header: 'SITUAÇÃO',
          match_table_actions_header: 'AÇÕES',
          match_table_edit_button: 'Editar',
          match_table_save_button: 'Salvar',
          match_table_delete_button_label: 'Excluir',
        },
      },

      breadcrumb: {
        calendar_matches_label1: 'APLICATIVO',
        calendar_matches_label2: 'CALENDÁRIO',
        calendar_matches_label3: 'PARTIDAS',
      },

      page_title: 'CALENDÁRIO DE PARTIDAS',
      section_title: 'Calendário de Partidas',
      app_area_enabled_label: 'Habilitado',
      app_area_disabled_label: 'Desabilitado',
      view_leagues_button: 'Ver competições',
      view_teams_button: 'Ver times',
      add_match_button: 'Adicionar partida',
      app_area_enable_success_toast: 'Área de calendário de partidas habilitada com sucesso',
      app_area_disable_success_toast: 'Área de calendário de partidas desabilitada com sucesso',
      app_area_enable_error_toast:
        'Ocorreu um erro ao habilitar área de calendário de partidas. Recarregue a página e tente novamente.',
      app_area_disable_error_toast:
        'Ocorreu um erro ao desabilitar área de calendário de partidas. Recarregue a página e tente novamente.',
      quick_save_success_toast: 'Alterações na partida salvas com sucesso!',
      quick_save_error_toast: 'Houve um erro ao salvar as alterações na partida. Recarregue e tente novamente.',
      delete_match_success_toast: 'Partida deletada com sucesso!',
      delete_match_error_toast: 'Ocorreu um erro ao deletar a partida. Tente novamente.',
      edit_match_invalid_uuid_toast: 'UUID inválido. Não foi possível buscar a partida.',
      edit_match_not_found_toast: 'Partida não encontrada.',
      delete_match_modal_title: 'Excluir partida',
      delete_match_modal_description: 'Tem certeza que deseja excluir a partida do dia',
      delete_match_modal_as: 'às',
      delete_match_modal_entre: 'entre',
      delete_match_modal_e: 'e',
      app_area_confirm_modal_title: 'Calendário de Partidas',
      app_area_confirm_modal_description_enable: 'Tem certeza que deseja habilitar este componente?',
      app_area_confirm_modal_description_disable: 'Tem certeza que deseja desabilitar este componente?',
    },

    application_calendar_week: {
      components: {
        week_schedule_header: {
          weekday: 'DIA DA SEMANA',
          description: 'DESCRIÇÃO',
          actions: 'AÇÕES',
        },

        new_item_table_row: {
          select_placeholder: 'Selecione',
          sunday: 'Domingo',
          monday: 'Segunda-Feira',
          tuesday: 'Terça-Feira',
          wednesday: 'Quarta-Feira',
          thursday: 'Quinta-Feira',
          friday: 'Sexta-Feira',
          saturday: 'Sábado',
          save_button: 'Salvar',
          delete_aria_label: 'Deletar',
        },

        table_row: {
          save_button: 'Salvar',
          delete_aria_label: 'Deletar',
        },
      },

      breadcrumb: {
        label1: 'APLICATIVO',
        label2: 'CALENDÁRIO',
        label3: 'PROGRAMAÇÃO DA SEMANA',
      },
      title: 'PROGRAMAÇÃO DA SEMANA',
      section_title: 'Programação da Semana',
      enabled: 'Habilitado',
      disabled: 'Desabilitado',
      label: 'Adicionar programação',
      save_success: 'Programação salva com sucesso!',
      delete_success: 'Programação excluída com sucesso!',
      area_enabled: 'Área de programação da semana habilitada com sucesso',
      area_disabled: 'Área de programação da semana desabilitada com sucesso',
      validation_error: 'Preencha todos os campos da programação',
      save_error: 'Ocorreu um erro ao salvar programação. Recarregue e tente novamente.',
      delete_error: 'Ocorreu um erro ao excluir programação. Recarregue e tente novamente.',
      title_delete: 'Excluir programação',
      description: 'Tem certeza que deseja excluir a programação?',
      title_label: 'Programação da Semana',
      description_enabled: 'Tem certeza que deseja habilitar este componente?',
      description_disabled: 'Tem certeza que deseja desabilitar este componente?',
    },

    application_card: {
      schema: {
        required_field: 'Campo obrigatório',
        select_image: 'Selecione uma imagem',
        select_color: 'Selecione uma cor',
      },

      breadcrumb: {
        card_label1: 'APLICATIVO',
        card_label2: 'CARTEIRINHA',
      },

      card_title: 'CARTEIRINHA DIGITAL',
      card_label: 'Carteirinha Digital',
      card_enabled: 'Habilitado',
      card_disabled: 'Desabilitado',
      card_title_card: 'Fundo da carteirinha',
      card_label_image: 'Imagem',
      card_color: 'Cor',
      card_image: 'Imagem',
      card_text: 'Proporção: 16:9 | Formato: PNG ou JPG',
      card_label_color: 'Cor (Hexadecimal)',
      card_icon: 'Ícone da carteirinha',
      card_found: 'Imagem (fundo transparente)',
      card_label_format: 'Formato: SVG | Dimensões: 1024 x 1024 px',
      card_card_title: 'Título da carteirinha',
      card_subtitle: 'Expressão referente aos usuários',
      card_label_user: 'Usuários comuns',
      card_helper_text: '(30 caracteres)',
      card_label_as: 'Assinantes',
      card_caracters: '(30 caracteres)',
      card_back: 'Voltar',
      card_save: 'Salvar alterações',
      card_digital: 'Carteirinha Digital',
      card_confirm_modal: 'Tem certeza que deseja habilitar este componente?',
      card_confirm_modal_edit: 'Tem certeza que deseja desabilitar este componente?',
      card_enable_action: 'habilitar',
      card_disable_action: 'desabilitar',
      card_enable_success: 'Carteirinha digital habilitada com sucesso',
      card_enable_error: 'Ocorreu um erro ao habilitar carteirinha digital. Recarregue a página e tente novamente',
      card_disable_success: 'Carteirinha digital desabilitada com sucesso',
      card_disable_error: 'Ocorreu um erro ao desabilitar carteirinha digital. Recarregue a página e tente novamente',
      card_save_success: 'Carteirinha salva com sucesso!',
      card_save_error: 'Não foi possível salvar a carteirinha. Tente novamente.',
    },

    application_category_video: {
      componnets: {
        category_video_create_modal: {
          category_modal_title: 'Adicionar categoria',
          category_modal_title_label: 'Título*:',
          category_modal_title_helper_text: '(Máx. de caracteres: 100)',
          category_modal_cancel: 'Cancelar',
          category_modal_create: 'Criar',
          category_modal_success: 'Categoria criada com sucesso!',
          category_modal_error: 'Não foi possível criar a categoria. Tente novamente.',

          schema: {
            required: 'Campo obrigatório',
          },
        },

        category_video_edit_modal: {
          category_edit_title: 'Editar categoria',
          category_edit_title_label: 'Título*:',
          category_edit_title_helper_text: '(Máx. de caracteres: 100)',
          category_edit_cancel: 'Cancelar',
          category_edit_save: 'Salvar alterações',
          category_edit_success: 'Categoria alterada com sucesso!',
          category_edit_error: 'Não foi possível alterar a categoria. Tente novamente.',

          schema: {
            required: 'Campo obrigatório',
          },
        },

        category_video_filter_box: {
          filter_title: 'Filtros',
          title_label: 'Título:',
          start_date_label: 'Data inicial:',
          end_date_label: 'Data final:',
          clear_filters_button: 'Limpar filtros',
        },

        category_video_table: {
          category_table_creation_date: 'DATA DA CRIAÇÃO',
          category_table_title: 'TÍTULO',
          category_table_actions: 'AÇÕES',
          category_table_view_details: 'Editar',
          category_table_delete: 'Excluir',
          category_table_actions_menu: 'Mostrar mais ações',
        },
      },
      breadcrumb: {
        category_video_label1: 'APLICATIVO',
        category_video_label2: 'CANAL DE VÍDEOS',
        category_video_label3: 'CATEGORIAS',
      },

      category_video_page_title: 'CATEGORIAS',
      category_video_section_title: 'Categorias',
      category_video_add_button: 'Adicionar categoria',
      category_video_title: 'Excluir categoria',
      category_video_description: 'Tem certeza que deseja excluir a categoria',
      category_video_toast_success: 'Categoria deletada com sucesso!',
      category_video_toast_error: 'Ocorreu um erro ao deletar a categoria. Tente novamente.',
      category_video_edit_toast_error: 'Categoria não encontrada.',
    },

    application_championship: {
      application_championship_toggled_enable: 'Área de competições habilitada com sucesso',
      application_championship_toggled_disable: 'Área de competições desabilitada com sucesso',
      application_championship_toggle_failed_enable:
        'Ocorreu um erro ao habilitar área de competições. Recarregue a página e tente novamente.',
      application_championship_toggle_failed_disable:
        'Ocorreu um erro ao desabilitar área de competições. Recarregue a página e tente novamente.',
      application_championship_title: 'Competições',
      application_championship_enabled: 'Habilitado',
      application_championship_disabled: 'Desabilitado',

      application_championship_description_enabled:
        'Ao habilitar este componente, todos os componentes associados serão automaticamente habilitados. Deseja continuar?',
      application_championship_description_disabled:
        'Ao desabilitar este componente, todos os componentes associados serão automaticamente desabilitados. Deseja continuar?',

      application_championship_link_competitions: 'Competições',
      application_championship_link_seasons: 'Temporadas',
      application_championship_link_teams: 'Times',
      application_championship_link_game_tables: 'Tabelas de Jogos',
      application_championship_link_standings_tables: 'Tabelas de Classificação',

      breadcrumb: {
        championship_label1: 'Aplicação',
        championship_label2: 'Competições',
        championship_label3: 'Competições',
      },
      components: {
        championship: {
          application_championship_title: 'Competições',
          application_championship_label: 'Competições',
          application_championship_add_button: 'Criar nova competição',
          application_championship_delete_success: 'Competição excluída com sucesso.',
          application_championship_delete_error: 'Não foi possível excluir a competição. Tente novamente.',
          application_championship_delete_confirm_title: 'Excluir competição',
          application_championship_delete_confirm_description_start: 'Tem certeza de que deseja excluir a competição ',
          application_championship_delete_confirm_description_end: '? Essa ação não poderá ser desfeita.',
        },
        championship_filter_box: {
          championship_filter_box_title: 'Filtros',
          championship_filter_box_name: 'Competição',
          championship_filter_box_start_date_label: 'Data inicial:',
          championship_filter_box_end_date_label: 'Data final:',
          championship_filter_box_is_active: 'Situação',
          championship_filter_box_is_filtered: 'Exibir em tabelas',
          championship_filter_box_all: 'Todos',
          championship_filter_box_active: 'Ativos',
          championship_filter_box_inactive: 'Desativados',
          championship_filter_box_filtered: 'Sim',
          championship_filter_box_not_filtered: 'Não',
          championship_filter_box_clear: 'Limpar filtros',
        },
        championship_table: {
          championship_table_created_at: 'Data da criação',
          championship_table_name: 'Competição',
          championship_table_is_filtered: 'Exibir em tabelas',
          championship_table_is_filtered_yes: 'Sim',
          championship_table_is_filtered_no: 'Não',
          championship_table_is_active: 'Situação',
          championship_table_is_active_yes: 'Ativo',
          championship_table_is_active_no: 'Desativado',
          championship_table_actions: 'Ações',
          championship_table_show_more_actions: 'Mostrar mais ações',
          championship_table_view_details: 'Ver detalhes',
          championship_table_delete: 'Excluir',
        },
        championship_create_modal: {
          championship_create_title: 'Cadastrar competição',
          championship_create_name: 'Nome*:',
          championship_create_name_limits: 'Máximo de 100 caracteres.',
          championship_create_is_active_label: 'Competição ativa',
          championship_create_is_active_helper: 'Se desativado, a competição não ficará disponível no aplicativo.',
          championship_create_is_filtered_label: 'Destacar na listagem',
          championship_create_is_filtered_helper: 'Exibir no menu Tabelas do aplicativo.',
          championship_create_cancel: 'Cancelar',
          championship_create_create: 'Criar competição',
          championship_create_success: 'Competição criada com sucesso.',
          championship_create_error: 'Não foi possível criar a competição. Tente novamente.',
        },
        championship_edit_modal: {
          championship_edit_title: 'Editar competição',
          championship_edit_name: 'Nome da competição',
          championship_edit_name_limits: 'Máximo de 100 caracteres.',
          championship_edit_is_active_label: 'Competição ativa',
          championship_edit_is_active_helper: 'Se desativado, a competição não ficará disponível no aplicativo.',
          championship_edit_is_filtered_label: 'Destacar na listagem',
          championship_edit_is_filtered_helper: 'Exibir no menu Tabelas do aplicativo.',
          championship_edit_cancel: 'Cancelar',
          championship_edit_save: 'Salvar alterações',
          championship_edit_success: 'Competição atualizado com sucesso.',
          championship_edit_error: 'Não foi possível atualizar a competição. Tente novamente.',
        },
        schema: {
          championship_create_schema_required: 'Campo obrigatório.',
          championship_edit_schema_required: 'Campo obrigatório.',
        },
      },
    },

    application_championship_matches: {
      page_title: 'Partidas',
      create_button: 'Adicionar partida',
      current_round_button: 'Rodada atual',
      current_stage_button: 'Fase atual',
      breadcrumb: {
        label1: 'Aplicação',
        label2: 'Competições',
        label3: 'Partidas',
      },
      toasts: {
        missing_stage: 'Esta partida não tem uma fase associada.',
        inline_save_success: 'Partida atualizada.',
        inline_save_error: 'Não foi possível atualizar a partida.',
        delete_success: 'Partida excluída com sucesso.',
        delete_error: 'Não foi possível excluir a partida.',
      },
      delete_modal: {
        title: 'Excluir partida',
        description: 'Tem certeza que deseja excluir a partida',
      },
      components: {
        matches_filter_box: {
          heading: 'Filtros',
          championship_label: 'Campeonato',
          season_label: 'Temporada',
          stage_label: 'Fase',
          round_label: 'Rodada',
          team_label: 'Time',
          status_label: 'Situação',
          start_date_label: 'Data inicial',
          end_date_label: 'Data final',
          all_option: 'Todos',
          clear_button: 'Limpar filtros',
          season_type_hybrid: 'Híbrido',
          season_type_knockout: 'Mata-mata',
          season_type_league: 'Liga',
          status_scheduled: 'Agendada',
          status_running: 'Em andamento',
          status_finished: 'Finalizada',
          status_postponed: 'Adiada',
          status_canceled: 'Cancelada',
          status_suspended: 'Suspensa',
          status_draft: 'Rascunho',
        },
        matches_table: {
          col_competition: 'Competição',
          col_round: 'Rodada',
          col_date: 'Data / Hora',
          col_match: 'Confronto',
          col_status: 'Situação',
          col_actions: 'Ações',
          action_edit: 'Editar detalhes',
          action_delete: 'Excluir',
          menu_aria_label: 'Ações da partida',
        },
        match_create_modal: {
          title: 'Adicionar partida',
          field_championship: 'Campeonato',
          field_season: 'Temporada',
          field_stage: 'Fase',
          field_home_team: 'Mandante',
          field_away_team: 'Visitante',
          field_date: 'Data / Hora',
          field_home_goals: 'Gols (mandante)',
          field_away_goals: 'Gols (visitante)',
          field_round: 'Rodada',
          field_stadium: 'Estádio',
          field_transmission: 'Transmissão',
          field_hyperlink: 'Link para compra de ingressos',
          field_hyperlink_target: 'Abrir link em',
          tickets_section_title: 'Ingressos',
          hyperlink_target_external: 'Navegador externo',
          hyperlink_target_internal: 'Dentro do app',
          hyperlink_target_partner: 'BaladApp',
          hyperlink_target_helper:
            'Navegador externo abre fora do app. Dentro do app abre em uma tela interna. BaladApp abre na área do parceiro, já com o usuário logado.',
          hyperlink_target_helper_empty: 'Informe o link acima para escolher onde ele abre.',
          field_description: 'Descrição',
          field_extra_time_home: 'Prorrogação (mandante)',
          field_extra_time_away: 'Prorrogação (visitante)',
          field_penalties_home: 'Pênaltis (mandante)',
          field_penalties_away: 'Pênaltis (visitante)',
          field_is_show_information: 'Exibir informações desta partida na UI',
          placeholder_select: 'Selecione...',
          placeholder_team: 'Selecione um time',
          season_type_hybrid: 'Híbrido',
          season_type_knockout: 'Mata-mata',
          season_type_league: 'Liga',
          last_matches_label: 'Histórico de confrontos',
          add_last_match_button: 'Adicionar confronto',
          remove_last_match_aria: 'Remover confronto',
          history_matches_label: 'Histórico de vitórias / empates / derrotas',
          wins_label: 'Vitórias',
          draw_label: 'Empates',
          lose_label: 'Derrotas',
          cancel_button: 'Cancelar',
          save_draft_button: 'Salvar como rascunho',
          create_button: 'Criar partida',
          errors: {
            missing_stage: 'Selecione uma fase.',
            missing_teams: 'Selecione o mandante e o visitante.',
            same_team: 'Mandante e visitante precisam ser diferentes.',
          },
          toasts: {
            create_success: 'Partida criada com sucesso.',
            create_error: 'Não foi possível criar a partida.',
          },
        },

        match_edit_modal: {
          title: 'Editar partida',
          field_home_team: 'Mandante',
          field_away_team: 'Visitante',
          field_date: 'Data / Hora',
          field_status: 'Situação',
          field_home_goals: 'Gols (mandante)',
          field_away_goals: 'Gols (visitante)',
          field_round: 'Rodada',
          field_stadium: 'Estádio',
          field_transmission: 'Transmissão',
          field_hyperlink: 'Link para compra de ingressos',
          field_hyperlink_target: 'Abrir link em',
          tickets_section_title: 'Ingressos',
          hyperlink_target_external: 'Navegador externo',
          hyperlink_target_internal: 'Dentro do app',
          hyperlink_target_partner: 'BaladApp',
          hyperlink_target_helper:
            'Navegador externo abre fora do app. Dentro do app abre em uma tela interna. BaladApp abre na área do parceiro, já com o usuário logado.',
          hyperlink_target_helper_empty: 'Informe o link acima para escolher onde ele abre.',
          field_description: 'Descrição',
          field_extra_time_home: 'Prorrogação (mandante)',
          field_extra_time_away: 'Prorrogação (visitante)',
          field_penalties_home: 'Pênaltis (mandante)',
          field_penalties_away: 'Pênaltis (visitante)',
          field_is_show_information: 'Exibir informações desta partida na UI',
          placeholder_team: 'Selecione um time',
          last_matches_label: 'Histórico de confrontos',
          add_last_match_button: 'Adicionar confronto',
          remove_last_match_aria: 'Remover confronto',
          history_matches_label: 'Histórico de vitórias / empates / derrotas',
          wins_label: 'Vitórias',
          draw_label: 'Empates',
          lose_label: 'Derrotas',
          cancel_button: 'Cancelar',
          save_button: 'Salvar',
          errors: {
            missing_stage: 'Esta partida não tem uma fase associada.',
            missing_teams: 'Selecione o mandante e o visitante.',
            same_team: 'Mandante e visitante precisam ser diferentes.',
          },
          toasts: {
            update_success: 'Detalhes salvos com sucesso.',
            update_error: 'Não foi possível salvar os detalhes da partida.',
          },
        },

        match_generate_modal: {
          title: 'Gerar partidas automaticamente',
          field_championship: 'Campeonato',
          field_season: 'Temporada',
          field_stage: 'Fase',
          field_format: 'Formato dos confrontos',
          field_start_date: 'Data do primeiro jogo',
          field_interval: 'Intervalo entre rodadas (dias)',
          field_replace_existing: 'Substituir jogos existentes nesta fase',
          placeholder_select: 'Selecione...',
          format_single: 'Turno único · cada par joga 1x',
          format_double: 'Turno e returno · ida e volta',
          format_single_label: 'turno único',
          format_double_label: 'turno e returno',
          preview_placeholder: 'Selecione uma fase para visualizar a simulação.',
          preview_loading: 'Carregando times…',
          preview_not_enough_teams: 'A fase precisa de pelo menos 2 times.',
          preview_odd_teams:
            'A fase tem {{count}} times (ímpar). A geração automática requer quantidade par.',
          preview_summary:
            '{{stageName}} com {{teamCount}} times · {{formatLabel}} · {{matchesCount}} jogos em {{roundsCount}} rodadas.',
          cancel_button: 'Cancelar',
          confirm_button: 'Gerar jogos',
          confirm_button_matches: 'Gerar {{count}} jogos',
          schema: {
            required_stage: 'Selecione uma fase.',
            required_format: 'Selecione o formato dos confrontos.',
            required_date: 'Informe a data do primeiro jogo (formato AAAA-MM-DD).',
            invalid_interval: 'O intervalo deve ser um número inteiro maior que zero.',
          },
          toasts: {
            create_success_one: '{{count}} partida gerada com sucesso!',
            create_success_other: '{{count}} partidas geradas com sucesso!',
            create_error: 'Erro ao gerar partidas.',
          },
        },

        match_current_round_modal: {
          title: 'Definir rodada atual',
          description: 'Escolha a fase e informe qual rodada o app deve exibir como atual.',
          field_championship: 'Campeonato',
          field_season: 'Temporada',
          field_stage: 'Fase',
          field_round: 'Rodada atual',
          field_round_placeholder: 'Ex.: 5',
          current_value: 'Rodada atual gravada: {{round}}.',
          current_value_empty: 'Nenhuma rodada atual definida para esta fase.',
          helper: 'Deixe em branco para não destacar nenhuma rodada.',
          placeholder_select: 'Selecione...',
          season_type_hybrid: 'Híbrido',
          season_type_knockout: 'Mata-mata',
          season_type_league: 'Liga',
          cancel_button: 'Cancelar',
          save_button: 'Salvar',
          toasts: {
            save_success: 'Rodada atual atualizada.',
            save_error: 'Não foi possível atualizar a rodada atual.',
            invalid_round: 'A rodada deve ser um número inteiro maior que zero.',
          },
        },

        match_current_stage_modal: {
          title: 'Definir fase atual',
          description: 'Escolha a temporada e qual fase o app deve destacar como atual (ex.: fase de grupos, oitavas).',
          field_championship: 'Campeonato',
          field_season: 'Temporada',
          field_stage: 'Fase atual',
          current_value: 'Fase atual gravada: {{stage}}.',
          current_value_empty: 'Nenhuma fase atual definida para esta temporada.',
          placeholder_select: 'Selecione...',
          season_type_hybrid: 'Híbrido',
          season_type_knockout: 'Mata-mata',
          season_type_league: 'Liga',
          cancel_button: 'Cancelar',
          save_button: 'Salvar',
          toasts: {
            save_success: 'Fase atual atualizada.',
            save_error: 'Não foi possível atualizar a fase atual.',
          },
        },
      },
      section_label: 'Partidas',
      switch_enabled: 'Habilitado',
      switch_disabled: 'Desabilitado',
      enable_success: 'Tabela de jogos habilitada com sucesso',
      disable_success: 'Tabela de jogos desabilitada com sucesso',
      enable_error: 'Ocorreu um erro ao habilitar. Recarregue a página e tente novamente.',
      disable_error: 'Ocorreu um erro ao desabilitar. Recarregue a página e tente novamente.',
      toggle_modal_title: 'Tabela de Jogos',
      enable_modal_description: 'Tem certeza que deseja habilitar este componente?',
      disable_modal_description: 'Tem certeza que deseja desabilitar este componente?',
    },

    application_championship_stage_standings: {
      page_title: 'Classificações',
      section_title: 'Classificação',
      breadcrumb: {
        label1: 'Aplicação',
        label2: 'Competições',
        label3: 'Classificações',
      },
      header_actions: {
        add_team: 'Adicionar time',
        disabled_no_stage: 'Selecione uma fase de Liga ou Grupo primeiro.',
        disabled_knockout: 'Fases mata-mata não possuem tabela.',
        disabled_in_progress: 'Termine de cadastrar o time atual antes de adicionar outro.',
        disabled_no_eligible: 'Nenhum time elegível disponível nesta fase.',
      },
      filter_box: {
        championship_label: 'Campeonato',
        season_label: 'Temporada',
        stage_label: 'Fase',
        placeholder_select: 'Selecione',
        clear_filters: 'Limpar filtros',
        stage_knockout_suffix: '(mata-mata — sem tabela)',
      },
      context_banner: {
        team_count_one: '{{count}} time participante',
        team_count_other: '{{count}} times participantes',
        knockout_suffix: 'fase eliminatória não possui tabela',
        badge: {
          league: 'LIGA',
          group: 'GRUPO',
          knockout: 'MATA-MATA',
        },
      },
      empty_state: {
        'select-stage': {
          title: 'Selecione uma fase',
          description:
            'Escolha campeonato, temporada e fase nos filtros acima para visualizar a tabela de classificação.',
        },
        knockout: {
          title: 'Esta fase não tem tabela de classificação',
          description:
            'Apenas fases do tipo Grupo ou Liga possuem classificação. Mata-matas são definidos por confrontos diretos.',
        },
        'no-standings': {
          title: 'Nenhum time na tabela ainda',
          description:
            'Use o botão "Adicionar time" para incluir o primeiro time na tabela desta fase.',
        },
      },
      legend: {
        title: 'Legenda da posição:',
        direct: 'Direta',
        playoff: 'Repescagem',
        secondary: 'Secundária',
        relegation: 'Rebaixamento',
        computed_hint: 'Colunas em cinza: calculadas',
      },
      table: {
        editing_hint:
          'Arraste pelo handle para reordenar · Pontos, V, E, D, GP, GC são editáveis · J, SG e Aprov. % calculam sozinho',
        col_pos: 'Pos',
        col_team: 'Time',
        col_points: 'P',
        col_played: 'J',
        col_wins: 'V',
        col_draws: 'E',
        col_losses: 'D',
        col_goals_for: 'GP',
        col_goals_against: 'GC',
        col_goal_diff: 'SG',
        col_win_rate: 'Aprov. %',
        col_actions: 'Ações',
      },
      row_actions: {
        save: 'Salvar',
        cancel: 'Cancelar',
        edit: 'Editar',
        delete: 'Excluir',
      },
      add_row: {
        select_team_placeholder: 'Selecione um time…',
      },
      toasts: {
        update_success: 'Linha atualizada com sucesso.',
        update_error: 'Não foi possível atualizar a linha.',
        delete_success: 'Time removido da tabela.',
        delete_error: 'Não foi possível remover o time.',
        add_success: 'Time adicionado à tabela.',
        add_error: 'Não foi possível adicionar o time.',
        reorder_error: 'Não foi possível reordenar a tabela.',
      },
      delete_modal: {
        title: 'Remover time da tabela',
        description_start: 'Tem certeza que deseja remover o time',
        description_end: ' da tabela desta fase? Essa ação não pode ser desfeita.',
      },
      switch_enabled: 'Habilitado',
      switch_disabled: 'Desabilitado',
      enable_success: 'Tabela de classificação habilitada com sucesso',
      disable_success: 'Tabela de classificação desabilitada com sucesso',
      enable_error: 'Ocorreu um erro ao habilitar. Recarregue a página e tente novamente.',
      disable_error: 'Ocorreu um erro ao desabilitar. Recarregue a página e tente novamente.',
      toggle_modal_title: 'Tabela de Classificação',
      enable_modal_description: 'Tem certeza que deseja habilitar este componente?',
      disable_modal_description: 'Tem certeza que deseja desabilitar este componente?',
    },

    application_season: {
      breadcrumb: {
        seasons_label1: 'Aplicação',
        seasons_label2: 'Competições',
        seasons_label3: 'Temporadas',
        seasons_label4: 'Criar temporada',
        seasons_label5: 'Editar temporada',
      },

      seasons: {
        application_seasons_title: 'Temporadas',
        application_seasons_label: 'Temporadas',
        application_seasons_add_button: 'Adicionar nova temporada',

        application_seasons_delete_success: 'Temporada excluída com sucesso.',
        application_seasons_delete_error: 'Não foi possível excluir a temporada. Tente novamente.',

        application_seasons_delete_confirm_title: 'Excluir temporada',
        application_seasons_delete_confirm_description_start: 'Tem certeza de que deseja excluir a temporada ',
        application_seasons_delete_confirm_description_end: '? Essa ação não poderá ser desfeita.',
      },

      components: {
        season_filter_box: {
          season_filter_box_title: 'Filtros',

          season_filter_box_championship_name: 'Competição',
          season_filter_box_year: 'Temporada',
          season_filter_box_type: 'Formato',
          season_filter_box_all: 'Todos',

          season_filter_box_type_league: 'Pontos corridos',
          season_filter_box_type_knockout: 'Mata-mata',
          season_filter_box_type_hybrid: 'Híbrido',

          season_filter_box_is_active: 'Situação',
          season_filter_box_active: 'Ativas',
          season_filter_box_inactive: 'Inativas',

          season_filter_box_is_filtered: 'Exibir em tabelas',
          season_filter_box_filtered: 'Filtradas',
          season_filter_box_not_filtered: 'Não filtradas',

          season_filter_box_start_date_label: 'Data inicial',
          season_filter_box_end_date_label: 'Data final',

          season_filter_box_clear: 'Limpar filtros',
        },

        seasons_table: {
          seasons_table_created_at: 'Data da criação',
          seasons_table_championship: 'Competição',
          seasons_table_acronym: 'Sigla',
          seasons_table_year: 'Temporada',
          seasons_table_type: 'Formato',

          seasons_table_type_league: 'Liga',
          seasons_table_type_knockout: 'Eliminatória',
          seasons_table_type_hybrid: 'Híbrido',

          seasons_table_show_in_tables: 'Exibir em tabelas',
          seasons_table_show_in_tables_yes: 'Sim',
          seasons_table_show_in_tables_no: 'Não',

          seasons_table_status: 'Situação',
          seasons_table_status_active: 'Ativo',
          seasons_table_status_inactive: 'Desativado',

          seasons_table_actions: 'Ações',
          seasons_table_show_more_actions: 'Mostrar mais ações',
          seasons_table_view_details: 'Ver detalhes',
          seasons_table_delete: 'Excluir',
        },

        season_wizard: {
          tabs: {
            tab_info: 'Informações',
            tab_stages: 'Fases',
            tab_teams: 'Times',
            tab_review: 'Confirmar',
          },
          footer: {
            back: 'Voltar',
            cancel: 'Cancelar',
            next: 'Salvar e continuar',
            review: 'Revisar',
            create: 'Criar temporada',
            close: 'Concluir',
          },
        },

        season_create: {
          page_title: 'Adicionar temporada',
        },

        season_edit: {
          page_title: 'Editar temporada',
          toasts: {
            edit_success: 'Temporada atualizada com sucesso!',
            rename_error: 'Não foi possível salvar as alterações de nome. Tente novamente.',
          },
          errors: {
            load_failed: 'Não foi possível carregar os dados da temporada. Tente novamente.',
          },
        },

        stage_type: {
          league: 'Fase única',
          group: 'Fase de grupos',
          knockout: 'Mata-mata',
        },

        season_step1: {
          title: 'Informações da temporada',
          fields: {
            championship: {
              label: 'Competição',
              placeholder: 'Selecione uma competição',
              help: 'Escolha o campeonato ao qual esta temporada pertence.',
            },
            year: {
              label: 'Ano',
              placeholder: 'Ex: 2025',
              help: 'Ano com 4 dígitos.',
            },
            format: {
              label: 'Formato da competição',
              locked_callout:
                'Esta temporada já tem fases cadastradas. Para mudar o formato é necessário excluir e recriar a temporada.',
              league: {
                label: 'Pontos corridos',
                help: 'Todos se enfrentam em turno ou turno e returno, com tabela de classificação. Fase única gerada automaticamente.',
              },
              cup: {
                label: 'Mata-mata',
                help: 'Eliminatórias em jogos de ida e volta ou jogo único. Você define as fases (oitavas, quartas, etc.) na próxima etapa.',
              },
              hybrid: {
                label: 'Híbrido',
                help: 'Combina fase de grupos com fase eliminatória. Os grupos são gerados automaticamente.',
              },
            },
            groups_count: {
              label: 'Quantidade de grupos',
            },
          },
          schema: {
            groups_min: 'Informe ao menos {{min}} grupos.',
          },
          toasts: {
            missing_season_id: 'Não foi possível identificar a temporada para edição.',
            create_error: 'Não foi possível criar a temporada. Tente novamente.',
            update_error: 'Não foi possível atualizar a temporada. Tente novamente.',
          },
          standings_columns: {
            title: 'Exibir na tabela de classificação',
            help: 'Escolha quais colunas aparecem na tabela de classificação no app. Posição e nome do time são sempre exibidos.',
            points: 'Pontos (P)',
            played: 'Jogos (J)',
            wins: 'Vitórias (V)',
            draws: 'Empates (E)',
            losses: 'Derrotas (D)',
            goals_for: 'Gols pró (GP)',
            goals_against: 'Gols contra (GC)',
            goal_diff: 'Saldo de gols (SG)',
            min_one: 'Selecione ao menos uma coluna para exibir na tabela de classificação.',
          },
        },

        season_step2: {
          title: 'Fases',
          callouts: {
            league_prefix: 'Pontos corridos:',
            league_text:
              'uma fase única foi gerada automaticamente. Não é necessária nenhuma configuração adicional.',
            knockout_prefix: 'Mata-mata:',
            knockout_text:
              'defina as fases eliminatórias desta temporada. Cada campeonato tem sua estrutura — adicione apenas as fases que existem nesta competição.',
            hybrid_prefix: 'Híbrido:',
            hybrid_text:
              'os grupos foram gerados automaticamente com base na sua configuração. Defina abaixo as fases eliminatórias deste campeonato.',
          },
          league: {
            stage_box_title: 'FASE QUE SERÁ CRIADA',
            single_stage_label: 'Fase única',
          },
          groups: {
            box_title: 'FASES DE GRUPO · GERADAS AUTOMATICAMENTE',
          },
          knockout: {
            elimination_title: 'Fases eliminatórias',
            elimination_help: 'Defina quais fases de mata-mata acontecem após a fase de grupos.',
          },
          actions: {
            add_stage: 'Adicionar fase',
            add_elimination_stage: 'Adicionar fase eliminatória',
            remove_stage: 'Remover fase',
            reorder_stage: 'Reordenar fase',
            stage_name_placeholder: 'Nome da fase',
          },
          default_stage_names: {
            round_of_16: 'Oitavas de final',
            quarterfinals: 'Quartas de final',
            semifinals: 'Semifinal',
            final: 'Final',
          },
          group_default_name: 'Grupo {{letter}}',
          qualifiers: {
            section_title: 'Zonas de classificação',
            section_help:
              'Informe quantos times de cada zona desta fase. Coloque 0 onde não houver zona — as posições do meio ficam sem cor.',
            section_title_group: 'Zonas de classificação por grupo',
            section_help_group:
              'Configure os cutoffs separadamente para cada grupo. Em campeonatos onde os grupos seguem a mesma regra, repita os mesmos valores.',
            apply_labels_to_all_groups: 'Aplicar nomes do 1º grupo a todos',
            direct: {
              label: 'Direta',
              help:
                'Top N posições com classificação direta para o torneio principal (ex.: Libertadores, Champions League).',
            },
            playoff: {
              label: 'Repescagem',
              help:
                'Próximas posições em repescagem ou pré-classificação do torneio principal (ex.: Pré-Libertadores, playoff da Champions).',
            },
            secondary: {
              label: 'Secundária',
              help:
                'Próximas posições com classificação direta para o torneio secundário (ex.: Sul-Americana, Europa League, Conference League).',
            },
            relegated: {
              label: 'Rebaixamento',
              help: 'Últimas K posições rebaixadas ao final da fase.',
            },
            cheat_sheet: {
              title: 'Como preencher (exemplos)',
              brasileirao_a: 'Brasileirão Série A (20 times):',
              brasileirao_a_help:
                'Direta = 4 (Libertadores), Repescagem = 2 (Pré-Liber), Secundária = 6 (Sul-Americana), Rebaixamento = 4.',
              la_liga: 'La Liga / Premier League (20 times):',
              la_liga_help:
                'Direta = 4 (Champions), Repescagem = 0, Secundária = 3 (Europa + Conference), Rebaixamento = 3.',
              no_zone: 'Posições "sem zona":',
              no_zone_help:
                'O que sobrar no meio (entre o último playoff/secundária e o primeiro rebaixado) fica neutro, sem cor — como o 13º ao 16º do Brasileirão.',
            },
          },
          schema: {
            stages_required: 'Adicione ao menos uma fase.',
            groups_required: 'É necessário ao menos um grupo.',
            elimination_required: 'Adicione ao menos uma fase eliminatória.',
            qualifiers_overflow:
              'A soma de direta + repescagem + secundária + rebaixamento ultrapassa o número de times.',
          },
        },

        season_step3_teams: {
          title: 'Times participantes',
          callout: 'Busque e selecione os times da temporada. Depois, distribua-os nos grupos.',
          search: {
            title: 'Buscar times',
            placeholder: 'Buscar por nome ou sigla…',
            total: '{{count}} cadastrados',
            empty: 'Nenhum time encontrado.',
            loading: 'Buscando…',
          },
          selected: {
            title: 'Times selecionados',
            empty_title: 'Nenhum time selecionado',
            empty_help: 'Use a busca ao lado para adicionar.',
            no_group: 'Sem grupo',
            remove: 'Remover time',
          },
          counter: {
            empty: 'Selecione os times para começar.',
            selected_one: 'time selecionado',
            selected_other: 'times selecionados',
            allocated_one: 'alocado',
            allocated_other: 'alocados',
            pending_one: 'pendente de grupo',
            pending_other: 'pendentes de grupo',
          },
          groups: {
            section_title: 'Distribuição nos grupos',
            section_help: 'Todos os times selecionados precisam estar em algum grupo para avançar para a revisão.',
            placeholder_group_name: 'Grupo {{index}}',
            team_count_one: '{{count}} time',
            team_count_other: '{{count}} times',
            empty: 'Nenhum time alocado neste grupo.',
            add_team: 'Adicionar time ao grupo',
            picker_empty: 'Todos os times selecionados já estão em algum grupo.',
            remove: 'Remover do grupo',
            unallocated_warning_one: 'Falta {{count}} time para alocar em um grupo antes de avançar.',
            unallocated_warning_other: 'Faltam {{count}} times para alocar em um grupo antes de avançar.',
          },
          toasts: {
            max_reached: 'Limite de {{max}} times atingido.',
          },
        },

        season_step3: {
          title: 'Revisar e confirmar',
          callout:
            'Revise as informações abaixo. Após criar a temporada, você poderá adicionar os times e configurar grupos na página de edição.',
          fields: {
            championship: 'Competição',
            year: 'Ano',
            format: 'Formato',
            total_stages: 'Total de fases',
            total_teams: 'Total de times',
          },
          total_stages_value_one: '{{count}} fase',
          total_stages_value_other: '{{count}} fases',
          total_teams_value_one: '{{count}} time',
          total_teams_value_other: '{{count}} times',
          stages_box_title: 'FASES QUE SERÃO CRIADAS',
          next_steps_title: 'PRÓXIMOS PASSOS',
          toasts: {
            create_success: 'Temporada criada com sucesso.',
            create_error: 'Não foi possível criar as fases da temporada. Tente novamente.',
          },
        },
      },
    },

    application_classification_table: {
      components: {
        classification_table_row: {
          classification_increase_position: 'Subir posição',
          classification_decrease_position: 'Descer posição',
          classification_delete: 'Deletar',
        },

        classification_table_header: {
          classification_header_position: 'POSIÇÃO',
          classification_header_team: 'TIME VISITANTE',
          classification_header_points: 'PONTOS',
          classification_header_matches: 'JOGOS',
          classification_header_wins: 'VITÓRIAS',
          classification_header_draws: 'EMPATES',
          classification_header_losses: 'DERROTAS',
          classification_header_goals_for: 'GOLS PRÓ',
          classification_header_goals_against: 'GOLS CONTRA',
          classification_header_goals_difference: 'SALDO DE GOLS',
          classification_header_actions: 'AÇÕES',
        },
      },

      breadcrumb: {
        classification_table_label1: 'APLICATIVO',
        classification_table_label2: 'TABELAS',
        classification_table_label3: 'CLASSIFICAÇÃO',
      },

      classification_table_title: 'TABELAS DE CLASSIFICAÇÃO',
      classification_table_view_competitions: 'Ver competições',
      classification_table_view_teams: 'Ver times',
      classification_table_tables_title: 'Tabelas de Classificação',
      classification_table_label: 'Competição:',
      classification_table_placeholder: 'Selecione uma competição',
      classification_table_label_default: 'Marcar como padrão',
      classification_table_description:
        'Caso essa opção esteja marcada, essa tabela de classificação aparecerá como padrão na tela inicial do Menu Tabelas e na Página Inicial do aplicativo',
      classification_table_new_position: 'Nova posição',
      classification_table_save_changes: 'Salvar alterações',
      classification_table_title_delete: 'Excluir posição',
      classification_table_description_label: 'Tem certeza que deseja excluir o time na posição ?',
      classification_table_enabled: 'Habilitado',
      classification_table_disabled: 'Desabilitado',
      classification_table_title_classification: 'Tabelas de Classificação',
      classification_table_modal_enabled: 'Tem certeza que deseja habilitar este componente?',
      classification_table_modal_disabled: 'Tem certeza que deseja desabilitar este componente?',
      classification_table_save_success: 'Classificação salva com sucesso!',
      classification_table_save_error: 'Ocorreu um erro ao salvar classificação. Recarregue e tente novamente.',
      classification_table_delete_error: 'Ocorreu um erro ao deletar posição. Recarregue e tente novamente!',
      classification_table_no_team: 'Existem posições sem time associado',
      classification_table_set_default_success: 'Competição marcada como padrão com sucesso',
      classification_table_set_default_error: 'Ocorreu um erro ao marcar competição como padrão. Recarregue e tente novamente.',
      classification_table_remove_default_success: 'Competição desmarcada como padrão com sucesso',
      classification_table_remove_default_error:
        'Ocorreu um erro ao desmarcar competição como padrão. Recarregue e tente novamente.',
      classification_table_toggle_area_enable: 'Área de tabelas de classificação habilitada com sucesso',
      classification_table_toggle_area_disable: 'Área de tabelas de classificação desabilitada com sucesso',
      classification_table_toggle_error_enabled:
        'Ocorreu um erro ao {action} área de tabelas de classificação. Recarregue a página e tente novamente.',
      classification_table_toggle_error_disabled:
        'Ocorreu um erro ao {action} área de tabelas de classificação. Recarregue a página e tente novamente.',
    },

    application_exclusive_material: {
      components: {
        exclusive_material_create_modal: {
          exclusive_create_modal_title: 'Adicionar material exclusivo',
          exclusive_create_modal_team: 'Time:',
          exclusive_create_modal_label: 'Nome*:',
          exclusive_create_modal_helper_text: '(Máx. de caracteres: 50)',
          exclusive_create_modal_label_archive: 'Arquivo*:',
          exclusive_create_modal_help_text: 'Formato: PNG, JPG, JPEG, PDF, DOC, DOCX, XLS, XLSX ou CSV',
          exclusive_create_modal_label_image: 'Imagem da capa*:',
          exclusive_create_modal_help_text_label: 'Formato: PNG, JPG ou JPEG | Tamanho mínimo 1000 x 1000 px',
          exclusive_create_modal_publish_date: 'Data:',
          exclusive_create_modal_text: 'Salvar como rascunho',
          exclusive_create_modal_icon: 'save',
          exclusive_create_modal_cancel: 'Cancelar',
          exclusive_create_modal_create: 'Criar',
          exclusive_create_modal_success: 'Material exclusivo criado com sucesso!',
          exclusive_create_modal_error: 'Não foi possível criar o material exclusivo. Tente novamente.',

          schema: {
            exclusive_create_required_field: 'Campo obrigatório',
            exclusive_create_invalid_file_extension:
              'Extensão inválida. Utilize .png, .jpg, .jpeg, .pdf, .xls, .xlsx, .doc, .docx ou .csv',
            exclusive_create_invalid_image_extension: 'Extensão inválida. Utilize .jpg, .jpeg ou .png',
          },
        },
        exclusive_material_edit_modal: {
          exclusive_edit_modal_title: 'Editar material exclusivo',
          exclusive_edit_modal_label: 'Nome*:',
          exclusive_edit_modal_team: 'Time:',
          exclusive_edit_modal_helper_text: '(Máx. de caracteres: 50)',
          exclusive_edit_modal_label_archive: 'Arquivo*:',
          exclusive_edit_modal_help_text: 'Formato: PNG, JPG, JPEG, PDF, DOC, DOCX, XLS, XLSX ou CSV',
          exclusive_edit_modal_label_image: 'Imagem da capa*:',
          exclusive_edit_modal_help_text_label: 'Formato: PNG, JPG ou JPEG | Tamanho mínimo 1000 x 1000 px',
          exclusive_edit_modal_publish_date: 'Data:',
          exclusive_edit_modal_published: 'Publicada',
          exclusive_edit_modal_cancel: 'Cancelar',
          exclusive_edit_modal_save: 'Salvar alterações',
          exclusive_edit_modal_success: 'Material exclusivo alterado com sucesso!',
          exclusive_edit_modal_error: 'Não foi possível alterar o material exclusivo. Tente novamente.',
          exclusive_edit_modal_download_success: 'Arquivo baixado com sucesso!',
          exclusive_edit_modal_download_error: 'Ocorreu um erro ao baixar o arquivo. Tente novamente.',

          schema: {
            exclusive_edit_required_field: 'Campo obrigatório',
            exclusive_edit_invalid_file_extension:
              'Extensão inválida. Utilize .png, .jpg, .jpeg, .pdf, .xls, .xlsx, .doc, .docx ou .csv',
            exclusive_edit_invalid_image_extension: 'Extensão inválida. Utilize .jpg, .jpeg ou .png',
            exclusive_edit_select_date: 'Selecione uma data',
          },
        },
        exclusive_material_filter_box: {
          exclusive_filter_box_heading: 'Filtros',
          exclusive_filter_box_material_team: 'Time:',
          exclusive_filter_box_material_team_select_all: 'Todos',
          exclusive_filter_box_material_label: 'Material:',
          exclusive_filter_box_status_label: 'Situação:',
          exclusive_filter_box_all_option: 'Todos',
          exclusive_filter_box_clear_button: 'Limpar filtros',
        },

        exclusive_material_table: {
          exlusive_table_creation_date_header: 'DATA DA CRIAÇÃO',
          exlusive_table_team_header: 'TIME',
          exlusive_table_title_header: 'TÍTULO',
          exlusive_table_downloads_header: 'NÚMERO DE DOWNLOADS',
          exlusive_table_status_header: 'SITUAÇÃO',
          exlusive_table_actions_header: 'AÇÕES',
          exlusive_table_more_actions_label: 'Mostrar mais ações',
          exlusive_table_view_details_action: 'Editar',
          exlusive_table_delete_action: 'Excluir',
        },
      },

      breadcrumb: {
        exclusive_material_label1: 'APLICATIVO',
        exclusive_material_label2: 'MATERIAIS EXCLUSIVOS',
      },

      exclusive_material_title: 'MATERIAIS EXCLUSIVOS',
      exclusive_material_label: 'Materiais exclusivos',
      exclusive_material_enabled: 'Habilitado',
      exclusive_material_disabled: 'Desabilitado',
      exclusive_material_add_button: 'Adicionar material exclusivo',
      exclusive_material_area_success: 'Área de materiais exclusivos habilitada com sucesso',
      exclusive_material_area_disabled: 'Área de materiais exclusivos desabilitada com sucesso',
      exclusive_material_area_error:
        'Ocorreu um erro ao habilitar a área de materiais exclusivos. Recarregue a página e tente novamente.',
      exclusive_material_area_error_disabled:
        'Ocorreu um erro ao desabilitar a área de materiais exclusivos. Recarregue a página e tente novamente.',
      exclusive_material_delete_success: 'Material exclusivo deletado com sucesso!',
      exclusive_material_delete_error: 'Ocorreu um erro ao deletar material exclusivo. Tente novamente.',
      exclusive_material_not_found: 'Material exclusivo não encontrado.',
      exclusive_material_delete_modal_title: 'Excluir material exclusivo',
      exclusive_material_delete_modal_description_1: 'Tem certeza que deseja excluir o material exclusivo ',
      exclusive_material_delete_modal_description_2: '?',
      exclusive_material_area_modal_title: 'Materiais Exclusivos',
      exclusive_material_area_modal_enabled: 'Tem certeza que deseja habilitar este componente?',
      exclusive_material_area_modal_disabled: 'Tem certeza que deseja desabilitar este componente?',
      exclusive_material_enable: 'habilitar',
      exclusive_material_disable: 'desabilitar',
    },

    application_games_schedule: {
      componnets: {
        games_schedule_create_modal: {
          games_schedule_modal_title: 'Adicionar um jogo',
          games_schedule_create_date_label: 'Data:',
          games_schedule_create_league_label: 'Competição*:',
          games_schedule_create_league_placeholder: 'Selecione',
          games_schedule_create_round_label: 'Rodada / Fase*:',
          games_schedule_create_local_label: 'Local*:',
          games_schedule_create_transmission_label: 'Transmissão:',
          games_schedule_create_home_team_label: 'Time da casa*:',
          games_schedule_create_away_team_label: 'Time de fora*:',
          games_schedule_create_hyperlink_label: 'Link para compra de ingressos:',
          games_schedule_create_description_label: 'Descrição:',
          games_schedule_create_last_matches_label: 'Últimos confrontos',
          games_schedule_create_add_match_button: 'Adicionar confronto',
          games_schedule_create_delete_match_button_label: 'Deletar confronto',
          games_schedule_create_history_label: 'Histórico',
          games_schedule_create_wins_label: 'Vitórias',
          games_schedule_create_draws_label: 'Empates',
          games_schedule_create_losses_label: 'Derrotas',
          games_schedule_create_save_draft_button: 'Salvar como rascunho',
          games_schedule_create_cancel_button: 'Cancelar',
          games_schedule_create_create_button: 'Criar',
          games_schedule_create_success_toast_title: 'Jogo criado com sucesso!',
          games_schedule_create_error_toast_title: 'Não foi possível criar um jogo. Tente novamente.',

          schema: {
            required_field_error: 'Campo obrigatório',
            same_team_error: 'Time de fora não pode ser o mesmo time da casa',
            select_team_error: 'Selecione um time',
            last_matches_empty_error: 'Adicione pelo menos um confronto',
          },
        },

        games_schedule_edit_modal: {
          games_schedule_edit_modal_title: 'Editar jogo',
          games_schedule_edit_competition_label: 'Competição*:',
          games_schedule_edit_round_label: 'Rodada / Fase*:',
          games_schedule_edit_home_team_label: 'Time da casa*:',
          games_schedule_edit_away_team_label: 'Time de fora*:',
          games_schedule_edit_select_placeholder: 'Selecione',
          games_schedule_edit_cancel: 'Cancelar',
          games_schedule_edit_save: 'Salvar alterações',
          games_schedule_edit_success: 'Jogo alterado com sucesso!',
          games_schedule_edit_error: 'Não foi possível alterar o jogo. Tente novamente.',
          games_schedule_edit_league_error: 'Competição não encontrada.',

          schema: {
            required: 'Campo obrigatório',
          },
        },

        games_schedule_filter_box: {
          games_schedule_filter_filter_title: 'Filtros',
          games_schedule_filter_competition_label: 'Competição:',
          games_schedule_filter_round_label: 'Rodada / Fase:',
          games_schedule_filter_team_label: 'Time:',
          games_schedule_filter_all_option: 'Todos',
          games_schedule_filter_clear_filters_button: 'Limpar filtros',
          games_schedule_filter_league_error: 'Competição não encontrada.',
          games_schedule_filter_status_label: 'Situação da Partida',
        },

        games_schedule_table: {
          games_schedule_table_date_header: 'DATA',
          games_schedule_table_time_header: 'HORÁRIO',
          games_schedule_table_location_header: 'LOCAL',
          games_schedule_table_competition_header: 'COMPETIÇÃO',
          games_schedule_table_round_header: 'RODADA / FASE',
          games_schedule_table_home_team_header: 'TIME DA CASA',
          games_schedule_table_score_header: 'PLACAR',
          games_schedule_table_away_team_header: 'TIME VISITANTE',
          games_schedule_table_status_header: 'SITUAÇÃO',
          games_schedule_table_actions_header: 'AÇÕES',
        },
        games_schedule_table_row: {
          games_schedule_table_edit_button: 'Editar',
          games_schedule_table_save_button: 'Salvar',
          games_schedule_table_delete_aria_label: 'Deletar',
        },
      },

      breadcrumb: {
        games_schedule_page_label1: 'APLICATIVO',
        games_schedule_page_label2: 'TABELAS',
        games_schedule_page_label3: 'JOGOS',
      },

      games_schedule_page_title: 'TABELAS DE JOGOS',
      games_schedule_section_title: 'Tabela de Jogos',
      games_schedule_enabled_status: 'Habilitado',
      games_schedule_disabled_status: 'Desabilitado',
      games_schedule_view_competitions_button: 'Ver competições',
      games_schedule_view_teams_button: 'Ver times',
      games_schedule_add_game_button: 'Adicionar jogo',
      games_schedule_game_updated: 'Jogo alterado com sucesso!',
      games_schedule_game_update_error: 'Ocorreu um erro ao alterar o jogo. Tente novamente.',
      games_schedule_game_deleted: 'Jogo deletado com sucesso!',
      games_schedule_game_delete_error: 'Ocorreu um erro ao deletar o jogo. Tente novamente.',
      games_schedule_area_enabled: 'Área de tabelas de jogos habilitada com sucesso',
      games_schedule_area_disabled: 'Área de tabelas de jogos desabilitada com sucesso',
      games_schedule_area_toggle_error:
        'Ocorreu um erro ao habilitar área de tabelas de jogos. Recarregue a página e tente novamente.',
      games_schedule_area_toggle_error_disabled:
        'Ocorreu um erro ao desabilitar área de tabelas de jogos. Recarregue a página e tente novamente.',
      games_schedule_delete_title: 'Excluir jogo',
      games_schedule_delete_description: 'Tem certeza que deseja excluir o jogo',
      games_schedule_toggle_area_title: 'Tabela de Jogos',
      games_schedule_toggle_area_description: 'Tem certeza que deseja habilitar este componente?',
      games_schedule_toggle_area_description_disabled: 'Tem certeza que deseja desabilitar este componente?',
    },

    application_history: {
      breadcrumb: {
        application_history_label1: 'APLICATIVO',
        application_history_label2: 'HISTÓRIA',
      },

      application_history_title: 'HISTÓRIA',
      application_history_header: 'História',
      application_history_enabled: 'Habilitado',
      application_history_disabled: 'Desabilitado',
      application_history_timeline: 'Linha do Tempo',
      application_history_anthem: 'Hino do Clube',
      application_history_gallery: 'Galeria Histórica',
      application_history_won_title: 'Títulos',
      application_history_uniforms: 'Uniformes Históricos',
      application_history_enable_success: 'Área de história habilitada com sucesso',
      application_history_disable_success: 'Área de história desabilitada com sucesso',
      application_history_enable_error: 'Ocorreu um erro ao habilitar área de história. Recarregue a página e tente novamente.',
      application_history_disable_error:
        'Ocorreu um erro ao desabilitar área de história. Recarregue a página e tente novamente.',
      application_history_title_label: 'História',
      application_history_description_enabed:
        'Ao habilitar este componente, todos os componentes associados serão automaticamente habilitados. Deseja continuar?',
      application_history_description_disabled:
        'Ao desabilitar este componente, todos os componentes associados serão automaticamente desabilitados. Deseja continuar?',
    },

    application_history_anthem: {
      breadcrumb: {
        application_history_anthem_label1: 'APLICATIVO',
        application_history_anthem_label2: 'HISTÓRIA',
        application_history_anthem_label3: 'HINO',
      },

      anthem_table: {
        anthem_table_created_at_header: 'DATA DA CRIAÇÃO',
        anthem_table_team_header: 'TIME',
        anthem_table_location_header: 'HINO',
        anthem_table_lyrics_header: 'LETRA',
        anthem_table_view_details_option: 'AÇÕES',
        anthem_table_edit_button: 'Editar',
        anthem_table_delete_button: 'Excluir',
        anthem_table_show_more_actions: 'Mostrar mais ações',
      },

      anthem_filter_box: {
        anthem_filter_box_title: 'Filtros',
        anthem_filter_box_team: 'Time:',
        anthem_filter_box_team_select_all: 'Todos',
        anthem_filter_box_clear: 'Limpar filtros',
      },

      anthem_create_modal: {
        anthem_create_title: 'Adicionar hino',
        anthem_create_team: 'Time',
        anthem_create_success: 'Hino criado com sucesso!',
        anthem_create_error: 'Não foi possível criar o hino. Tente novamente.',
        anthem_create_cancel: 'Cancelar',
        anthem_create_create: 'Criar',
        anthem_label_lyrics: 'Letra:',
        anthem_helper_text: '(Máx. de caracteres: 2.000)',
      },

      anthem_edit_modal: {
        anthem_edit_title: 'Editar hino do clube',
        anthem_edit_team: 'Time',
        anthem_edit_success: 'Hino criado com sucesso!',
        anthem_edit_error: 'Não foi possível criar o hino. Tente novamente.',
        anthem_edit_cancel: 'Cancelar',
        anthem_label_lyrics: 'Letra:',
        anthem_helper_text: '(Máx. de caracteres: 2.000)',
        anthem_edit_save: 'Salvar alterações',
      },

      application_history_anthem_delete_confirm_title: 'Excluir hino',
      application_history_anthem_delete_confirm_description_start: 'Tem certeza que deseja excluir o hino ',
      application_history_anthem_delete_confirm_description_end: '?',
      application_history_anthem_toggle_confirm_title: 'Hino',
      application_history_anthem_enable_confirm_description: 'Tem certeza que deseja habilitar este componente?',
      application_history_anthem_disable_confirm_description: 'Tem certeza que deseja desabilitar este componente?',
      application_history_anthem_add_button: 'Adicionar hino',
      application_history_anthem_enabled: 'Habilitado',
      application_history_anthem_disabled: 'Desabilitado',
      application_history_anthem_label: 'Hino do Clube',
      application_history_anthem_title: 'HINO DO CLUBE',
      application_history_anthem_edit_error: 'Hino não encontrado.',
      application_history_anthem_delete_success: 'Hino deletado com sucesso!',
      application_history_anthem_delete_error: 'Ocorreu um erro ao deletar o hino. Recarregue e tente novamente.',
      application_history_anthem_enable_success: 'Área do hino habilitada com sucesso',
      application_history_anthem_disable_success: 'Área do hino desabilitada com sucesso',
      application_history_anthem_enable_error:
        'Ocorreu um erro ao habilitar área do hino. Recarregue a página e tente novamente.',
      application_history_anthem_disable_error:
        'Ocorreu um erro ao desabilitar área do hino. Recarregue a página e tente novamente.',

      schema: {
        application_history_anthem_required_path: 'Selecione um arquivo',
        application_history_anthem_required_music: 'Extensão inválida. Utilize um arquivo .mp3 ou .wav',
      },
    },

    application_history_gallery: {
      components: {
        photo_gallery_create_modal: {
          photo_gallery_create_title: 'Adicionar imagem',
          photo_gallery_create_team_label: 'Time:',
          photo_gallery_create_title_label: 'Título*:',
          photo_gallery_create_title_helper: '(Máx. de caracteres: 200)',
          photo_gallery_create_description_label: 'Descrição*:',
          photo_gallery_create_credit_label: 'Crédito:',
          photo_gallery_create_description_helper: '(Máx. de caracteres: 200)',
          photo_gallery_create_image_label: 'Imagem*:',
          photo_gallery_create_image_helper: 'Formato: PNG, JPG ou JPEG | Proporção 4:3 ou 16:9',
          photo_gallery_create_cancel: 'Cancelar',
          photo_gallery_create_create: 'Criar',
          photo_gallery_create_success: 'Imagem criada com sucesso!',
          photo_gallery_create_error: 'Não foi possível criar a imagem. Tente novamente.',

          schema: {
            required: 'Campo obrigatório',
            required_image: 'Extensão inválida. Utilize .jpg, .jpeg ou .png',
          },
        },

        photo_gallery_edit_modal: {
          photo_gallery_edit_title: 'Editar imagem',
          photo_gallery_edit_team_label: 'Time:',
          photo_gallery_edit_title_label: 'Título*:',
          photo_gallery_edit_title_helper: '(Máx. de caracteres: 200)',
          photo_gallery_edit_description_label: 'Descrição*:',
          photo_gallery_edit_description_helper: '(Máx. de caracteres: 200)',
          photo_gallery_edit_credit_label: 'Crédito:',
          photo_gallery_edit_image_label: 'Imagem*:',
          photo_gallery_edit_image_helper: 'Formato: PNG, JPG ou JPEG | Proporção 4:3 ou 16:9',
          photo_gallery_edit_cancel: 'Cancelar',
          photo_gallery_edit_save: 'Salvar alterações',
          photo_gallery_edit_success: 'Imagem alterada com sucesso!',
          photo_gallery_edit_error: 'Não foi possível alterar a imagem. Tente novamente.',

          schema: {
            required: 'Campo obrigatório',
            required_image: 'Extensão inválida. Utilize .jpg, .jpeg ou .png',
          },
        },

        photo_gallery_filter_box: {
          photo_gallery_filter_filter_title: 'Filtros',
          photo_gallery_filter_team_title: 'Time',
          photo_gallery_filter_team_select_all: 'Todos',
          photo_gallery_filter_achievement_label: 'Título:',
          photo_gallery_filter_start_date_label: 'Data inicial:',
          photo_gallery_filter_end_date_label: 'Data final:',
          photo_gallery_filter_clear_filters_button: 'Limpar filtros',
        },

        photo_gallery_table: {
          photo_gallery_table_creation_date_header: 'DATA DA CRIAÇÃO',
          photo_gallery_table_title_header: 'TÍTULO',
          photo_gallery_table_actions_header: 'AÇÕES',
          photo_gallery_table_view_details_option: 'Editar',
          photo_gallery_table_delete_option: 'Excluir',
          photo_gallery_table_menu_aria_label: 'Mostrar mais ações',
        },
      },

      breadcrumb: {
        photo_gallery_label1: 'APLICATIVO',
        photo_gallery_label2: 'HISTÓRIA',
        photo_gallery_label3: 'GALERIA HISTÓRICA',
      },

      photo_gallery_page_title: 'GALERIA HISTÓRICA',
      photo_gallery_gallery_label: 'Galeria Histórica',
      photo_gallery_enabled_status: 'Habilitado',
      photo_gallery_disabled_status: 'Desabilitado',
      photo_gallery_add_image_button: 'Adicionar imagem',
      photo_gallery_delete_image_modal_title: 'Excluir imagem',
      photo_gallery_delete_image_modal_description: 'Tem certeza que deseja excluir a imagem ?',
      photo_gallery_toggle_component_modal_title: 'Galeria Histórica',
      photo_gallery_toggle_component_modal_description: 'Tem certeza que deseja habilitar este componente?',
      photo_gallery_toggle_component_modal_description_disabled: 'Tem certeza que deseja desabilitar este componente?',
      photo_gallery_enable_action: 'habilitar',
      photo_gallery_disable_action: 'desabilitar',
      photo_gallery_area_enabled_success: 'Área da galeria habilitada com sucesso',
      photo_gallery_area_disabled_success: 'Área da galeria desabilitada com sucesso',
      photo_gallery_area_toggle_error_enabled:
        'Ocorreu um erro ao habilitar a área da galeria. Recarregue a página e tente novamente.',
      photo_gallery_area_toggle_error_disabled:
        'Ocorreu um erro ao desabilitar a área da galeria. Recarregue a página e tente novamente.',
      photo_gallery_image_deleted_success: 'Imagem deletada com sucesso!',
      photo_gallery_image_delete_error: 'Ocorreu um erro ao deletar a imagem. Tente novamente.',
      photo_gallery_image_not_found: 'Imagem não encontrada.',
    },

    application_history_timeline: {
      components: {
        team_timeline_filter_box: {
          team_timeline_filter_box_title: 'Filtros',
          team_timeline_filter_box_team_label: 'Time:',
          team_timeline_filter_box_team_select_all: 'Todos',
          team_timeline_filter_box_title_label: 'Título:',
          team_timeline_filter_box_year_label: 'Ano:',
          team_timeline_filter_box_clear_button: 'Limpar filtros',
        },

        team_timeline_table: {
          team_timeline_table_created_at: 'DATA DA CRIAÇÃO',
          team_timeline_table_team: 'TIME',
          team_timeline_table_year: 'ANO',
          team_timeline_table_title: 'TÍTULO',
          team_timeline_table_actions: 'Ações',
          team_timeline_table_add_actions: 'Mostrar mais ações',
          team_timeline_table_view_details: 'Editar',
          team_timeline_table_delete: 'Excluir',
        },

        team_timeline_create_modal: {
          team_timeline_create_title: 'Adicionar timeline',
          team_timeline_create_team_label: 'Time:',
          team_timeline_create_year_label: 'Ano*:',
          team_timeline_create_title_label: 'Título*:',
          team_timeline_create_title_helper: '(Máx. de caracteres: 50)',
          team_timeline_create_description_label: 'Descrição*:',
          team_timeline_create_description_helper: '(Máx. de caracteres: 200)',
          team_timeline_create_cancel_button: 'Cancelar',
          team_timeline_create_create_button: 'Criar',
          team_timeline_create_success: 'Linha do Tempo criada com sucesso!',
          team_timeline_create_error: 'Não foi possível criar a timeline. Tente novamente.',

          schema: {
            required: 'Campo obrigatório',
            required_year: 'O ano deve ser maior ou igual a 1500',
          },
        },
        team_timeline_edit_modal: {
          team_timeline_edit_title: 'Editar timeline',
          team_timeline_edit_team_label: 'Time:',
          team_timeline_edit_year_label: 'Ano*:',
          team_timeline_edit_title_label: 'Título*:',
          team_timeline_edit_title_helper: '(Máx. de caracteres: 50)',
          team_timeline_edit_description_label: 'Descrição*:',
          team_timeline_edit_description_helper: '(Máx. de caracteres: 200)',
          team_timeline_edit_cancel_button: 'Cancelar',
          team_timeline_edit_save_button: 'Salvar alterações',
          team_timeline_edit_success: 'Linha do Tempo alterada com sucesso!',
          team_timeline_edit_error: 'Não foi possível alterar a timeline. Tente novamente.',

          schema: {
            required: 'Campo obrigatório',
          },
        },
      },

      breadcrumb: {
        team_timeline_label1: 'APLICATIVO',
        team_timeline_label2: 'HISTÓRIA',
        team_timeline_label3: 'LINHA DO TEMPO',
      },

      team_timeline_page_title: 'LINHA DO TEMPO',
      team_timeline_title: 'Linha do Tempo',
      team_timeline_enabled: 'Habilitado',
      team_timeline_disabled: 'Desabilitado',
      team_timeline_add_button: 'Adicionar timeline',
      team_timeline_toggle_title: 'Linha do Tempo',
      team_timeline_toggle_description: 'Tem certeza que deseja habilitar este componente?',
      team_timeline_toggle_description_disabled: 'Tem certeza que deseja desabilitar este componente?',
      team_timeline_toggle_enable: 'habilitar',
      team_timeline_toggle_disable: 'desabilitar',
      team_timeline_toggle_success: 'Área da timeline habilitada com sucesso',
      team_timeline_toggle_disabled: 'Área da timeline desabilitada com sucesso',
      team_timeline_toggle_error: 'Ocorreu um erro ao habilitar área da timeline. Recarregue a página e tente novamente.',
      team_timeline_toggle_error_disabled:
        'Ocorreu um erro ao desabilitar área da timeline. Recarregue a página e tente novamente.',
      team_timeline_delete_title: 'Excluir timeline',
      team_timeline_delete_description: 'Tem certeza que deseja excluir a timeline?',
      team_timeline_delete_confirm_button: 'Excluir',
      team_timeline_delete_success: 'Linha do Tempo deletada com sucesso!',
      team_timeline_delete_error: 'Ocorreu um erro ao deletar a timeline. Tente novamente.',
      team_timeline_search_error: 'Linha do Tempo não encontrada.',
    },

    application_home: {
      app_menu_buttons: {
        available_label: 'Disponíveis:',
        selected_label: 'Selecionados:',
      },

      home_area_features: {
        available_label: 'Disponíveis:',
        selected_label: 'Selecionados:',
        replace_label: 'Substituir',
      },

      breadcrumb: {
        home_label1: 'APLICATIVO',
        home_label2: 'PÁGINA INICIAL',
      },

      application_home_title: 'PÁGINA INICIAL',
      application_home_page_title: 'Página Inicial',
      application_home_page_subtitle: 'Configuração da página inicial:',
      application_home_areas_title: 'Áreas da página inicial',
      application_home_areas_description:
        'Áreas do aplicativo que serão exibidas na página inicial. A ordem dos itens selecionados será a mesma exibida na tela do aplicativo:',
      application_home_save_home_button: 'Salvar página inicial',
      application_home_shortcuts_title: 'Atalhos do rodapé',
      application_home_shortcuts_description:
        'Atalhos rápidos que ficarão fixos no rodapé durante a navegação. A ordem dos itens selecionados será a mesma exibida no rodapé do aplicativo:',
      application_home_shortcuts_info: 'Mínimo: 3 atalhos | Máximo: 5 atalhos',
      application_home_back_button: 'Voltar',
      application_home_save_shortcuts_button: 'Salvar atalhos',
      application_home_success: 'Alterações salvas com sucesso!',
      application_home_error: 'Ocorreu um erro ao salvar alterações. Tente novamente.',
    },

    application_indications_map: {
      components: {
        location_create_modal: {
          location_create_title: 'Adicionar uma indicação',
          location_create_team_label: 'Time:',
          location_create_title_label: 'Nome*:',
          location_create_title_helper: '(Máx. de caracteres: 100)',
          location_create_phone: 'Telefone',
          location_create_email: 'E-mail:',
          location_create_website: 'Site:',
          location_create_instagram: 'Instagram:',
          location_create_postal_code: 'CEP:',
          location_create_address_line1: 'Logradouro:',
          location_create_address_line2: 'Número:',
          location_create_address_line3: 'Complemento:',
          location_create_neighborhood: 'Bairro:',
          location_create_city: 'Cidade:',
          location_create_state: 'Estado:',
          location_create_latitude: 'Latitude:',
          location_create_longitude: 'Longitude:',
          location_create_state_helper: '(Máx. de caracteres: 2)',
          location_create_country_code: 'País:',
          location_create_cancel: 'Cancelar',
          location_create_create: 'Criar',
          location_create_success: 'Indicação criada com sucesso!',
          location_create_error: 'Não foi possível criar a indicação. Tente novamente.',

          schema: {
            required: 'Campo obrigatório',
            required_image: 'Selecione uma imagem',
          },
        },

        location_edit_modal: {
          location_edit_title: 'Editar indicação',
          location_edit_team_label: 'Time:',
          location_edit_title_label: 'Nome*:',
          location_edit_title_helper: '(Máx. de caracteres: 100)',
          location_edit_phone: 'Telefone:',
          location_edit_email: 'E-mail:',
          location_edit_website: 'Site:',
          location_edit_instagram: 'Instagram:',
          location_edit_postal_code: 'CEP:',
          location_edit_address_line1: 'Logradouro:',
          location_edit_address_line2: 'Número:',
          location_edit_address_line3: 'Complemento:',
          location_edit_neighborhood: 'Bairro:',
          location_edit_city: 'Cidade:',
          location_edit_state: 'Estado:',
          location_edit_latitude: 'Latitude:',
          location_edit_longitude: 'Longitude:',
          location_edit_state_helper: '(Máx. de caracteres: 2)',
          location_edit_country_code: 'País:',
          location_edit_cancel: 'Cancelar',
          location_edit_save: 'Salvar alterações',
          location_edit_success: 'Indicação alterada com sucesso!',
          location_edit_error: 'Não foi possível alterar a indicação. Tente novamente.',

          schema: {
            required: 'Campo obrigatório',
          },
        },

        location_filter_box: {
          location_filter_filter_title: 'Filtros',
          location_filter_team_label: 'Time:',
          location_filter_team_select_all: 'Todos',
          location_filter_title_label: 'Título:',
          location_filter_city_label: 'Cidade:',
          location_filter_start_date_label: 'Data inicial:',
          location_filter_end_date_label: 'Data final:',
          location_filter_clear_filters_button: 'Limpar filtros',
        },

        location_table: {
          location_table_created_at: 'DATA DA CRIAÇÃO',
          location_table_team: 'TIME',
          location_table_title: 'INDICAÇÃO',
          location_table_city: 'CIDADE',
          location_table_actions: 'Ações',
          location_table_view_details: 'Editar',
          location_table_delete: 'Excluir',
          location_table_aria_label: 'Mostrar mais ações',
        },
      },

      breadcrumb: {
        indications_map_label1: 'APLICATIVO',
        indications_map_label2: 'MAPA DE INDICAÇÕES',
      },

      indications_map_page_title: 'MAPA DE INDICAÇÕES',
      indications_map_section_title: 'Mapa de Indicações',
      indications_map_switch_enabled: 'Habilitado',
      indications_map_switch_disabled: 'Desabilitado',
      indications_map_add_button: 'Adicionar indicação',
      indications_map_title: 'Excluir indicação',
      indications_map_description: 'Tem certeza que deseja excluir a indicação?',
      indications_map_title_label: 'Mapa de Indicações',
      indications_map_enable_description: 'Tem certeza que deseja habilitar este componente?',
      indications_map_disable_description: 'Tem certeza que deseja desabilitar este componente?',
      indications_map_enable_success: 'Área de mapa de indicações habilitada com sucesso',
      indications_map_disable_success: 'Área de mapa de indicações desabilitada com sucesso',
      indications_map_enable_error:
        'Ocorreu um erro ao habilitar área de mapa de indicações. Recarregue a página e tente novamente.',
      indications_map_disable_error:
        'Ocorreu um erro ao desabilitar área de mapa de indicações. Recarregue a página e tente novamente.',
      indications_map_delete_success: 'Indicação deletada com sucesso!',
      indications_map_delete_error: 'Ocorreu um erro ao deletar a indicação. Tente novamente.',
      indications_map_not_found: 'Indicação não encontrada.',
    },

    application_league: {
      components: {
        league_create_modal: {
          league_create_title: 'Adicionar competição',
          league_create_name: 'Nome*:',
          league_create_name_helper: '(Máx. de caracteres: 30)',
          league_create_acronym: 'Sigla*:',
          league_create_acronym_helper: '(Máx. de caracteres: 3)',
          league_create_rounds_title: 'Rodadas / Fases*:',
          league_create_round_name: 'Nome:',
          league_create_round_helper: '(Máx. de caracteres: 30)',
          league_create_classification_title: 'Tabela de classificação',
          league_create_classification_label: 'Exibir tabela de classificação',
          league_create_add_round: 'Adicionar rodada / fase',
          league_create_cancel: 'Cancelar',
          league_create_create: 'Criar',
          league_create_success: 'Competição criada com sucesso!',
          league_create_error: 'Não foi possível criar a competição. Tente novamente.',
          league_create_delete_round: 'Deletar rodada',
          league_create_tournament_type_placeholder: 'Selecione o tipo',
          league_create_tournament_type_running_points: 'Pontos Corridos',
          league_create_tournament_type_qualifier: 'Eliminatórias',

          schema: {
            required: 'Campo obrigatório',
            required_rounds: 'Necessário ao menos uma rodada',
          },
        },

        league_edit_modal: {
          league_edit_title: 'Editar competição',
          league_edit_name: 'Nome*:',
          league_edit_name_helper: '(Máx. de caracteres: 30)',
          league_edit_acronym: 'Sigla*:',
          league_edit_acronym_helper: '(Máx. de caracteres: 3)',
          league_edit_rounds_title: 'Rodadas / Fases*:',
          league_edit_round_name: 'Nome:',
          league_edit_round_helper: '(Máx. de caracteres: 30)',
          league_edit_classification_title: 'Tabela de classificação',
          league_edit_classification_label: 'Exibir tabela de classificação',
          league_edit_add_round: 'Adicionar rodada / fase',
          league_edit_cancel: 'Cancelar',
          league_edit_save: 'Salvar alterações',
          league_edit_success: 'Competição alterada com sucesso!',
          league_edit_error: 'Não foi possível alterar a competição. Tente novamente.',
          league_edit_delete_round: 'Deletar rodada',
          league_edit_league_placeholder: 'Selecione o tipo',
          league_edit_tournament_type_placeholder: 'Selecione o tipo',
          league_edit_tournament_type_running_points: 'Pontos Corridos',
          league_edit_tournament_type_qualifier: 'Eliminatórias',

          schema: {
            required: 'Campo obrigatório',
            required_rounds: 'Necessário ao menos uma rodada',
          },
        },
        league_filter_box: {
          league_filter_filter_title: 'Filtros',
          league_filter_competition_label: 'Competição:',
          league_filter_start_date_label: 'Data inicial:',
          league_filter_end_date_label: 'Data final:',
          league_filter_clear_filters_button: 'Limpar filtros',
        },

        league_table: {
          league_table_created_at: 'DATA DA CRIAÇÃO',
          league_table_name: 'COMPETIÇÃO',
          league_table_acronym: 'SIGLA',
          league_table_actions: 'Ações',
          league_table_view_details: 'Editar',
          league_table_delete: 'Excluir',
          league_table_aria_label: 'Mostrar mais ações',
        },
      },

      breadcrumb: {
        league_label1: 'APLICATIVO',
        league_label2: 'TABELAS',
        league_label3: 'COMPETIÇÕES',
      },

      league_page_title: 'COMPETIÇÕES',
      league_section_title: 'Competição',
      league_add_competition: 'Adicionar competição',
      league_delete_title: 'Excluir competição',
      league_delete_description: 'Tem certeza que deseja excluir a competição',
      league_delete_success: 'Competição deletada com sucesso!',
      league_delete_error: 'Ocorreu um erro ao deletar a competição. Tente novamente.',
      league_not_found: 'Competição não encontrada',
    },

    application_news: {
      components: {
        news_create_modal: {
          news_create_title: 'Criar nova notícia',
          news_create_label_team: 'Time:',
          news_create_label: 'Título*:',
          news_create_helper_text: '(Máx. de caracteres: 100)',
          news_create_label_text: 'Texto*:',
          news_create_helper_text_label: '(Máx. de caracteres: 4.000)',
          news_create_label_url: 'URL fonte:',
          news_create_label_image: 'Imagem:',
          news_create_help_text: 'Formato: PNG, JPG ou JPEG | Proporção: 4:3 ou 16:9',
          news_create_date_label: 'Data:',
          news_create_save_draft: 'Salvar como rascunho',
          news_create_cancel: 'Cancelar',
          news_create_create: 'Criar',
          news_create_success: 'Notícia criada com sucesso!',
          news_create_error: 'Não foi possível criar a notícia. Tente novamente',

          schema: {
            required: 'Campo obrigatório',
            required_file: 'Extensão inválida. Utilize .jpg, .jpeg ou .png',
            required_publish_at: 'Selecione uma data',
          },
        },

        news_edit_modal: {
          news_edit_title: 'Editar notícia',
          news_edit_published: 'Publicada',
          news_edit_label: 'Título*:',
          news_edit_helper_text: '(Máx. de caracteres: 100)',
          news_edit_label_text: 'Texto*:',
          news_edit_helper_text_label: '(Máx. de caracteres: 4.000)',
          news_edit_label_url: 'URL fonte:',
          news_edit_label_image: 'Imagem:',
          news_edit_help_text: 'Formato: PNG, JPG ou JPEG | Proporção: 4:3 ou 16:9',
          news_edit_date_label: 'Data:',
          news_edit_cancel: 'Cancelar',
          news_edit_save: 'Salvar alterações',
          news_edit_success: 'Notícia alterada com sucesso!',
          news_edit_error: 'Não foi possível alterar a notícia. Tente novamente.',

          schema: {
            required: 'Campo obrigatório',
            required_file: 'Extensão inválida. Utilize .jpg, .jpeg ou .png',
            required_publish_at: 'Selecione uma data',
          },
        },

        news_filter_box: {
          news_filter_filter_heading: 'Filtros',
          news_filter_team_label: 'Time:',
          news_filter_team_select_all: 'Todos',
          news_filter_title_label: 'Título:',
          news_filter_status_label: 'Situação:',
          news_filter_all_option: 'Todos',
          news_filter_published_option: 'Publicada',
          news_filter_scheduled_option: 'Programada',
          news_filter_not_published_option: 'Não publicada',
          news_filter_start_date_label: 'Data inicial:',
          news_filter_end_date_label: 'Data final:',
          news_filter_clear_button: 'Limpar filtros',
        },

        news_table: {
          news_table_created_at_header: 'DATA DA CRIAÇÃO',
          news_table_publish_date_header: 'DATA DA PUBLICAÇÃO',
          news_table_team_name_header: 'TIME',
          news_table_title_header: 'TÍTULO',
          news_table_status_header: 'SITUAÇÃO',
          news_table_actions_header: 'AÇÕES',
          news_table_menu_aria_label: 'Mostrar mais ações',
          news_table_view_details: 'Editar',
          news_table_delete: 'Excluir',
        },
      },

      breadcrumb: {
        news_label1: 'APLICATIVO',
        news_label2: 'NOTÍCIAS',
      },

      news_page_title: 'NOTÍCIAS',
      news_label: 'Notícias',
      news_enabled: 'Habilitado',
      news_disabled: 'Desabilitado',
      news_create_news_button: 'Criar nova notícia',
      news_area_enabled_success: 'Área de notícias habilitada com sucesso',
      news_area_disabled_success: 'Área de notícias desabilitada com sucesso',
      news_area_enable_error: 'Ocorreu um erro ao habilitar área de notícias',
      news_area_disable_error: 'Ocorreu um erro ao desabilitar área de notícias',
      news_deleted_success: 'Notícia deletada com sucesso!',
      news_delete_error: 'Ocorreu um erro ao deletar notícia. Recarregue e tente novamente.',
      news_not_found: 'Notícia não encontrada',
      news_delete_news_title: 'Excluir notícia',
      news_delete_news_description: 'Tem certeza que deseja excluir a notícia',
      news_component_title: 'Notícias',
      news_enable: 'habilitar',
      news_disable: 'desabilitar',
      news_delete_news_enabled: 'Tem certeza que deseja habilitar este componente?',
      news_component_description_disabled: 'Tem certeza que deseja desabilitar este componente?',
    },

    application_balada_app: {
      components: {
        balada_app_create_modal: {
          balada_app_create_title: 'Criar BaladAPP',
          balada_app_create_label_title: 'Título*:',
          balada_app_create_label_identifier: 'Identificador*:',
          balada_app_create_label_type: 'Tipo*:',
          balada_app_create_type_placeholder: 'Selecione um tipo',
          balada_app_create_type_others: 'Outros',
          balada_app_create_type_tickets: 'Ingressos',
          balada_app_create_type_memberships: 'Sócio-torcedor',
          balada_app_create_label_url: 'Link*:',
          balada_app_create_help_url: 'Informe a URL do serviço. Ao clicar no banner, o usuário será direcionado para esta página em uma WebView interna, mantendo a navegação dentro do aplicativo.',
          balada_app_create_label_image: 'Imagem*:',
          balada_app_create_help_text: 'Formato: PNG, JPG ou JPEG | Proporção: 4:3 ou 16:9',
          balada_app_create_cancel: 'Cancelar',
          balada_app_create_create: 'Criar',
          balada_app_create_success: 'BaladAPP criado com sucesso!',
          balada_app_create_error: 'Não foi possível criar o BaladAPP. Tente novamente',

          schema: {
            required: 'Campo obrigatório',
            identifier_max: 'O identificador deve ter no máximo 20 caracteres',
            required_file: 'Imagem obrigatória',
            invalid_file: 'Extensão inválida. Utilize .jpg, .jpeg ou .png',
          },
        },

        balada_app_edit_modal: {
          balada_app_edit_title: 'Editar BaladAPP',
          balada_app_edit_label_title: 'Título*:',
          balada_app_edit_label_identifier: 'Identificador*:',
          balada_app_edit_label_type: 'Tipo*:',
          balada_app_edit_type_others: 'Outros',
          balada_app_edit_type_tickets: 'Ingressos',
          balada_app_edit_type_memberships: 'Sócio-torcedor',
          balada_app_edit_label_url: 'Link*:',
          balada_app_edit_help_url: 'Informe a URL do serviço. Ao clicar no banner, o usuário será direcionado para esta página em uma WebView interna, mantendo a navegação dentro do aplicativo.',
          balada_app_edit_label_image: 'Imagem:',
          balada_app_edit_help_text: 'Formato: PNG, JPG ou JPEG | Proporção: 4:3 ou 16:9',
          balada_app_edit_cancel: 'Cancelar',
          balada_app_edit_save: 'Salvar alterações',
          balada_app_edit_success: 'BaladAPP alterado com sucesso!',
          balada_app_edit_error: 'Não foi possível alterar o BaladAPP. Tente novamente.',

          schema: {
            required: 'Campo obrigatório',
            identifier_max: 'O identificador deve ter no máximo 20 caracteres',
            invalid_file: 'Extensão inválida. Utilize .jpg, .jpeg ou .png',
          },
        },

        balada_app_filter_box: {
          balada_app_filter_filter_heading: 'Filtros',
          balada_app_filter_title_label: 'Título:',
          balada_app_filter_type_label: 'Tipo:',
          balada_app_filter_all_option: 'Todos',
          balada_app_filter_type_others: 'Outros',
          balada_app_filter_type_tickets: 'Ingressos',
          balada_app_filter_type_memberships: 'Sócio-torcedor',
          balada_app_filter_start_date_label: 'Data inicial:',
          balada_app_filter_end_date_label: 'Data final:',
          balada_app_filter_clear_button: 'Limpar filtros',
        },

        balada_app_table: {
          balada_app_table_created_at_header: 'DATA DA CRIAÇÃO',
          balada_app_table_title_header: 'TÍTULO',
          balada_app_table_type_header: 'TIPO',
          balada_app_table_actions_header: 'AÇÕES',
          balada_app_table_menu_aria_label: 'Mostrar mais ações',
          balada_app_table_view_details: 'Detalhes',
          balada_app_table_delete: 'Excluir',
        },
      },

      breadcrumb: {
        balada_app_label1: 'APLICATIVO',
        balada_app_label2: 'BANNERS BALADAPP',
      },

      balada_app_page_title: 'BANNERS BALADAPP',
      balada_app_label: 'Banners BaladApp',
      balada_app_description: 'Gerencie os banners internos do aplicativo. Utilize este espaço para divulgar serviços e campanhas do clube. Os links configurados serão abertos em uma WebView interna, mantendo o torcedor dentro do app.',
      balada_app_enabled: 'Habilitado',
      balada_app_disabled: 'Desabilitado',
      balada_app_create_button: 'Criar BaladAPP',
      balada_app_area_enabled_success: 'Área do BaladAPP habilitada com sucesso',
      balada_app_area_disabled_success: 'Área do BaladAPP desabilitada com sucesso',
      balada_app_area_enable_error: 'Ocorreu um erro ao habilitar a área do BaladAPP',
      balada_app_area_disable_error: 'Ocorreu um erro ao desabilitar a área do BaladAPP',
      balada_app_deleted_success: 'BaladAPP deletado com sucesso!',
      balada_app_delete_error: 'Ocorreu um erro ao deletar. Recarregue e tente novamente.',
      balada_app_not_found: 'BaladAPP não encontrado',
      balada_app_delete_title: 'Excluir BaladAPP',
      balada_app_delete_description: 'Tem certeza que deseja excluir o BaladAPP',
      balada_app_component_title: 'BaladAPP',
      balada_app_component_description_enabled: 'Tem certeza que deseja habilitar este componente?',
      balada_app_component_description_disabled: 'Tem certeza que deseja desabilitar este componente?',
    },

    application_polls: {
      components: {
        polls_create_modal: {
          polls_create_title: 'Criar enquete',
          polls_create_team_label: 'Time:',
          polls_create_label: 'Identificador da enquete*:',
          polls_create_helper_text: '(Máx. de caracteres: 20)',
          polls_create_label_enq: 'Título da enquete*:',
          polls_create_helper_text_100: '(Máx. de caracteres: 100)',
          polls_create_title_response: 'Opções de resposta*:',
          polls_create_option_label: 'Opção {{index}}*:',
          polls_create_helper_text_50: '(Máx. de caracteres: 50)',
          polls_create_image_label: 'Imagem*',
          polls_create_label_date: 'Data de encerramento da enquete*:',
          polls_create_has_closing_date: 'Definir data de encerramento da enquete',
          polls_create_allow_multiple_votes: 'Permitir votar na enquete mais de uma vez',
          polls_create_show_partial_results: 'Exibir resultado parcial',
          polls_create_disable_comments: 'Desativar comentários',
          polls_create_enable_home: 'Ativar na página inicial',
          polls_create_save_option: 'Salvar',
          polls_create_add_option: 'Adicionar opção',
          polls_create_save_draft: 'Salvar como rascunho',
          polls_create_cancel: 'Cancelar',
          polls_create_create: 'Criar',
          polls_create_create_success: 'Enquete criada com sucesso!',
          polls_create_create_error: 'Ocorreu um erro ao criar enquete. Tente novamente!',

          schema: {
            required: 'Campo obrigatório',
            required_image: 'Imagem obrigatória',
            required_uuid: 'UUID necessário',
            required_options: 'Necessário ao menos 2 opções de resposta',
            max_options: 'Máximo de 25 opções de resposta',
          },
        },

        polls_edit_modal: {
          polls_edit_title: 'Editar enquete',
          polls_published_label: 'Publicado',
          polls_edit_team_label: 'Time:',
          polls_edit_label: 'Identificador da enquete*:',
          polls_edit_helper_text_20: '(Máx. de caracteres: 20)',
          polls_edit_label_enq: 'Título da enquete*:',
          polls_edit_helper_text_100: '(Máx. de caracteres: 100)',
          polls_edit_title_response: 'Opções de resposta*:',
          polls_edit_option_label: 'Opção {{index}}*:',
          polls_edit_helper_text_50: '(Máx. de caracteres: 50)',
          polls_edit_image_label: 'Imagem*',
          polls_edit_label_date: 'Data de encerramento da enquete*:',
          polls_edit_has_closing_date: 'Definir data de encerramento da enquete',
          polls_edit_allow_multiple_votes: 'Permitir votar na enquete mais de uma vez',
          polls_edit_show_partial_results: 'Exibir resultado parcial',
          polls_edit_disable_comments: 'Desativar comentários',
          polls_edit_enable_home: 'Ativar na página inicial',
          polls_edit_save_option: 'Salvar',
          polls_edit_add_option: 'Adicionar opção',
          polls_edit_cancel: 'Cancelar',
          polls_edit_save_changes: 'Salvar alterações',
          polls_edit_update_success: 'Enquete atualizada com sucesso!',
          polls_edit_update_error: 'Ocorreu um erro ao atualizar enquete. Tente novamente!',

          schema: {
            required: 'Campo obrigatório',
            required_image: 'Imagem obrigatória',
            required_uuid: 'UUID necessário',
            required_options: 'Necessário ao menos 2 opções de resposta',
            max_options: 'Máximo de 25 opções de resposta',
          },
        },

        polls_filters_box: {
          polls_filters_heading: 'Filtros',
          polls_filters_poll_label: 'Enquete:',
          polls_filters_status_label: 'Situação:',
          polls_filters_team_label: 'Time:',
          polls_filters_team_all_option: 'Todos',
          polls_filters_interactivity_label: 'Interação:',
          polls_filters_status_all_option: 'Todas',
          polls_filters_interactivity_all_option: 'Todos',
          polls_filters_utton_clear: 'Limpar filtros',
        },

        polls_table: {
          polls_table_created_at_header: 'DATA DA CRIAÇÃO',
          polls_table_updated_at_header: 'DATA DA PUBLICAÇÃO',
          polls_table_team_header: 'TIME',
          polls_table_question_header: 'TÍTULO',
          polls_table_identifier_header: 'IDENTIFICADOR',
          polls_table_total_participants_header: 'PARTICIPAÇÕES',
          polls_table_total_comments_header: 'COMENTÁRIOS',
          polls_table_status_header: 'SITUAÇÃO',
          polls_table_interactivity_header: 'INTERAÇÃO',
          polls_table_actions_header: 'AÇÕES',
          polls_table_finish_button: 'Encerrar enquete',
          polls_table_view_result: 'Ver resultado',
          polls_table_menu_button_label: 'Mostrar mais ações',
          polls_table_edit_menu_item: 'Editar enquete',
          polls_table_delete_menu_item: 'Excluir enquete',
        },

        polls_result_detail_modal: {
          polls_result_detail_title: 'Resultado da enquete',
          polls_result_detail_identifier: 'Identificador da enquete:',
          polls_result_detail_question: 'Título da enquete:',
          polls_result_detail_start_date: 'Data de início:',
          polls_result_detail_closing_date: 'Data de encerramento:',
          polls_result_detail_total_participants: 'Total de participações',
          polls_result_detail_result: 'Resultado',
          polls_result_detail_empty: 'Nenhum voto registrado até o momento.',
          polls_result_detail_close: 'Fechar',
        },
      },

      breadcrumb: {
        polls_label1: 'APLICATIVO',
        polls_label2: 'ÁREA INTERATIVA',
        polls_label3: 'ENQUETES',
      },

      application_polls_page_title: 'ENQUETES',
      application_polls_create_button: 'Criar enquete',
      application_polls_section_label: 'Enquete',
      application_polls_switch_enabled: 'Habilitado',
      application_polls_switch_disabled: 'Desabilitado',
      application_polls_enable_success: 'Enquete habilitada com sucesso',
      application_polls_disable_success: 'Enquete desabilitada com sucesso',
      application_polls_enable_error: 'Ocorreu um erro ao habilitar a enquete. Recarregue a página e tente novamente.',
      application_polls_disable_error: 'Ocorreu um erro ao desabilitar a enquete. Recarregue a página e tente novamente.',
      application_polls_not_found_error: 'Enquete não encontrada.',
      application_polls_result_error: 'Ocorreu um erro ao carregar o resultado da enquete. Tente novamente.',
      application_polls_finish_success: 'Enquete encerrada com sucesso!',
      application_polls_finish_error: 'Erro ao encerrar enquete. Tente novamente',
      application_polls_delete_success: 'Enquete deletada com sucesso!',
      application_polls_delete_error: 'Ocorreu um erro ao deletar a enquete. Tente novamente.',
      application_polls_finish_modal_title: 'Encerrar enquete',
      application_polls_finish_modal_description:
        'Tem certeza que deseja encerrar essa enquete? Caso esteja publicado, ela continuará sendo exibida no aplicativo, mas não permitirá mais participações dos usuários.',
      application_polls_delete_modal_title: 'Excluir enquete',
      application_polls_delete_modal_description_prefix: 'Tem certeza que deseja excluir a enquete ',
      application_polls_toggle_modal_title: 'Enquete',
      application_polls_enable_modal_description: 'Tem certeza que deseja habilitar este componente?',
      application_polls_disable_modal_description: 'Tem certeza que deseja desabilitar este componente?',
    },

    application_posts: {
      components: {
        media_field: {
          media_field_add_media_label: 'Adicionar mídia*:',
          media_field_max_files_helper: 'Máximo: 5 arquivos',
          media_field_file_already_selected_warning: 'Arquivo já selecionado',
        },

        posts_create_modal: {
          posts_create_title: 'Criar post',
          posts_create_identifier_label: 'Identificador do post*:',
          posts_create_team_label: 'Time:',
          posts_create_identifier_helper_text: '(Máx. de caracteres: 20)',
          posts_create_content_label: 'Legenda do post*:',
          posts_create_content_helper_text: '(Máx. de caracteres: 500)',
          posts_create_disable_comments_label: 'Desativar comentários',
          posts_create_enable_home_label: 'Ativar na página inicial',
          posts_create_button_save_draft: 'Salvar como rascunho',
          posts_create_button_cancel: 'Cancelar',
          posts_create_button_create: 'Criar',
          posts_create_success: 'Post criado com sucesso!',
          posts_create_error: 'Erro ao criar post. Tente novamente!',

          schema: {
            identifier_required: 'Campo obrigatório',
            posts_media_required: 'Selecione pelo menos uma mídia',
          },
        },

        posts_edit_modal: {
          posts_edit_title: 'Editar post',
          posts_edit_published_label: 'Publicado',
          posts_edit_identifier_label: 'Identificador do post*:',
          posts_edit_team_label: 'Time:',
          posts_edit_identifier_helper_text: '(Máx. de caracteres: 20)',
          posts_edit_content_label: 'Legenda do post*:',
          posts_edit_content_helper_text: '(Máx. de caracteres: 500)',
          posts_edit_disable_comments_label: 'Desativar comentários',
          posts_edit_enable_home_label: 'Ativar na página inicial',
          posts_edit_button_cancel: 'Cancelar',
          posts_edit_button_save: 'Salvar alterações',
          posts_edit_success: 'Post atualizado com sucesso!',
          posts_edit_error: 'Erro ao atualizar post. Tente novamente!',

          schema: {
            identifier_required: 'Campo obrigatório',
            posts_media_required: 'Selecione pelo menos uma mídia',
          },
        },
        posts_filters_box: {
          posts_filters_title: 'Filtros',
          posts_filters_content_label: 'Post:',
          posts_filters_team_label: 'Time:',
          posts_filters_team_option_all: 'Todos',
          posts_filters_status_label: 'Situação:',
          posts_filters_status_option_all: 'Todas',
          posts_filters_status_option_published: 'Publicado',
          posts_filters_status_option_not_published: 'Não publicado',
          posts_filters_status_option_draft: 'Rascunho',
          posts_filters_button_clear: 'Limpar filtros',
        },

        posts_table: {
          posts_table_status_published: 'Publicado',
          posts_table_status_not_published: 'Não publicado',
          posts_table_status_draft: 'Rascunho',
          posts_table_status_deleted: 'Deletado',
          posts_table_header_team: 'TIME',
          posts_table_header_created_at: 'DATA DA CRIAÇÃO',
          posts_table_header_updated_at: 'DATA DA PUBLICAÇÃO',
          posts_table_header_content: 'LEGENDA',
          posts_table_header_identifier: 'IDENTIFICADOR',
          posts_table_header_total_likes: 'CURTIDAS',
          posts_table_header_total_comments: 'COMENTÁRIOS',
          posts_table_header_status: 'STATUS',
          posts_table_header_actions: 'AÇÕES',
          posts_table_actions_aria_label: 'Mostrar mais ações',
          posts_table_action_edit: 'Editar post',
          posts_table_action_delete: 'Excluir post',
        },
      },

      breadcrumb: {
        posts_label1: 'APLICATIVO',
        posts_label2: 'ÁREA INTERATIVA',
        posts_label3: 'POSTS',
      },

      post_title: 'POSTS',
      post_button_create: 'Criar post',
      post_posts_label: 'Posts',
      post_enabled_label: 'Habilitado',
      post_disabled_label: 'Desabilitado',
      post_enable_success: 'Posts habilitada com sucesso',
      post_disable_success: 'Posts desabilitada com sucesso',
      post_enable_error: 'Ocorreu um erro ao habilitar o Posts. Recarregue a página e tente novamente.',
      post_disable_error: 'Ocorreu um erro ao desabilitar o Posts. Recarregue a página e tente novamente.',
      post_delete_success: 'Post deletado com sucesso!',
      post_delete_error: 'Ocorreu um erro ao deletar o post. Tente novamente.',
      post_delete_modal_title: 'Excluir post',
      post_delete_modal_description: 'Tem certeza que deseja excluir o post',
      post_toggle_modal_title: 'Post',
      post_toggle_modal_description_enable: 'Tem certeza que deseja habilitar este componente?',
      post_toggle_modal_description_disable: 'Tem certeza que deseja desabilitar este componente?',
    },

    application_predictions: {
      components: {
        predictions_create_modal: {
          predictions_create_title: 'Criar palpite',
          predictions_create_identifier_label: 'Identificador do palpite*:',
          predictions_create_team_label: 'Time:',
          predictions_create_identifier_helper_text: '(Máx. de caracteres: 20)',
          predictions_create_title_label: 'Título*:',
          predictions_create_title_helper_text: '(Máx. de caracteres: 50)',
          predictions_create_description_label: 'Descrição*:',
          predictions_create_description_helper_text: '(Máx. de caracteres: 100)',
          predictions_create_prediction_label: 'Palpite*:',
          predictions_create_image_label: 'Imagem*',
          predictions_create_option_1_label: 'Opção 1*:',
          predictions_create_option_1_helper_text: '(Máx. de caracteres: 50)',
          predictions_create_option_2_label: 'Opção 2*:',
          predictions_create_option_2_helper_text: '(Máx. de caracteres: 50)',
          predictions_create_closing_date_label: 'Data de encerramento do palpite*:',
          predictions_create_set_closing_date: 'Definir data de encerramento do palpite',
          predictions_create_disable_comments: 'Desativar comentários',
          predictions_create_enable_home: 'Ativar na página inicial',
          predictions_create_save_as_draft: 'Salvar como rascunho',
          predictions_create_cancel: 'Cancelar',
          predictions_create_create: 'Criar',
          predictions_create_success: 'Palpite criado com sucesso!',
          predictions_create_error: 'Ocorreu um erro ao criar palpite. Tente novamente!',

          schema: {
            required: 'Campo obrigatório',
            required_image: 'Imagem obrigatória',
          },
        },

        predictions_edit_modal: {
          predictions_edit_title: 'Editar palpite',
          predictions_edit_published_label: 'Publicado',
          predictions_edit_identifier_label: 'Identificador do palpite*:',
          predictions_edit_team_label: 'Time:',
          predictions_edit_identifier_helper_text: '(Máx. de caracteres: 20)',
          predictions_edit_title_label: 'Título*:',
          predictions_edit_title_helper_text: '(Máx. de caracteres: 50)',
          predictions_edit_description_label: 'Descrição*:',
          predictions_edit_description_helper_text: '(Máx. de caracteres: 100)',
          predictions_edit_prediction_label: 'Palpite*:',
          predictions_edit_image_label: 'Imagem*',
          predictions_edit_option_1_label: 'Opção 1*:',
          predictions_edit_option_1_helper_text: '(Máx. de caracteres: 50)',
          predictions_edit_option_2_label: 'Opção 2*:',
          predictions_edit_option_2_helper_text: '(Máx. de caracteres: 50)',
          predictions_edit_closing_date_label: 'Data de encerramento do palpite*:',
          predictions_edit_set_closing_date: 'Definir data de encerramento do palpite',
          predictions_edit_disable_comments: 'Desativar comentários',
          predictions_edit_enable_home: 'Ativar na página inicial',
          predictions_edit_cancel: 'Cancelar',
          predictions_edit_save_changes: 'Salvar alterações',
          predictions_edit_success: 'Palpite atualizado com sucesso!',
          predictions_edit_error: 'Ocorreu um erro ao atualizar palpite. Tente novamente!',

          schema: {
            required: 'Campo obrigatório',
            required_image: 'Imagem obrigatória',
          },
        },

        predictions_filters_box: {
          predictions_filters_title: 'Filtros',
          predictions_filters_poll_label: 'Enquete:',
          predictions_filters_team_label: 'Time:',
          predictions_filters_team_option_all: 'Todos',
          predictions_filters_status_label: 'Situação:',
          predictions_filters_interactivity_label: 'Interação:',
          predictions_filters_status_all: 'Todas',
          predictions_filters_interactivity_all: 'Todos',
          predictions_filters_clear_filters: 'Limpar filtros',
        },

        predictions_result_modal: {
          predictions_result_title: 'Inserir resultado do palpite',
          predictions_result_cancel: 'Cancelar',
          predictions_result_confirm: 'Confirmar',
          predictions_result_success: 'Resultado salvo com sucesso!',
          predictions_result_error: 'Ocorreu um erro ao salvar resultado. Tente novamente!',
        },

        predictions_table: {
          predictions_table_created_at_header: 'DATA DA CRIAÇÃO',
          predictions_table_updated_at_header: 'DATA DA PUBLICAÇÃO',
          predictions_table_title_header: 'TÍTULO',
          predictions_table_identifier_header: 'IDENTIFICADOR',
          predictions_table_team_header: 'TIME',
          predictions_table_total_participants_header: 'PARTICIPAÇÕES',
          predictions_table_total_comments_header: 'COMENTÁRIOS',
          predictions_table_status_header: 'SITUAÇÃO',
          predictions_table_interactivity_header: 'INTERAÇÃO',
          predictions_table_actions_header: 'AÇÕES',
          predictions_table_insert_result: 'Inserir resultado',
          predictions_table_finish_prediction: 'Encerrar palpite',
          predictions_table_view_result: 'Ver resultado',
          predictions_table_edit_prediction: 'Editar palpite',
          predictions_table_delete_prediction: 'Excluir palpite',
          predictions_table_show_more_actions: 'Mostrar mais ações',
        },

        predictions_result_detail_modal: {
          predictions_result_detail_title: 'Resultado do palpite',
          predictions_result_detail_identifier: 'Identificador do palpite:',
          predictions_result_detail_title_field: 'Título do palpite:',
          predictions_result_detail_description: 'Descrição do palpite:',
          predictions_result_detail_start_date: 'Data de início:',
          predictions_result_detail_closing_date: 'Data de encerramento:',
          predictions_result_detail_total_participants: 'Total de participações',
          predictions_result_detail_total_hits: 'Total de acertos',
          predictions_result_detail_official_result: 'Resultado oficial',
          predictions_result_detail_predictions_list: 'Palpites',
          predictions_result_detail_empty: 'Nenhum palpite registrado até o momento.',
          predictions_result_detail_close: 'Fechar',
        },

        predictions_ranking_modal: {
          predictions_ranking_title: 'Ranking dos Palpites',
          predictions_ranking_fan_header: 'Torcedor',
          predictions_ranking_hits_header: 'Acertos',
          predictions_ranking_percentage_header: 'Aproveitamento',
          predictions_ranking_empty: 'Nenhum torcedor no ranking até o momento.',
          predictions_ranking_close: 'Fechar',
        },

        predictions_result_modal_two: {
          predictions_result_title: 'Inserir resultado do palpite',
          predictions_result_cancel: 'Cancelar',
          predictions_result_confirm: 'Confirmar',
          predictions_result_success: 'Resultado salvo com sucesso!',
          predictions_result_error: 'Ocorreu um erro ao salvar resultado. Tente novamente!',
        },
      },

      breadcrumb: {
        predictions_label1: 'APLICATIVO',
        predictions_label2: 'ÁREA INTERATIVA',
        predictions_label3: 'PALPITES',
      },
      application_predictions_title: 'PALPITES',
      application_predictions_create_button: 'Criar palpite',
      application_predictions_ranking_button: 'Ver ranking',
      application_predictions_ranking_error: 'Ocorreu um erro ao carregar o ranking dos palpites. Tente novamente.',
      application_predictions_label: 'Palpites',
      application_predictions_enabled: 'Habilitado',
      application_predictions_disabled: 'Desabilitado',
      application_predictions_enable_success: 'Palpite habilitado com sucesso',
      application_predictions_disable_success: 'Palpite desabilitado com sucesso',
      application_predictions_enable_error: 'Ocorreu um erro ao habilitar o palpite. Recarregue a página e tente novamente.',
      application_predictions_disable_error: 'Ocorreu um erro ao desabilitar o palpite. Recarregue a página e tente novamente.',
      application_predictions_finish_success: 'Palpite encerrado com sucesso!',
      application_predictions_finish_error: 'Erro ao encerrar palpite. Tente novamente',
      application_predictions_delete_success: 'Palpite deletado com sucesso!',
      application_predictions_delete_error: 'Ocorreu um erro ao deletar a palpite. Tente novamente.',
      application_predictions_not_found_error: 'Material exclusivo não encontrado.',
      application_predictions_result_error: 'Ocorreu um erro ao carregar o resultado do palpite. Tente novamente.',
      application_predictions_finish_modal_title: 'Encerrar palpite',
      application_predictions_finish_modal_description:
        'Tem certeza que deseja encerrar esse palpite? Caso esteja publicado, ela continuará sendo exibida no aplicativo, mas não permitirá mais participações dos usuários.',
      application_predictions_delete_modal_title: 'Excluir palpite',
      application_predictions_delete_modal_description: 'Tem certeza que deseja excluir o palpite',
      application_predictions_toggle_modal_title: 'Palpite',
      application_predictions_toggle_modal_enable_description: 'Tem certeza que deseja habilitar este componente?',
      application_predictions_toggle_modal_disable_description: 'Tem certeza que deseja desabilitar este componente?',
    },

    application_quiz: {
      components: {
        create_quiz_modal: {
          question: {
            question_create_success: 'Pergunta criada com sucesso!',
            question_create_error: 'Ocorreu um erro ao criar quiz. Tente novamente!',
            question_label: 'Pergunta*:',
            question_helper_text: '(Máx. de caracteres: 100)',
            question_image_label: 'Imagem da pergunta:',
            question_image_help_text: 'Formato: PNG, JPG ou JPEG | Proporção: 4:3 ou 16:9',
            question_answer_label: 'Alternativa *:',
            question_add_answer_button: 'Adicionar alternativa',
            question_save_draft_button: 'Salvar Quiz como rascunho',
            question_add_question_button: 'perguntas',
            question_save_publish_button: 'Salvar e Publicar Quiz',

            schema: {
              required: 'Campo obrigatório',
              required_max_50: 'Máximo de 50 caracteres',
              required_file: 'Extensão inválida. Utilize .jpg, .jpeg ou .png',
              required_max_30: 'Máximo de 30 caracteres',
              required_min: 'Adicione pelo menos 2 alternativas',
              required_max: 'Adicione no máximo 5 alternativas',
              required_answers_min: 'Selecione uma alternativa correta',
              required_answers_max: 'Selecione apenas uma alternativa correta',
            },
          },

          quiz: {
            quiz_create_success: 'Quiz criado com sucesso!',
            quiz_create_error: 'Ocorreu um erro ao criar quiz. Tente novamente!',
            quiz_identifier_label: 'Identificador do quiz*:',
            quiz_identifier_helper_text: '(Máx. de caracteres: 20)',
            quiz_title_label: 'Título do quiz*:',
            quiz_title_helper_text: '(Máx. de caracteres: 100)',
            quiz_closing_date_label: 'Definir data de término',
            quiz_enable_home_label: 'Ativar na página inicial',
            quiz_date_label: 'Data:',
            quiz_cover_image_label: 'Imagem de capa do resultado:',
            quiz_cover_image_help_text: 'Formato: PNG, JPG ou JPEG | Proporção: 4:3 ou 16:9',
            quiz_cancel_button: 'Cancelar',
            quiz_add_questions_button: 'Adicionar Perguntas',

            schema: {
              required: 'Campo obrigatório',
              identifier_max: 'Máximo de 20 caracteres',
              title_max: 'Máximo de 100 caracteres',
              file_invalid: 'Extensão inválida. Utilize .jpg, .jpeg ou .png',
              date_required: 'Selecione uma data',
            },

            create_quiz_modal: {
              modal_publish_success: 'Quiz publicado com sucesso!',
              modal_publish_error: 'Ocorreu um erro ao publicar o quiz. Tente novamente!',
              modal_create_quiz_label: 'Criar Quiz',
              modal_add_questions_label: 'Adicionar Perguntas',
            },
          },
        },

        edit_quiz_modal: {
          question: {
            question_create_success: 'Pergunta criada com sucesso!',
            question_create_error: 'Ocorreu um erro ao criar a pergunta. Tente novamente!',
            question_label: 'Pergunta*:',
            question_helper_text: '(Máx. de caracteres: 100)',
            question_image_label: 'Imagem da pergunta:',
            question_image_help_text: 'Formato: PNG, JPG ou JPEG | Proporção: 4:3 ou 16:9',
            question_answer_label: 'Alternativa *:',
            question_add_answer_button: 'Adicionar alternativa',
            question_cancel_button: 'Cancelar',
            question_add_question_button: 'Adicionar pergunta',

            schema: {
              required: 'Campo obrigatório',
              required_max_50: 'Máximo de 50 caracteres',
              required_file: 'Extensão inválida. Utilize .jpg, .jpeg ou .png',
              required_max_30: 'Máximo de 30 caracteres',
              required_min: 'Adicione pelo menos 2 alternativas',
              required_max: 'Adicione no máximo 5 alternativas',
              required_answers_min: 'Selecione uma alternativa correta',
              required_answers_max: 'Selecione apenas uma alternativa correta',
            },
          },

          edit_question: {
            edit_question_save_success: 'Pergunta salva com sucesso!',
            edit_question_save_error: 'Ocorreu um erro ao salvar pergunta. Tente novamente!',
            edit_question_label: 'Pergunta*:',
            edit_question_helper_text: '(Máx. de caracteres: 100)',
            edit_question_image_label: 'Imagem da pergunta:',
            edit_question_image_help_text: 'Formato: PNG, JPG ou JPEG | Proporção: 4:3 ou 16:9',
            edit_question_answer_label: 'Alternativa *:',
            edit_question_add_answer_button: 'Adicionar alternativa',
            edit_question_cancel_button: 'Cancelar',
            edit_question_save_button: 'Salvar alterações',

            schema: {
              required: 'Campo obrigatório',
              required_max_50: 'Máximo de 50 caracteres',
              required_file: 'Extensão inválida. Utilize .jpg, .jpeg ou .png',
              required_max_30: 'Máximo de 30 caracteres',
              required_min: 'Adicione pelo menos 2 alternativas',
              required_max: 'Adicione no máximo 5 alternativas',
              required_answers_min: 'Selecione uma alternativa correta',
              required_answers_max: 'Selecione apenas uma alternativa correta',
            },
          },

          quiz: {
            quiz_update_success: 'Quiz atualizado com sucesso!',
            quiz_update_error: 'Ocorreu um erro ao atualizar o quiz. Tente novamente!',
            quiz_close_success: 'Quiz encerrado com sucesso!',
            quiz_close_error: 'Ocorreu um erro ao encerrar o quiz. Tente novamente!',
            quiz_edit_label: 'Editar Quiz',
            quiz_published_label: 'Publicada',
            quiz_identifier_label: 'Identificador do quiz*:',
            quiz_identifier_helper_text: '(Máx. de caracteres: 20)',
            quiz_title_label: 'Título do quiz*:',
            quiz_title_helper_text: '(Máx. de caracteres: 100)',
            quiz_closing_date_label: 'Definir data de término',
            quiz_enable_home_label: 'Ativar na página inicial',
            quiz_date_label: 'Data:',
            quiz_cover_image_label: 'Imagem de capa do resultado:',
            quiz_cover_image_help_text: 'Formato: PNG, JPG ou JPEG | Proporção: 4:3 ou 16:9',
            quiz_image_label: 'Imagem',
            quiz_questions_label: 'Perguntas:',
            quiz_add_question_button: 'Adicionar pergunta',
            quiz_close_button: 'encerrar quiz',
            quiz_cancel_button: 'Cancelar',
            quiz_save_button: 'Salvar alterações',

            schema: {
              required: 'Campo obrigatório',
              identifier_max: 'Máximo de 20 caracteres',
              title_max: 'Máximo de 100 caracteres',
              file_invalid: 'Extensão inválida. Utilize .jpg, .jpeg ou .png',
              date_required: 'Selecione uma data',
            },
          },

          question_item: {
            question_delete_success: 'Pergunta excluída com sucesso!',
            question_delete_error: 'Erro ao excluir pergunta. Tente novamente',
            question_label: 'Pergunta {{index}}:',
            question_cancel_button: 'cancelar',
            question_delete_button: 'excluir',
          },
        },

        quiz_filters: {
          filter_title: 'Filtros',
          filter_quiz_label: 'Quiz:',
          filter_status_label: 'Situação:',
          filter_status_all: 'Todas',
          filter_status_published: 'Publicado',
          filter_status_unpublished: 'Não publicado',
          filter_status_draft: 'Rascunho',
          filter_interactivity_label: 'Interação:',
          filter_interactivity_all: 'Todos',
          filter_interactivity_active: 'Ativo',
          filter_interactivity_closed: 'Encerrado',
          filter_clear_button: 'Limpar filtros',
        },

        quiz_table: {
          table_status_published: 'Publicado',
          table_status_unpublished: 'Não publicado',
          table_status_draft: 'Rascunho',
          table_status_deleted: 'Deletado',
          table_interactivity_active: 'Ativo',
          table_interactivity_closed: 'Encerrado',
          table_created_at_header: 'DATA DA CRIAÇÃO',
          table_published_at_header: 'DATA DA PUBLICAÇÃO',
          table_title_header: 'TÍTULO',
          table_identifier_header: 'IDENTIFICADOR',
          table_participants_header: 'PARTICIPAÇÕES',
          table_accuracy_header: 'ACERTOS (%)',
          table_status_header: 'STATUS',
          table_interactivity_header: 'INTERAÇÃO',
          table_end_quiz_button: 'Encerrar quiz',
          table_actions_header: 'AÇÕES',
          table_actions_aria_label: 'Mostrar mais ações',
          table_edit_quiz_action: 'Editar quiz',
          table_delete_quiz_action: 'Excluir quiz',
        },
      },

      breadcrumb: {
        quizz_label1: 'APLICATIVO',
        quizz_label2: 'ÁREA INTERATIVA',
        quizz_label3: 'QUIZZES',
      },

      quiz_title: 'QUIZZ',
      quiz_create_button: 'Criar quiz',
      quiz_section_title: 'Quizzes',
      quiz_enabled_label: 'Habilitado',
      quiz_disabled_label: 'Desabilitado',
      quiz_enable_success: 'Área quizzes habilitada com sucesso',
      quiz_disable_success: 'Área quizzes desabilitada com sucesso',
      quiz_enable_error: 'Ocorreu um erro ao habilitar área de quizzes. Recarregue a página e tente novamente.',
      quiz_disable_error: 'Ocorreu um erro ao desabilitar área de quizzes. Recarregue a página e tente novamente.',
      quiz_total_quizzes_label: 'TOTAL DE QUIZZES',
      quiz_participations_label: 'PARTICIPAÇÕES',
      quiz_delete_success: 'Quiz excluído com sucesso!',
      quiz_delete_error: 'Erro ao excluir quiz. Tente novamente',
      quiz_end_success: 'Quiz encerrado com sucesso!',
      quiz_end_error: 'Ocorreu um erro ao encerrar o quiz. Tente novamente!',
      quiz_not_found_error: 'Quiz não encontrado.',
      quiz_enable_component_description: 'Tem certeza que deseja habilitar este componente?',
      quiz_disable_component_description: 'Tem certeza que deseja desabilitar este componente?',
      quiz_delete_modal_title: 'Excluir quiz',
      quiz_delete_modal_description: 'Tem certeza que deseja excluir esse quizz?',
      quiz_delete_confirm_button: 'Excluir',
      quiz_end_modal_title: 'Encerrar quiz',
      quiz_end_modal_description: 'Tem certeza que deseja encerrar esse quizz?',
      quiz_end_confirm_button: 'Encerrar',
    },

    application_social_media: {
      breadcrumb: {
        social_media_app_label: 'APLICATIVO',
        social_media_label: 'REDES SOCIAIS',
        social_media_links_label: 'Canais Oficiais',
        social_media_feed_label: 'FEED',
        social_media_influencers_label: 'INFLUENCERS',
        social_media_virais_label: 'POST VIRAIS',
      },

      social_media_title: 'REDES SOCIAIS',
      social_media: 'Redes Sociais',
      social_media_area_toggled_enable: 'Área de redes sociais habilitado com sucesso',
      social_media_area_toggled_disable: 'Área de redes sociais desabilitado com sucesso',
      social_media_enabled: 'Habilitado',
      social_media_disabled: 'Desabilitado',
      social_media_description_enabled: 'Tem certeza que deseja habilitar este componente?',
      social_media_description_disabled: 'Tem certeza que deseja desabilitar este componente?',
      social_media_links: {
        title_links: 'Canais Oficiais',
        failed_enable: 'Ocorreu um erro ao habilitado área de redes sociais. Recarregue a página e tente novamente.',
        failed_disable: 'Ocorreu um erro ao desabilitado área de redes sociais. Recarregue a página e tente novamente.',
        toggled_enable: 'Área de links habilitada com sucesso',
        toggled_disable: 'Área de links desabilitada com sucesso',
      },
      social_media_feed: {
        failed_enable: 'Ocorreu um erro ao habilitado área de redes sociais. Recarregue a página e tente novamente.',
        failed_disable: 'Ocorreu um erro ao desabilitado área de redes sociais. Recarregue a página e tente novamente.',
        toggled_enable: 'Área de links habilitada com sucesso',
        toggled_disable: 'Área de links desabilitada com sucesso',
      },
      social_media_post_viral: {
        title: 'Posts Virais',
        enabled: 'Habilitado',
        disabled: 'Desabilitado',
        add_button: 'Adicionar nova postagem viral',
        delete_title: 'Excluir post viral',
        delete_description: 'Tem certeza que deseja excluir o post viral {{team}} ?',
        delete_success: 'Post viral deletado com sucesso!',
        delete_error: 'Ocorreu um erro ao deletar o post viral. Tente novamente.',
        search_error: 'Post virtal não encontrado.',
        toggle_description: 'Tem certeza que deseja habilitar este componente?',
        toggle_description_disabled: 'Tem certeza que deseja desabilitar este componente?',
        toggled_enable_success: 'Área de Posts Virais ativada com sucesso',
        toggled_disable_success: 'Área de Posts Virais desativada com sucesso',
        failed_enable_error: 'Ocorreu um erro ao ativar a área de posts virais. Recarregue a página e tente novamente.',
        failed_disable_error: 'Ocorreu um erro ao desativar a área de posts virais. Recarregue a página e tente novamente.',
        table: {
          created_at: 'DATA DA CRIAÇÃO',
          team: 'TIME',
          enabled: 'EXIBIR NA VITRINE',
          total: 'Virais',
          show_more_actions: 'Mostrar mais ações',
          view_details: 'Editar',
          delete: 'Excluir',
        },
        filter_box: {
          filter_box_title: 'Filtros',
          filter_box_team: 'Time:',
          filter_box_team_select_all: 'Todos',
          filter_box_clear: 'Limpar filtros',
        },
        modal_edit: {
          team: 'Time:',
          edit_title: 'Editar post viral',
          placeholder_url: 'Cole o link do post viral (ex: https://twitter.com/...)',
          add_button: 'Adicionar link',
          limit_reached: 'Limite de {{count}} posts atingido',
          enable_area: 'Exibir na vitrine',
          save_success: 'Alterações salvas com sucesso',
          save_failed: 'Falha ao salvar alterações',
          create_cancel: 'Cancelar',
          create_save: 'Salvar alterações',
        },
        modal_create: {
          create_title: 'Novo post viral',
          team: 'Time:',
          placeholder_url: 'Cole o link do post viral (ex: https://twitter.com/...)',
          add_button: 'Adicionar link',
          limit_reached: 'Limite de {{count}} posts atingido',
          enable_area: 'Exibir na vitrine',
          save_success: 'Post viral criado com sucesso',
          save_failed: 'Erro ao criar post viral',
          create_cancel: 'Cancelar',
          create_save: 'Criar',
        },
      },
      social_media_back: 'Voltar',
      social_media_save: 'Salvar alterações',
      social_media_title_label: 'Redes Sociais',
      social_media_changes_saved: 'Alterações salvas com sucesso!',
      social_media_save_failed: 'Ocorreu um erro ao salvar alterações. Tente novamente.',
    },


    application_roster_group: {
      components: {
        roster_group_table: {
          roster_group_table_team: 'TIME',
          roster_group_table_name: 'NOME',
          roster_group_table_sort_order: 'ORDEM',
          roster_group_table_show_stats: 'EXIBE ESTATÍSTICAS',
          roster_group_table_created_at: 'CRIADO EM',
          roster_group_table_actions: 'AÇÕES',
          roster_group_table_yes: 'Sim',
          roster_group_table_no: 'Não',
          roster_group_table_show_more_actions: 'Mostrar mais ações',
          roster_group_table_view_details: 'Editar',
          roster_group_table_delete: 'Excluir',
          roster_group_table_empty: 'Nenhuma categoria cadastrada.',
          roster_group_table_reorder_hint: 'Arraste as linhas para reordenar as categorias.',
        },
        roster_group_filter_box: {
          roster_group_filter_box_title: 'Filtros',
          roster_group_filter_box_name: 'Nome:',
          roster_group_filter_box_clear: 'Limpar filtros',
        },
        schema: {
          roster_group_schema_required: 'Campo obrigatório',
        },
        roster_group_position_order_field: {
          label: 'Ordem das posições',
          hint: 'Defina a ordem em que as posições (ex.: Goleiro, Zagueiro, Lateral) aparecem no app. Arraste para reordenar. Posições não cadastradas aqui aparecem por último.',
          placeholder: 'Ex.: Goleiro',
          add: 'Adicionar',
          empty: 'Nenhuma posição cadastrada — a ordem seguirá o cadastro dos membros.',
        },
        roster_group_create_modal: {
          roster_group_create_title: 'Criar categoria de elenco',
          roster_group_create_team: 'Time:',
          roster_group_create_name: 'Nome*:',
          roster_group_create_sort_order: 'Ordem:',
          roster_group_create_show_stats: 'Exibir estatísticas',
          roster_group_create_cancel: 'Cancelar',
          roster_group_create_create: 'Criar',
          roster_group_create_success: 'Categoria criada com sucesso!',
          roster_group_create_error: 'Não foi possível criar a categoria. Tente novamente.',
        },
        roster_group_edit_modal: {
          roster_group_edit_title: 'Editar categoria de elenco',
          roster_group_edit_team: 'Time:',
          roster_group_edit_name: 'Nome*:',
          roster_group_edit_sort_order: 'Ordem:',
          roster_group_edit_show_stats: 'Exibir estatísticas',
          roster_group_edit_cancel: 'Cancelar',
          roster_group_edit_save: 'Salvar alterações',
          roster_group_edit_success: 'Categoria alterada com sucesso!',
          roster_group_edit_error: 'Não foi possível alterar a categoria. Tente novamente.',
        },
      },
      breadcrumb: {
        roster_group_label1: 'APLICATIVO',
        roster_group_label2: 'EQUIPE',
        roster_group_label3: 'ELENCO - CATEGORIAS',
      },
      application_roster_group_title: 'ELENCO - CATEGORIAS',
      application_roster_group_label: 'Elenco',
      application_roster_group_enabled: 'Habilitado',
      application_roster_group_disabled: 'Desabilitado',
      application_roster_group_add_button: 'Adicionar categoria',
      application_roster_group_enable_success: 'Área de elenco habilitada com sucesso',
      application_roster_group_disable_success: 'Área de elenco desabilitada com sucesso',
      application_roster_group_enable_error: 'Ocorreu um erro ao habilitar a área de elenco. Recarregue a página e tente novamente.',
      application_roster_group_disable_error: 'Ocorreu um erro ao desabilitar a área de elenco. Recarregue a página e tente novamente.',
      application_roster_group_delete_success: 'Categoria excluída com sucesso!',
      application_roster_group_delete_error: 'Ocorreu um erro ao excluir a categoria. Recarregue e tente novamente.',
      application_roster_group_edit_error: 'Categoria não encontrada.',
      application_roster_group_reorder_error: 'Não foi possível reordenar as categorias. Tente novamente.',
      application_roster_group_delete_confirm_title: 'Excluir categoria',
      application_roster_group_delete_confirm_description_start: 'Tem certeza que deseja excluir a categoria ',
      application_roster_group_delete_confirm_description_end: '?',
      application_roster_group_toggle_confirm_title: 'Elenco',
      application_roster_group_enable_confirm_description: 'Tem certeza que deseja habilitar este componente?',
      application_roster_group_disable_confirm_description: 'Tem certeza que deseja desabilitar este componente?',
    },

    application_roster_member: {
      components: {
        roster_member_table: {
          roster_member_table_type: 'TIPO',
          roster_member_table_name: 'NOME',
          roster_member_table_role_label: 'FUNÇÃO',
          roster_member_table_group: 'CATEGORIA',
          roster_member_table_shirt_number: 'CAMISA',
          roster_member_table_created_at: 'CRIADO EM',
          roster_member_table_actions: 'AÇÕES',
          roster_member_table_type_player: 'Atleta',
          roster_member_table_type_staff: 'Comissão',
          roster_member_table_show_more_actions: 'Mostrar mais ações',
          roster_member_table_view_details: 'Editar',
          roster_member_table_delete: 'Excluir',
          roster_member_table_empty: 'Nenhum membro cadastrado.',
          roster_member_table_reorder_hint: 'Arraste as linhas para reordenar os membros (recomendado com uma categoria filtrada).',
        },
        roster_member_filter_box: {
          roster_member_filter_box_title: 'Filtros',
          roster_member_filter_box_name: 'Nome:',
          roster_member_filter_box_group: 'Categoria:',
          roster_member_filter_box_group_default: 'Todas',
          roster_member_filter_box_clear: 'Limpar filtros',
        },
        roster_member_stats_fields: {
          roster_member_stats_section: 'Estatísticas',
          roster_member_stats_matches: 'Jogos',
          roster_member_stats_wins: 'Vitórias',
          roster_member_stats_draw: 'Empates',
          roster_member_stats_lose: 'Derrotas',
          roster_member_stats_goals: 'Gols',
          roster_member_stats_assists: 'Assistências',
          roster_member_stats_total_shots: 'Finalizações',
          roster_member_stats_shots_on_target: 'Finalizações no alvo',
          roster_member_stats_yellow_cards: 'Cartões amarelos',
          roster_member_stats_red_cards: 'Cartões vermelhos',
          roster_member_stats_goals_conceded: 'Gols sofridos',
        },
        schema: {
          roster_member_schema_required: 'Campo obrigatório',
          roster_member_schema_invalid_file_extension: 'Extensão inválida. Utilize .jpg, .jpeg ou .png',
        },
        roster_member_create_modal: {
          roster_member_create_title: 'Criar membro do elenco',
          roster_member_create_team: 'Time:',
          roster_member_create_type: 'Tipo*:',
          roster_member_create_type_player: 'Atleta',
          roster_member_create_type_staff: 'Comissão',
          roster_member_create_group: 'Categoria*:',
          roster_member_create_group_default: 'Selecione uma categoria',
          roster_member_create_name: 'Nome*:',
          roster_member_create_role_label: 'Função:',
          roster_member_create_role_label_placeholder: 'Posição',
          roster_member_create_role_label_no_options: 'Digite para criar uma posição',
          roster_member_create_hyperlink: 'Link:',
          roster_member_create_shirt_number: 'Número da camisa:',
          roster_member_create_age: 'Idade:',
          roster_member_create_birthdate: 'Data de nascimento:',
          roster_member_create_nationality: 'Nacionalidade:',
          roster_member_create_height: 'Altura:',
          roster_member_create_contract_until: 'Contrato até:',
          roster_member_create_photo: 'Foto*:',
          roster_member_create_photo_formats: 'Formato: PNG, JPG ou JPEG | Dimensões: 1024 x 1024 px',
          roster_member_create_cancel: 'Cancelar',
          roster_member_create_create: 'Criar',
          roster_member_create_success: 'Membro criado com sucesso!',
          roster_member_create_error: 'Não foi possível criar o membro. Tente novamente.',
        },
        roster_member_edit_modal: {
          roster_member_edit_title: 'Editar membro do elenco',
          roster_member_edit_team: 'Time:',
          roster_member_edit_type: 'Tipo*:',
          roster_member_edit_type_player: 'Atleta',
          roster_member_edit_type_staff: 'Comissão',
          roster_member_edit_group: 'Categoria*:',
          roster_member_edit_group_default: 'Selecione uma categoria',
          roster_member_edit_name: 'Nome*:',
          roster_member_edit_role_label: 'Função:',
          roster_member_edit_role_label_placeholder: 'Posição',
          roster_member_edit_role_label_no_options: 'Digite para criar uma posição',
          roster_member_edit_hyperlink: 'Link:',
          roster_member_edit_shirt_number: 'Número da camisa:',
          roster_member_edit_age: 'Idade:',
          roster_member_edit_birthdate: 'Data de nascimento:',
          roster_member_edit_nationality: 'Nacionalidade:',
          roster_member_edit_height: 'Altura:',
          roster_member_edit_contract_until: 'Contrato até:',
          roster_member_edit_photo: 'Foto:',
          roster_member_edit_photo_formats: 'Formato: PNG, JPG ou JPEG | Dimensões: 1024 x 1024 px',
          roster_member_edit_cancel: 'Cancelar',
          roster_member_edit_save: 'Salvar alterações',
          roster_member_edit_success: 'Membro alterado com sucesso!',
          roster_member_edit_error: 'Não foi possível alterar o membro. Tente novamente.',
        },
      },
      breadcrumb: {
        roster_member_label1: 'APLICATIVO',
        roster_member_label2: 'EQUIPE',
        roster_member_label3: 'ELENCO - MEMBROS',
      },
      application_roster_member_title: 'ELENCO - MEMBROS',
      application_roster_member_add_button: 'Adicionar membro',
      application_roster_member_delete_success: 'Membro excluído com sucesso!',
      application_roster_member_delete_error: 'Ocorreu um erro ao excluir o membro. Recarregue e tente novamente.',
      application_roster_member_edit_error: 'Membro não encontrado.',
      application_roster_member_reorder_error: 'Não foi possível reordenar os membros. Tente novamente.',
      application_roster_member_delete_confirm_title: 'Excluir membro',
      application_roster_member_delete_confirm_description_start: 'Tem certeza que deseja excluir o membro ',
      application_roster_member_delete_confirm_description_end: '?',
    },

    application_store: {
      components: {
        store_main_banners_table: {
          banner_table_date: 'Data',
          banner_table_team: 'Time',
          banner_table_title: 'Título do Banner',
          banner_table_actions: 'Ações',
          banner_table_show_more_actions: 'Mostrar mais ações',
          banner_table_view_details: 'Exibir detalhes',
          banner_table_delete: 'Deletar',
        },
        store_main_banners_filter_box: {
          store_main_banners_filter_box_title: 'Filtros',
          store_main_banners_filter_box_title_label: 'Título',
          store_main_banners_filter_box_clear: 'Limpar filtros',
        },
        store_main_banner_schema_modal: {
          schema: {
            required: 'Este campo é obrigatório',
            required_file: 'O arquivo deve ser uma imagem válida (JPEG ou PNG)',
            required_image: 'A imagem do banner é obrigatória',
          },
        },
        store_main_banners_create_modal: {
          create_title: 'Criar novo banner',
          create_team_label: 'Time:',
          create_title_label: 'Título:',
          create_link_label: 'Link:',
          create_cancel: 'Cancelar',
          create_confirm: 'Criar',
          create_success: 'Banner criado com sucesso',
          create_error: 'Erro ao criar banner',
        },
        store_main_banners_edit_modal: {
          edit_title: 'Editar banner',
          edit_team_label: 'Time:',
          edit_title_label: 'Título:',
          edit_link_label: 'Link:',
          edit_cancel: 'Cancelar',
          edit_save: 'Salvar alterações',
          edit_success: 'Banner atualizado com sucesso',
          edit_error: 'Erro ao atualizar banner',
        },
        store_main_banners_page: {
          page_title: 'Banners',
          store_label: 'Banners',
          enabled: 'Habilitado',
          disabled: 'Desabilitado',
          add_banner: 'Adicionar banner',
          banner_not_found: 'Banner não encontrado.',
          delete_success: 'Banner excluído com sucesso!',
          delete_error: 'Ocorreu um erro ao excluir o banner. Recarregue e tente novamente.',
          delete_title: 'Excluir banner',
          delete_confirm: 'Tem certeza que deseja excluir o banner',
          confirm_modal_title: 'Banners',
          confirm_enable: 'Tem certeza que deseja habilitar este componente?',
          confirm_disable: 'Tem certeza que deseja desabilitar este componente?',
          enable_success: 'Área de banners habilitada com sucesso',
          disable_success: 'Área de banners desabilitada com sucesso',
          enable_error: 'Ocorreu um erro ao habilitar área de banners. Recarregue a página e tente novamente.',
          disable_error: 'Ocorreu um erro ao desabilitar área de banners. Recarregue a página e tente novamente.',
        },

        product_store: {
          application_store_page_title: 'PRODUTOS',
          application_store_store_label: 'Produtos',
          application_store_enabled: 'Habilitado',
          application_store_disabled: 'Desabilitado',
          application_store_confirm_modal_title: 'Produtos',
          application_store_confirm_enable: 'Tem certeza que deseja habilitar este componente?',
          application_store_confirm_disable: 'Tem certeza que deseja desabilitar este componente?',
          application_store_enable_success: 'Área de produtos habilitada com sucesso',
          application_store_disable_success: 'Área de produtos desabilitada com sucesso',
          application_store_enable_error: 'Ocorreu um erro ao habilitar área de produtos. Recarregue a página e tente novamente.',
          application_store_disable_error:
            'Ocorreu um erro ao desabilitar área de produtos. Recarregue a página e tente novamente.',
          application_store_add_product: 'Adicionar produto',
          application_store_product_not_found: 'Produto não encontrado.',
          application_store_product_delete_success: 'Produto excluído com sucesso!',
          application_store_product_delete_error: 'Ocorreu um erro ao excluir o produto. Recarregue e tente novamente.',
          application_store_delete_product_title: 'Excluir produto',
          application_store_delete_product_confirm: 'Tem certeza que deseja excluir o produto',
        },

        product_store_create_modal: {
          product_store_create_title: 'Criar novo produto',
          product_store_create_product_team: 'Time:',
          product_store_create_product_label: 'Produto*:',
          product_store_create_product_helper_text: '(Máx. de caracteres: 100)',
          product_store_create_price_label: 'Preço*:',
          product_store_create_link_label: 'Link*:',
          product_store_create_photo_label: 'Foto*:',
          product_store_create_photo_helper_text: 'Formato: PNG, JPG ou JPEG | Proporção: 4:3 ou 16:9',
          product_store_create_date_label: 'Data:',
          product_store_create_partner_label: 'Vincular à parceiro',
          product_store_create_partner_select_label: 'Parceiro:',
          product_store_create_partner_select_all: 'Todos',
          product_store_create_save_draft: 'Salvar como rascunho',
          product_store_create_cancel: 'Cancelar',
          product_store_create_submit: 'Criar',
          product_store_create_success: 'Produto criada com sucesso!',
          product_store_create_error: 'Não foi possível criar a produto. Tente novamente.',

          schema: {
            required: 'Campo obrigatório',
            required_file: 'Extensão inválida. Utilize .jpg, .jpeg ou .png',
            required_date: 'Selecione uma data',
            required_partner: 'Selecione um parceiro',
          },
        },

        product_store_edit_modal: {
          product_store_edit_title: 'Editar produto',
          product_store_edit_published_label: 'Publicado',
          product_store_edit_product_label: 'Produto*:',
          product_store_edit_product_team: 'Time:',
          product_store_edit_product_helper_text: '(Máx. de caracteres: 100)',
          product_store_edit_price_label: 'Preço*:',
          product_store_edit_link_label: 'Link*:',
          product_store_edit_photo_label: 'Foto*:',
          product_store_edit_photo_helper_text: 'Formato: PNG, JPG ou JPEG | Proporção: 4:3 ou 16:9',
          product_store_edit_date_label: 'Data:',
          product_store_edit_partner_label: 'Vincular à parceiro',
          product_store_edit_partner_select_label: 'Parceiro:',
          product_store_edit_partner_select_all: 'Todos',
          product_store_edit_cancel: 'Cancelar',
          product_store_edit_save_changes: 'Salvar alterações',
          product_store_edit_update_success: 'Produto atualizado com sucesso!',
          product_store_edit_update_error: 'Não foi possível atualizar a produto. Tente novamente.',

          schema: {
            required: 'Campo obrigatório',
            required_file: 'Extensão inválida. Utilize .jpg, .jpeg ou .png',
            required_date: 'Selecione uma data',
            required_partner: 'Selecione um parceiro',
          },
        },

        product_store_filter: {
          store_filter_title: 'Filtros',
          store_filter_product_label: 'Produto:',
          store_filter_product_team: 'Time:',
          store_filter_product_team_select_all: 'Todos',
          store_filter_status_label: 'Situação:',
          store_filter_status_all: 'Todos',
          store_filter_start_date_label: 'Data inicial:',
          store_filter_end_date_label: 'Data final:',
          store_filter_clear_filters: 'Limpar filtros',
        },

        product_store_table: {
          product_store_table_creation_date: 'DATA DA CRIAÇÃO',
          product_store_table_team: 'TIME',
          product_store_table_product: 'PRODUTO',
          product_store_table_partner: 'PARCEIRO',
          product_store_table_price: 'PREÇO',
          product_store_table_status: 'SITUAÇÃO',
          product_store_table_actions: 'Açoes',
          product_store_table_view_details: 'Editar',
          product_store_table_delete: 'Excluir',
        },
      },

      breadcrumb: {
        store_label1: 'APLICATIVO',
        store_label2: 'LOJA',
        store_label3: 'BANNERS',
        store_label4: 'PRODUTOS',
      },

      application_store_page_title: 'LOJA',
      application_store_store_label: 'Loja',
      application_store_enabled: 'Habilitado',
      application_store_disabled: 'Desabilitado',
      application_store_confirm_modal_title: 'Loja',
      application_store_confirm_enable: 'Tem certeza que deseja habilitar este componente?',
      application_store_confirm_disable: 'Tem certeza que deseja desabilitar este componente?',
      application_store_enable_success: 'Área de lojas habilitada com sucesso',
      application_store_disable_success: 'Área de lojas desabilitada com sucesso',
      application_store_enable_error: 'Ocorreu um erro ao habilitar área de lojas. Recarregue a página e tente novamente.',
      application_store_disable_error: 'Ocorreu um erro ao desabilitar área de lojas. Recarregue a página e tente novamente.',

      application_store_edit_main_banner: 'Editar banner principal',
      application_store_main_banner_not_found: 'Banner principal não encontrado.',
    },

    application_tables: {
      breadcrumb: {
        table_label1: 'APLICATIVO',
        table_label2: 'TABELAS',
      },

      application_tables_page_title: 'TABELAS',
      application_tables_label: 'Tabelas',
      application_tables_enabled: 'Habilitado',
      application_tables_disabled: 'Desabilitado',
      application_tables_classification_link: 'Tabelas de Classificação',
      application_tables_games_link: 'Tabelas de Jogos',
      application_tables_league_link: 'Competições',
      application_tables_teams_link: 'Times',
      application_tables_enable_success: 'Área de tabelas habilitada com sucesso',
      application_tables_disable_success: 'Área de tabelas desabilitada com sucesso',
      application_tables_enable_error: 'Ocorreu um erro ao habilitar área de tabelas. Recarregue a página e tente novamente.',
      application_tables_disable_error: 'Ocorreu um erro ao desabilitar área de tabelas. Recarregue a página e tente novamente.',
      application_tables_confirm_modal_title: 'Tabelas',
      application_tables_confirm_enable:
        'Ao habilitar este componente, todos os componentes associados serão automaticamente habilitados. Deseja continuar?',
      application_tables_confirm_disable:
        'Ao desabilitar este componente, todos os componentes associados serão automaticamente desabilitados. Deseja continuar?',
    },

    application_team: {
      breadcrumb: {
        team_label1: 'APLICATIVO',
        team_label2: 'EQUIPE',
      },

      application_team_page_title: 'EQUIPE',
      application_team_label: 'Equipe',
      application_team_enabled: 'Habilitado',
      application_team_disabled: 'Desabilitado',
      application_team_roster_group_link: 'Elenco - Categorias',
      application_team_roster_member_link: 'Elenco - Membros',
      application_team_enable_success: 'Área de equipe habilitada com sucesso',
      application_team_disable_success: 'Área de equipe desabilitada com sucesso',
      application_team_enable_error: 'Ocorreu um erro ao habilitar área de equipe. Recarregue a página e tente novamente.',
      application_team_disable_error: 'Ocorreu um erro ao desabilitar área de equipe. Recarregue a página e tente novamente.',
      application_team_confirm_modal_title: 'Equipe',
      application_team_confirm_enable:
        'Ao habilitar este componente, todos os componentes associados serão automaticamente habilitados. Deseja continuar?',
      application_team_confirm_disable:
        'Ao desabilitar este componente, todos os componentes associados serão automaticamente desabilitados. Deseja continuar?',
    },

    application_teams: {
      components: {
        teams_create_modal: {
          teams_create_title: 'Criar novo time',
          teams_create_name_label: 'Nome*:',
          teams_create_name_helper_text: '(Máx. de caracteres: 100)',
          teams_create_acronym_label: 'Sigla*:',
          teams_create_acronym_helper_text: '(Máx. de caracteres: 3)',
          teams_create_shield_label: 'Escudo (Fundo transparente)*:',
          teams_create_shield_helper_text: 'Formato: PNG, JPG ou JPEG | Proporção: 4:3 ou 16:9',
          teams_create_cancel: 'Cancelar',
          teams_create_submit: 'Criar',
          teams_create_success: 'Time criado com sucesso!',
          teams_create_error: 'Não foi possível criar o time. Tente novamente.',
          teams_create_favorite_label: 'Adicionar como time destaque.',
          teams_create_favorite_description:
            'Caso esta opção seja marcada, o time será exibido como destaque em funcionalidades como calendário, tabelas de classificação e tabelas de jogos. Apenas um time pode ser marcado como destaque.',
          teams_create_favorite_exists:
            'Já existe um time definido como destaque. Você deve desmarcá-lo para adicionar um novo time destaque.',

          schema: {
            required: 'Campo obrigatório',
            required_file: 'Extensão inválida. Utilize .jpg, .jpeg ou .png',
          },
        },

        teams_edit_modal: {
          teams_edit_title: 'Editar time',
          teams_edit_name_label: 'Nome*:',
          teams_edit_name_helper_text: '(Máx. de caracteres: 100)',
          teams_edit_acronym_label: 'Sigla*:',
          teams_edit_acronym_helper_text: '(Máx. de caracteres: 3)',
          teams_edit_shield_label: 'Escudo (Fundo transparente)*:',
          teams_edit_shield_helper_text: 'Formato: PNG, JPG ou JPEG | Proporção: 4:3 ou 16:9',
          teams_edit_cancel: 'Cancelar',
          teams_edit_submit: 'Salvar alterações',
          teams_edit_success: 'Time alterado com sucesso!',
          teams_edit_error: 'Não foi possível alterar o time. Tente novamente.',
          teams_edit_favorite_label: 'Adicionar como time destaque.',
          teams_edit_favorite_description:
            'Caso esta opção seja marcada, o time será exibido como destaque em funcionalidades como calendário, tabelas de classificação e tabelas de jogos. Apenas um time pode ser marcado como destaque.',
          teams_edit_favorite_exists:
            'Já existe um time definido como destaque. Você deve desmarcá-lo para adicionar um novo time destaque.',

          schema: {
            required: 'Campo obrigatório',
            required_file: 'Extensão inválida. Utilize .jpg, .jpeg ou .png',
          },
        },

        teams_filter_box: {
          teams_filter_title: 'Filtros',
          teams_filter_team_label: 'Time:',
          teams_filter_start_date_label: 'Data inicial:',
          teams_filter_end_date_label: 'Data final:',
          teams_filter_clear_filters: 'Limpar filtros',
        },

        teams_table: {
          teams_table_created_at_header: 'DATA DA CRIAÇÃO',
          teams_table_logo_header: 'ESCUDO',
          teams_table_name_header: 'TIME',
          teams_table_acronym_header: 'SIGLA',
          teams_table_actions_header: 'Açoes',
          teams_table_show_more_actions: 'Mostrar mais ações',
          teams_table_view_details: 'Editar',
          teams_table_delete: 'Excluir',
        },
      },
      breadcrumb: {
        teams_label1: 'APLICATIVO',
        teams_label2: 'Competições',
        teams_label3: 'TIMES',
      },

      application_teams_page_title: 'TIMES',
      application_teams_label: 'Time',
      application_teams_create_button: 'Criar novo time',
      application_teams_delete_success: 'Time deletado com sucesso!',
      application_teams_delete_error: 'Ocorreu um erro ao deletar o time. Recarregue e tente novamente.',
      application_teams_not_found: 'Time não encontrado.',
      application_teams_delete_modal_title: 'Excluir time',
      application_teams_delete_confirm: 'Tem certeza que deseja excluir o time',
    },


    application_uniform_gallery: {
      components: {
        uniform_gallery_create_modal: {
          uniform_gallery_create_title: 'Criar novo uniforme',
          uniform_gallery_create_team_label: 'Time:',
          uniform_gallery_create_season_label: 'Coleção*:',
          uniform_gallery_create_season_default_option: 'Selecione',
          uniform_gallery_create_title_label: 'Descrição*:',
          uniform_gallery_create_credit_label: 'Crédito:',
          uniform_gallery_create_title_helper_text: '(Máx. de caracteres: 100)',
          uniform_gallery_create_image_label: 'Imagem:',
          uniform_gallery_create_image_helper_text: 'Formato: PNG, JPG ou JPEG | Proporção: 4:3 ou 16:9',
          uniform_gallery_create_cancel_button: 'Cancelar',
          uniform_gallery_create_submit_button: 'Criar',
          uniform_gallery_create_success: 'Uniforme criado com sucesso!',
          uniform_gallery_create_error: 'Não foi possível criar o uniforme. Tente novamente.',

          schema: {
            required: 'Campo obrigatório',
            required_file: 'Extensão inválida. Utilize .jpg, .jpeg ou .png',
            required_image: 'Selecione uma imagem',
          },
        },

        uniform_gallery_edit_modal: {
          uniform_gallery_edit_title: 'Editar uniforme',
          uniform_gallery_edit_team_label: 'Time:',
          uniform_gallery_edit_season_label: 'Coleção*:',
          uniform_gallery_edit_season_default_option: 'Selecione',
          uniform_gallery_edit_title_label: 'Descrição*:',
          uniform_gallery_edit_credit_label: 'Crédito:',
          uniform_gallery_edit_title_helper_text: '(Máx. de caracteres: 100)',
          uniform_gallery_edit_image_label: 'Imagem:',
          uniform_gallery_edit_image_helper_text: 'Formato: PNG, JPG ou JPEG | Proporção: 4:3 ou 16:9',
          uniform_gallery_edit_cancel_button: 'Cancelar',
          uniform_gallery_edit_submit_button: 'Salvar alterações',
          uniform_gallery_edit_success: 'Uniforme alterado com sucesso!',
          uniform_gallery_edit_error: 'Não foi possível alterar o uniforme. Tente novamente.',

          schema: {
            required: 'Campo obrigatório',
            required_file: 'Extensão inválida. Utilize .jpg, .jpeg ou .png',
            required_image: 'Selecione uma imagem ou forneça uma URL válida',
          },
        },

        uniform_gallery_filter_box: {
          uniform_gallery_filter_title: 'Filtros',
          uniform_gallery_filter_season_label: 'Coleção:',
          uniform_gallery_filter_team_label: 'Time:',
          uniform_gallery_filter_team_select_all: 'Todos',
          uniform_gallery_filter_season_default_option: 'Todos',
          uniform_gallery_filter_clear_button: 'Limpar filtros',
        },

        uniform_gallery_table: {
          uniform_gallery_table_created_at_header: 'DATA DA CRIAÇÃO',
          uniform_gallery_table_team_header: 'TIME',
          uniform_gallery_table_season_header: 'COLEÇÃO',
          uniform_gallery_table_title_header: 'DESCRIÇÃO',
          uniform_gallery_table_actions_header: 'Açoes',
          uniform_gallery_table_actions_aria_label: 'Mostrar mais ações',
          uniform_gallery_table_view_details: 'Editar',
          uniform_gallery_table_delete: 'Excluir',
        },

        uniform_season_edit_modal: {
          uniform_season_edit_title: 'Editar coleções',
          uniform_season_edit_name_label: 'Nome:',
          uniform_season_edit_add_button: 'Adicionar coleção',
          uniform_season_edit_cancel_button: 'Cancelar',
          uniform_season_edit_submit_button: 'Salvar',
          uniform_season_edit_delete_modal_title: 'Excluir coleção',
          uniform_season_edit_delete_confirm: 'Tem certeza que deseja excluir a coleção',
          uniform_season_edit_delete_success: 'Coleção deletada com sucesso!',
          uniform_season_edit_delete_error: 'Ocorreu um erro ao deletar coleção. Recarregue e tente novamente.',

          schema: {
            required: 'Campo obrigatório',
          },
        },
      },

      breadcrumb: {
        uniform_label1: 'APLICATIVO',
        uniform_label2: 'HISTÓRIA',
        uniform_label3: 'UNIFORMES HISTÓRICOS',
      },

      application_uniform_gallery_page_title: 'UNIFORMES HISTÓRICOS',
      application_uniform_gallery_label: 'Uniformes Históricos',
      application_uniform_gallery_enabled: 'Habilitado',
      application_uniform_gallery_disabled: 'Desabilitado',
      application_uniform_gallery_create_button: 'Adicionar uniforme',
      application_uniform_gallery_edit_seasons_button: 'Editar coleções',
      application_uniform_gallery_enable_success: 'Área de uniformes históricos habilitado com sucesso',
      application_uniform_gallery_disable_success: 'Área de uniformes históricos desabilitado com sucesso',
      application_uniform_gallery_enable_error:
        'Ocorreu um erro ao habilitar área de uniformes históricos. Recarregue a página e tente novamente.',
      application_uniform_gallery_disable_error:
        'Ocorreu um erro ao desabilitar área de uniformes históricos. Recarregue a página e tente novamente.',
      application_uniform_gallery_delete_success: 'Uniforme deletado com sucesso!',
      application_uniform_gallery_delete_error: 'Ocorreu um erro ao deletar o uniforme. Tente novamente.',
      application_uniform_gallery_not_found_error: 'Uniforme não encontrado.',
      application_uniform_gallery_season_save_single_success: 'Coleção salva com sucesso!',
      application_uniform_gallery_season_save_multiple_success: 'Coleções salvas com sucesso!',
      application_uniform_gallery_season_save_single_error: 'Ocorreu erro ao salvar a coleção',
      application_uniform_gallery_season_save_multiple_error: 'Ocorreu erro ao salvar as coleções',
      application_uniform_gallery_delete_modal_title: 'Excluir uniforme',
      application_uniform_gallery_delete_confirm: 'Tem certeza que deseja excluir o uniforme',
      application_uniform_gallery_app_area_confirm: 'Tem certeza que deseja habilitar este componente?',
      application_uniform_gallery_app_area_disabled: 'Tem certeza que deseja desabilitar este componente?',
      application_uniform_gallery_enable_action: 'habilitar',
      application_uniform_gallery_disable_action: 'desabilitar',
    },

    application_videos_channel: {
      components: {
        live_video_create_modal: {
          live_video_create_title: 'Tranmissão ao vivo',
          live_video_create_title_label: 'Título*:',
          live_video_create_title_helper_text: '(Máx. de caracteres: 100)',
          live_video_create_video_url_label: 'Link do vídeo*:',
          live_video_create_thumbnail_label: 'Imagem de miniatura:',
          live_video_create_thumbnail_helper_text: 'Formato: PNG, JPG ou JPEG | Tamanho: 512 x 512 px',
          live_video_create_cancel_button: 'Cancelar',
          live_video_create_submit_button: 'Salvar alterações',
          live_video_create_success_create: 'Transmissão ao vivo criada com sucesso!',
          live_video_create_success_update: 'Transmissão ao vivo alterada com sucesso!',
          live_video_create_error_create: 'Não foi possível criar a transmissão ao vivo. Tente novamente.',
          live_video_create_error_update: 'Não foi possível alterar a transmissão ao vivo. Tente novamente.',

          schema: {
            required: 'Campo obrigatório',
            required_file: 'Extensão inválida. Utilize .jpg, .jpeg ou .png',
          },
        },

        video_channel_filter_box: {
          video_channel_filter_title: 'Filtros',
          video_channel_filter_team_label: 'Time:',
          video_channel_filter_team_select_all: 'Todos',
          video_channel_filter_title_label: 'Título:',
          video_channel_filter_category_label: 'Categoria:',
          video_channel_filter_start_date_label: 'Data inicial:',
          video_channel_filter_end_date_label: 'Data final:',
          video_channel_filter_category_default_option: 'Todos',
          video_channel_filter_clear_button: 'Limpar filtros',
          video_channel_filter_live_video_category: 'Transmissão ao vivo',
        },

        video_channel_table: {
          video_channel_table_created_at_header: 'DATA DA CRIAÇÃO',
          video_channel_table_team_header: 'TIME',
          video_channel_table_title_header: 'TÍTULO',
          video_channel_table_category_header: 'CATEGORIA',
          video_channel_table_actions_header: 'Açoes',
          video_channel_table_actions_aria_label: 'Mostrar mais ações',
          video_channel_table_view_details: 'Editar',
          video_channel_table_delete: 'Excluir',
        },

        video_create_modal: {
          video_create_title: 'Adicionar vídeo',
          video_create_team_label: 'Time:',
          video_create_title_label: 'Título*:',
          video_create_title_helper_text: '(Máx. de caracteres: 100)',
          video_create_category_label: 'Categoria*:',
          video_create_category_default_option: 'Selecione',
          video_create_video_url_label: 'Link do vídeo*:',
          video_create_thumbnail_label: 'Imagem de miniatura:',
          video_create_thumbnail_helper_text: 'Formato: PNG, JPG ou JPEG | Tamanho: 512 x 512 px',
          video_create_cancel_button: 'Cancelar',
          video_create_submit_button: 'Criar',
          video_create_success: 'Vídeo criado com sucesso!',
          video_create_error: 'Não foi possível criar o vídeo. Tente novamente.',

          schema: {
            required: 'Campo obrigatório',
            required_file: 'Extensão inválida. Utilize .jpg, .jpeg ou .png',
          },
        },

        video_edit_modal: {
          video_edit_title: 'Editar vídeo',
          video_edit_team_label: 'Time:',
          video_edit_title_label: 'Título*:',
          video_edit_title_helper_text: '(Máx. de caracteres: 100)',
          video_edit_category_label: 'Categoria*:',
          video_edit_category_default_option: 'Selecione',
          video_edit_video_url_label: 'Link do vídeo*:',
          video_edit_thumbnail_label: 'Imagem de miniatura:',
          video_edit_thumbnail_helper_text: 'Formato: PNG, JPG ou JPEG | Tamanho: 512 x 512 px',
          video_edit_cancel_button: 'Cancelar',
          video_edit_submit_button: 'Salvar alterações',
          video_edit_success: 'Vídeo alterado com sucesso!',
          video_edit_error: 'Não foi possível alterar o vídeo. Tente novamente.',

          schema: {
            required: 'Campo obrigatório',
            required_file: 'Extensão inválida. Utilize .jpg, .jpeg ou .png',
          },
        },
      },

      breadcrumb: {
        videos_label1: 'APLICATIVO',
        videos_label2: 'CANAL DE VÍDEOS',
      },

      application_videos_channel_page_title: 'CANAL DE VÍDEOS',
      application_videos_channel_label: 'Canal de videos',
      application_videos_channel_enabled: 'Habilitado',
      application_videos_channel_disabled: 'Desabilitado',
      application_videos_channel_view_categories_button: 'Ver categorias',
      application_videos_channel_create_video_button: 'Adicionar vídeo',
      application_videos_channel_enable_success: 'Área de canal de videos habilitada com sucesso',
      application_videos_channel_disable_success: 'Área de canal de videos desabilitada com sucesso',
      application_videos_channel_enable_error:
        'Ocorreu um erro ao habilitar área de canal de videos. Recarregue a página e tente novamente.',
      application_videos_channel_disable_error:
        'Ocorreu um erro ao desabilitar área de canal de videos. Recarregue a página e tente novamente.',
      application_videos_channel_delete_video_success: 'Vídeo deletado com sucesso!',
      application_videos_channel_delete_video_error: 'Ocorreu um erro ao deletar o vídeo. Tente novamente.',
      application_videos_channel_video_not_found_error: 'Vídeo não encontrado.',
      application_videos_channel_delete_modal_title: 'Excluir vídeo',
      application_videos_channel_delete_confirm: 'Tem certeza que deseja excluir o vídeo',
      application_videos_channel_app_area_modal_title: 'Canal de Videos',
      application_videos_channel_app_area_confirm: 'Tem certeza que deseja habilitar esse componente?',
      application_videos_channel_app_area_disabled: 'Tem certeza que deseja desabilitar esse componente?',
      application_videos_channel_enable_action: 'habilitar',
      application_videos_channel_disable_action: 'desabilitar',
    },

    application_won_title: {
      components: {
        competition_edit_modal: {
          competition_edit_title: 'Editar competições',
          competition_edit_name_label: 'Nome:',
          competition_edit_add_button: 'Adicionar competição',
          competition_edit_cancel_button: 'Cancelar',
          competition_edit_submit_button: 'Salvar',
          competition_edit_delete_success: 'Competição deletada com sucesso!',
          competition_edit_delete_error: 'Ocorreu um erro ao deletar competição. Recarregue e tente novamente.',
          competition_edit_delete_modal_title: 'Excluir competição',
          competition_edit_delete_confirm: 'Tem certeza que deseja excluir a competição',

          schema: {
            required: 'Campo obrigatório',
          },
        },

        won_title_create_modal: {
          won_title_create_title: 'Criar novo título',
          won_title_create_team_label: 'Time:',
          won_title_create_year_label: 'Ano*:',
          won_title_create_competition_label: 'Competição*:',
          won_title_create_competition_default_option: 'Selecione',
          won_title_create_cancel_button: 'Cancelar',
          won_title_create_submit_button: 'Criar',
          won_title_create_success: 'Título criado com sucesso!',
          won_title_create_error: 'Não foi possível criar o título. Tente novamente.',

          schema: {
            required: 'Campo obrigatório',
            required_number: 'O ano deve ser maior ou igual a 1500',
          },
        },

        won_title_edit_modal: {
          won_title_edit_title: 'Editar título',
          won_title_edit_team_label: 'Time:',
          won_title_edit_year_label: 'Ano*:',
          won_title_edit_competition_label: 'Competição*:',
          won_title_edit_competition_default_option: 'Selecione',
          won_title_edit_cancel_button: 'Cancelar',
          won_title_edit_submit_button: 'Salvar alterações',
          won_title_edit_success: 'Título alterado com sucesso!',
          won_title_edit_error: 'Não foi possível alterar o título. Tente novamente.',

          schema: {
            required: 'Campo obrigatório',
            required_number: 'O ano deve ser maior ou igual a 1500',
          },
        },

        won_title_filter_box: {
          won_title_filter_title: 'Filtros',
          won_title_filter_team_label: 'Time:',
          won_title_filter_team_select_all: 'Todos',
          won_title_filter_competition_label: 'Títulos:',
          won_title_filter_competition_default_option: 'Todos',
          won_title_filter_year_label: 'Ano:',
          won_title_filter_clear_button: 'Limpar filtros',
        },

        won_title_table: {
          won_title_table_created_at_header: 'DATA DA CRIAÇÃO',
          won_title_table_team_header: 'TIME',
          won_title_table_competition_header: 'COMPETIÇÃO',
          won_title_table_year_header: 'ANO',
          won_title_table_actions_header: 'Açoes',
          won_title_table_actions_menu_label: 'Mostrar mais ações',
          won_title_table_view_details_menu_item: 'Editar',
          won_title_table_delete_menu_item: 'Excluir',
        },
      },

      breadcrumb: {
        won_title_label1: 'APLICATIVO',
        won_title_label2: 'HISTÓRIA',
        won_title_label3: 'TÍTULOS',
      },

      application_won_title_page_title: 'TÍTULOS',
      application_won_title_label: 'Títulos',
      application_won_title_enabled: 'Habilitado',
      application_won_title_disabled: 'Desabilitado',
      application_won_title_create_button: 'Adicionar título',
      application_won_title_edit_competitions_button: 'Editar competições',
      application_won_title_enable_success: 'Área de títulos habilitada com sucesso',
      application_won_title_disable_success: 'Área de títulos desabilitada com sucesso',
      application_won_title_enable_error:
        'Ocorreu um erro ao habilitar área de títulos. Recarregue a página e tente novamente.',
      application_won_title_disable_error:
        'Ocorreu um erro ao desabilitar área de títulos. Recarregue a página e tente novamente.',
      application_won_title_delete_success: 'Título deletado com sucesso!',
      application_won_title_delete_error: 'Ocorreu um erro ao deletar o título. Tente novamente.',
      application_won_title_not_found_error: 'Título não encontrado.',
      application_won_title_delete_modal_title: 'Excluir títulos',
      application_won_title_delete_confirm: 'Tem certeza que deseja excluir a conquita',
      application_won_title_app_area_modal_title: 'Títulos',
      application_won_title_app_area_confirm: 'Tem certeza que deseja habilitar este componente?',
      application_won_title_app_area_disabled: 'Tem certeza que deseja desabilitar este componente?',
      application_won_title_enable_action: 'habilitar',
      application_won_title_disable_action: 'desabilitar',
      application_won_title_save_competition_error_singular: 'Ocorreu erro ao salvar a competição',
      application_won_title_save_competition_error_plural: 'Ocorreu erro ao salvar as competições',
      application_won_title_save_competition_success_singular: 'Competição salva com sucesso!',
      application_won_title_save_competition_success_plural: 'Competições salvas com sucesso!',
    },

    benefits_club: {
      components: {
        benefits_club_header: {
          benefits_club_header_label: 'Clube de benefícios',
          benefits_club_header_enabled: 'Habilitado',
          benefits_club_header_disabled: 'Desabilitado',
          benefits_club_header_view_partners_button: 'Ver parceiros',
          benefits_club_header_create_button: 'Adicionar benefício',
          benefits_club_header_enable_success: 'Clube de benefícios habilitada com sucesso',
          benefits_club_header_disable_success: 'Clube de benefícios desabilitada com sucesso',
          benefits_club_header_enable_error:
            'Ocorreu um erro ao habilitar clube de benefícios. Recarregue a página e tente novamente.',
          benefits_club_header_disable_error:
            'Ocorreu um erro ao desabilitar clube de benefícios. Recarregue a página e tente novamente.',
          benefits_club_header_modal_title: 'Clube de Benefícios',
          benefits_club_header_confirm: 'Tem certeza que deseja habilitar este componente?',
          benefits_club_header_confirm_disabled: 'Tem certeza que deseja desabilitar este componente?',
          benefits_club_header_enable_action: 'habilitar',
          benefits_club_header_disable_action: 'desabilitar',
        },

        benefit_create_modal: {
          benefit_create_title: 'Criar benefício',
          benefit_create_partner_label: 'Parceiro:',
          benefit_create_default_option: 'Todos',
          benefit_create_type_label: 'Tipo de benefício:',
          benefit_create_team_label: 'Time:',
          benefit_create_title_label: 'Título do benefício *:',
          benefit_create_title_helper: '(Máx. de caracteres: 100)',
          benefit_create_description_label: 'Descrição do benefício:',
          benefit_create_description_helper: '(Máx. de caracteres: 255)',
          benefit_create_coupon_label: 'Código do cupom *:',
          benefit_create_hyperlink_label: 'Link externo:',
          benefit_create_schedule_label: 'Definir período',
          benefit_create_start_date_label: 'Data inicial:',
          benefit_create_end_date_label: 'Data final:',
          benefit_create_default_image_label: 'Utilizar imagem do parceiro',
          benefit_create_image_label: 'Imagem:',
          benefit_create_image_helper: 'Formato: PNG, JPG ou JPEG | Proporção: 4:3 ou 16:9',
          benefit_create_spotlight_label: 'Adicionar aos destaques',
          benefit_create_spotlight_helper:
            'Caso essa opção esteja marcada, o benefício aparecerá em destaque na Área do Assinante.',
          benefit_create_cancel_button: 'Cancelar',
          benefit_create_submit_button: 'Criar',
          benefit_create_success: 'Benefício criado com sucesso!',
          benefit_create_error: 'Não foi possível criar o benefício. Tente novamente.',

          schema: {
            required: 'Campo obrigatório',
            required_file: 'Extensão inválida. Utilize .jpg, .jpeg ou .png',
            required_max_100: 'Máximo de 100 caracteres',
            required_date: 'Selecione uma data',
          },
        },

        benefit_edit_modal: {
          benefit_edit_title: 'Editar benefício',
          benefit_edit_status_label: 'Ativo',
          benefit_edit_partner_label: 'Parceiro:',
          benefit_edit_team_label: 'Time:',
          benefit_edit_type_label: 'Tipo de benefício:',
          benefit_edit_default_option: 'Todos',
          benefit_edit_title_label: 'Título do benefício *:',
          benefit_edit_title_helper: '(Máx. de caracteres: 100)',
          benefit_edit_description_label: 'Descrição do benefício:',
          benefit_edit_description_helper: '(Máx. de caracteres: 255)',
          benefit_edit_coupon_label: 'Código do cupom *:',
          benefit_edit_hyperlink_label: 'Link externo:',
          benefit_edit_schedule_label: 'Definir período',
          benefit_edit_start_date_label: 'Data inicial:',
          benefit_edit_end_date_label: 'Data final:',
          benefit_edit_default_image_label: 'Utilizar imagem do parceiro',
          benefit_edit_image_label: 'Imagem:',
          benefit_edit_image_helper: 'Formato: PNG, JPG ou JPEG | Proporção: 4:3 ou 16:9',
          benefit_edit_spotlight_label: 'Adicionar aos destaques',
          benefit_edit_spotlight_helper:
            'Caso essa opção esteja marcada, o benefício aparecerá em destaque na Área do Assinante.',
          benefit_edit_cancel_button: 'Cancelar',
          benefit_edit_submit_button: 'Salvar alterações',
          benefit_edit_success: 'Benefício atualizado com sucesso!',
          benefit_edit_error: 'Não foi possível atualizar o benefício. Tente novamente.',

          schema: {
            required: 'Campo obrigatório',
            required_file: 'Extensão inválida. Utilize .jpg, .jpeg ou .png',
            required_max_100: 'Máximo de 100 caracteres',
            required_date: 'Selecione uma data',
          },
        },

        benefits_filters_box: {
          benefits_filters_title: 'Filtros',
          benefits_filters_title_label: 'Título:',
          benefits_filters_description_label: 'Descrição:',
          benefits_filters_team_label: 'Time:',
          benefits_filters_team_select_all: 'Todos',
          benefits_filters_partner_label: 'Parceiro:',
          benefits_filters_default_option: 'Todos',
          benefits_filters_type_label: 'Benefício:',
          benefits_filters_status_label: 'Situação:',
          benefits_filters_spotlight_label: 'Exibir apenas destaques',
          benefits_filters_clear_button: 'Limpar filtros',
        },

        benefits_table: {
          benefits_table_created_at_header: 'DATA DA CRIAÇÃO',
          benefits_table_team_header: 'TIME',
          benefits_table_partner_header: 'PARCEIRO',
          benefits_table_title_header: 'BENEFÍCIO',
          benefits_table_description_header: 'BENEFÍCIO',
          benefits_table_status_header: 'SITUAÇÃO',
          benefits_table_actions_header: 'Açoes',
          benefits_table_actions_aria_label: 'Mostrar mais ações',
          benefits_table_edit_action: 'Editar',
          benefits_table_delete_action: 'Excluir',
        },
      },

      breadcrumb: {
        benefits_label1: 'APLICATIVO',
        benefits_label2: 'CLUBE DE BENEFÍCIOS',
      },

      benefits_club_page_title: 'CLUBE DE BENEFÍCIOS',
      benefits_club_fetch_error: 'Benefício não encontrado.',
      benefits_club_delete_success: 'Benefício excluído com sucesso!',
      benefits_club_delete_error: 'Ocorreu um erro ao deletar o benefício. Recarregue e tente novamente.',
      benefits_club_delete_modal_title: 'Excluir benefício',
      benefits_club_delete_modal_confirm: 'Tem certeza que deseja excluir o benefício',
    },

    communication_central: {
      components: {
        notification_create_modal: {
          schedule_send_label: 'Agendar envio',
          scheduled_at_label: 'Data e hora do envio*:',

          schema: {
            scheduled_at_required: 'Selecione a data e hora do envio',
            scheduled_at_invalid: 'Data e hora inválidas',
            scheduled_at_future: 'A data e hora do envio devem ser futuras',
            scheduled_at_should_be_empty: 'A data e hora do envio devem ser vazias quando o agendamento está desativado',
          },
        },

        notifications_tab_table: {
          column_status: 'STATUS',
          status_pending: 'Agendado',
          status_processing: 'Agendado',
          status_sent: 'Enviado',
          status_failed: 'Falhou',
        },

        notifications_tab_filter_box: {
          status_label: 'Status:',
          status_all: 'Todos',
        },

        smtp_config_tab: {
          smtp_config_title: 'Configuração para Envio de E-mail',
          smtp_config_host_label: 'Host',
          smtp_config_username_label: 'Usuário',
          smtp_config_password_label: 'Senha',
          smtp_config_port_label: 'Porta',
          smtp_config_from_label: 'De',
          smtp_config_reply_to_label: 'Reply to',
          smtp_config_submit_button: 'Salvar alterações',
          smtp_config_success: 'Configuração salva com sucesso!',
          smtp_config_error: 'Não foi possível salvar as configurações. Tente novamente.',

          schema: {
            required: 'Campo obrigatório',
          },
        },
      },

      breadcrumb: {
        central_label1: 'CENTRAL DE COMUNICAÇÃO',
      },

      communication_central_page_title: 'CENTRAL DE COMUNICAÇÃO',
      communication_central_notifications_tab: 'Notificações',
      communication_central_emails_tab: 'Emails',
      communication_central_smtp_config_tab: 'Configuração para Envio de E-mail',
    },

    financial: {
      components: {
        commercial_conditions_modal: {
          financial_commercial_conditions_title: 'Condições Comerciais',
          financial_commercial_conditions_plan_label: 'Plano:',
          financial_commercial_conditions_start_date_label: 'Data de Início:',
          financial_commercial_conditions_validity_label: 'Vigência:',
          financial_commercial_conditions_setup_label: 'Setup:',
          financial_commercial_conditions_monthly_fee_label: 'Mensalidade:',
          financial_commercial_conditions_extra_users_label: 'Usuários Extras:',
          financial_commercial_conditions_subscription_commission_label: 'Comissão por assinaturas:',
          financial_commercial_conditions_banner_label: 'Banner:',
          financial_commercial_conditions_remarks_label: 'Observações:',
          financial_commercial_conditions_close_button: 'Fechar',
          financial_commercial_conditions_export_button: 'Exportar',
        },
        financial_filters_box: {
          financial_filters_title: 'Filtros',
          financial_filters_subscriber_label: 'Assinante:',
          financial_filters_transaction_type_label: 'Tipo de transação:',
          financial_filters_plan_label: 'Plano:',
          financial_filters_all_option: 'Todos',
          financial_filters_monthly_payment: 'Assinatura',
          financial_filters_experience: 'Experiência',
          financial_filters_clear_filters: 'Limpar filtros',
        },

        financial_table: {
          financial_table_created_at: 'DATA DA CRIAÇÃO',
          financial_table_subscriber_name: 'NOME',
          financial_table_subscription_plan: 'PLANO',
          financial_table_transaction_type: 'TIPO DE TRANSAÇÃO',
          financial_table_price: 'VALOR',
          financial_table_actions: 'Ações',
          financial_table_monthly_payment: 'Assinatura',
          financial_table_experience: 'Experiência',
          financial_table_view_details: 'Editar',
          financial_table_show_more_actions: 'Mostrar mais ações',
        },
      },
      breadcrumb: {
        financial_label: 'PLANOS DE ACESSO',
      },

      financial_title: 'FINANCEIRO',
      financial_view_commercial_conditions: 'Ver condições comerciais',
      financial_total_revenue: 'RECEITA TOTAL DO PERÍODO',
    },

    financial_transaction_detail: {
      breadcrumb: {
        financial_transaction_label1: 'FINANCEIRO',
        financial_transaction_label2: 'DETALHES DA TRANSAÇÃO',
      },

      financial_transaction_detail_title: 'DETALHES DA TRANSAÇÃO',
      financial_transaction_detail_type_label: 'Tipo de transação:',
      financial_transaction_detail_date_label: 'Data:',
      financial_transaction_detail_subscriber_label: 'Assinante:',
      financial_transaction_detail_plan_label: 'Plano:',
      financial_transaction_detail_value_label: 'Valor:',
      financial_transaction_detail_payment_method_label: 'Forma de pagamento:',
      financial_transaction_detail_transaction_id_label: 'ID da transação:',
      financial_transaction_detail_monthly_payment: 'Assinatura',
      financial_transaction_detail_experience: 'Experiência',
      financial_transaction_detail_payment_method_credit_card: 'Cartão de crédito',
      financial_transaction_detail_payment_method_pix: 'Pix',
      financial_transaction_detail_download_receipt: 'Baixar comprovante',
      financial_transaction_detail_export_error: 'Houve um erro ao realizar a exportação.',
    },

    fundraising_campaign: {
      components: {
        fundraising_campaign_create_modal: {
          fundraising_campaign_create_modal_title: 'Criar campanha',
          fundraising_campaign_create_title_label: 'Título*:',
          fundraising_campaign_create_title_helper_text: '(Máx. de caracteres: 100)',
          fundraising_campaign_create_description_label: 'Descrição*:',
          fundraising_campaign_create_description_helper_text: '(Máx. de caracteres: 4.000)',
          fundraising_campaign_create_goal_label: 'Meta de arrecadação*:',
          fundraising_campaign_create_goal_placeholder: '0',
          fundraising_campaign_create_pix_key_label: 'Chave Pix*:',
          fundraising_campaign_create_image_label: 'Imagem:',
          fundraising_campaign_create_image_help_text: 'Formato: PNG, JPG ou JPEG | Proporção: 4:3 ou 16:9',
          fundraising_campaign_create_schedule_label: 'Definir período',
          fundraising_campaign_create_start_date_label: 'Data inicial:',
          fundraising_campaign_create_end_date_label: 'Data final:',
          fundraising_campaign_create_save_draft_button: 'Salvar como rascunho',
          fundraising_campaign_create_cancel_button: 'Cancelar',
          fundraising_campaign_create_create_button: 'Criar',
          fundraising_campaign_create_success_toast_title: 'Campanha de arrecadação criada com sucesso!',
          fundraising_campaign_create_error_toast_title: 'Não foi possível criar a campanha de arrecadação. Tente novamente.',

          schema: {
            required: 'Campo obrigatório',
            required_file: 'Extensão inválida. Utilize .jpg, .jpeg ou .png',
            required_date: 'Selecione uma data',
          },
        },

        fundraising_campaign_edit_modal: {
          fundraising_campaign_edit_modal_title: 'Criar campanha',
          fundraising_campaign_edit_published_label: 'Publicada',
          fundraising_campaign_edit_title_label: 'Título*:',
          fundraising_campaign_edit_title_helper_text: '(Máx. de caracteres: 100)',
          fundraising_campaign_edit_description_label: 'Descrição*:',
          fundraising_campaign_edit_description_helper_text: '(Máx. de caracteres: 4.000)',
          fundraising_campaign_edit_goal_label: 'Meta de arrecadação*:',
          fundraising_campaign_edit_goal_placeholder: '0',
          fundraising_campaign_edit_pix_key_label: 'Chave Pix*:',
          fundraising_campaign_edit_image_label: 'Imagem:',
          fundraising_campaign_edit_image_help_text: 'Formato: PNG, JPG ou JPEG | Proporção: 4:3 ou 16:9',
          fundraising_campaign_edit_schedule_label: 'Definir período',
          fundraising_campaign_edit_start_date_label: 'Data inicial:',
          fundraising_campaign_edit_end_date_label: 'Data final:',
          fundraising_campaign_edit_cancel_button: 'Cancelar',
          fundraising_campaign_edit_save_button: 'Salvar alterações',
          fundraising_campaign_edit_success_toast_title: 'Alterações salvas com sucesso!',
          fundraising_campaign_edit_error_toast_title: 'Não foi possível realizar alterçaões. Tente novamente.',

          schema: {
            required: 'Campo obrigatório',
            required_file: 'Extensão inválida. Utilize .jpg, .jpeg ou .png',
            required_date: 'Selecione uma data',
          },
        },

        fundraising_campaign_filters_box: {
          fundraising_campaign_filters_box_title: 'Filtros',
          fundraising_campaign_filters_box_campaign_label: 'Campanha:',
          fundraising_campaign_filters_box_status_label: 'Situação:',
          fundraising_campaign_filters_box_status_all_option: 'Todos',
          fundraising_campaign_filters_box_status_published_option: 'Publicada',
          fundraising_campaign_filters_box_status_not_published_option: 'Não publicada',
          fundraising_campaign_filters_box_status_scheduled_option: 'Programada',
          fundraising_campaign_filters_box_status_ended_option: 'Finalizada',
          fundraising_campaign_filters_box_clear_filters_button: 'Limpar filtros',
        },

        fundraising_campaign_justify_expenses_modal: {
          fundraising_campaign_justify_expenses_modal_title: 'Adicionar prestação de contas',
          fundraising_campaign_justify_expenses_campaign_label: 'Campanha:',
          fundraising_campaign_justify_expenses_collected_value_label: 'Valor arrecadado:',
          fundraising_campaign_justify_expenses_collected_value_empty: '-',
          fundraising_campaign_justify_expenses_thank_you_message_label: 'Mensagem de agradecimento:',
          fundraising_campaign_justify_expenses_thank_you_message_helper_text: '(Máx. de caracteres: 4000)',
          fundraising_campaign_justify_expenses_total_expenses_label: 'Total gasto*:',
          fundraising_campaign_justify_expenses_total_expenses_helper_text: '(Máx. de caracteres: 4000)',
          fundraising_campaign_justify_expenses_details_label: 'Detalhe dos gastos:',
          fundraising_campaign_justify_expenses_item_label: 'Item*:',
          fundraising_campaign_justify_expenses_item_helper_text: '(Máx. de caracteres: 30)',
          fundraising_campaign_justify_expenses_value_label: 'Valor*:',
          fundraising_campaign_justify_expenses_save_button: 'Salvar',
          fundraising_campaign_justify_expenses_add_expense_button: 'Adicionar vantagem',
          fundraising_campaign_justify_expenses_close_button: 'Fechar',
          fundraising_campaign_justify_expenses_success_toast_title: 'Prestação de contas salvas com sucesso!',
          fundraising_campaign_justify_expenses_error_toast_title:
            'Ocorreu um erro ao salvar prestação de contas. Recarregue e tente novamente!',

          schema: {
            required: 'Campo obrigatório',
            requireded: 'Obrigatório',
          },
        },

        fundraising_campaign_table: {
          fundraising_campaign_table_status_not_published: 'Não publicada',
          fundraising_campaign_table_status_published: 'Publicada',
          fundraising_campaign_table_status_scheduled: 'Agendada',
          fundraising_campaign_table_status_ended: 'Finalizada',
          fundraising_campaign_table_created_at_header: 'DATA DA CRIAÇÃO',
          fundraising_campaign_table_campaign_header: 'CAMPANHA',
          fundraising_campaign_table_period_header: 'PERÍODO',
          fundraising_campaign_table_period_empty: '-',
          fundraising_campaign_table_goal_header: 'META',
          fundraising_campaign_table_collected_header: 'ARRECADADO',
          fundraising_campaign_table_collected_empty: '-',
          fundraising_campaign_table_status_header: 'SITUAÇÃO',
          fundraising_campaign_table_justify_expenses_button: 'Adicionar prestação de contas',
          fundraising_campaign_table_actions_header: 'Açoes',
          fundraising_campaign_table_edit_action: 'Editar Campanha',
          fundraising_campaign_table_end_action: 'Finalizar Campanha',
          fundraising_campaign_table_publish_action: 'Publicar Campanha',
          fundraising_campaign_table_delete_action: 'Excluir Campanha',
          fundraising_campaign_table_more_actions_label: 'Mostrar mais ações',
        },
        receipt_upload: {
          receipt_upload_placeholder: 'Comprovante',
        },
      },

      breadcrumb: {
        fundraising_campaign_label1: 'CAMPANHAS DE ARRECADAÇÃO',
      },

      fundraising_campaign_screen_page_title: 'CAMPANHAS DE ARRECADAÇÃO',
      fundraising_campaign_screen_create_button: 'Criar campanha',
      fundraising_campaign_screen_publish_success_toast: 'Campanha de arrecadação publicada com sucesso!',
      fundraising_campaign_screen_publish_error_toast: 'Ocorreu um erro ao publicar campanha de arrecadação. Tente novamente',
      fundraising_campaign_screen_end_success_toast: 'Campanha de arrecadação finalizada com sucesso!',
      fundraising_campaign_screen_end_error_toast: 'Ocorreu um erro ao finalizar campanha de arrecadação. Tente novamente',
      fundraising_campaign_screen_delete_success_toast: 'Campanha de arrecadação deletada com sucesso!',
      fundraising_campaign_screen_delete_error_toast: 'Ocorreu um erro ao deletar campanha de arrecadação. Tente novamente',
      fundraising_campaign_screen_publish_modal_title: 'Publicar campanha',
      fundraising_campaign_screen_publish_modal_description: 'Tem certeza que deseja publicar essa campanha?',
      fundraising_campaign_screen_end_modal_title: 'Finalizar campanha',
      fundraising_campaign_screen_end_modal_description: 'Tem certeza que deseja finalizar essa campanha?',
      fundraising_campaign_screen_delete_modal_title: 'Excluir campanha',
      fundraising_campaign_screen_delete_modal_description: 'Tem certeza que deseja excluir essa campanha?',
      fundraising_campaign_screen_delete_modal_confirm_label: 'Excluir',
    },

    home: {
      home_shortcuts_section_title: 'ATALHOS',
      home_users_shortcut: 'Usuários',
      home_application_shortcut: 'Aplicativo',
      home_store_shortcut: 'Loja',
      home_team_shortcut: 'Equipe',
      home_subscribers_shortcut: 'Assinantes',
      home_authorizations_shortcut: 'Autorizações',
    },

    interactive_area: {
      breadcrumb: {
        interactive_label1: 'APLICATIVO',
        interactive_label2: 'ÁREA INTERATIVA',
      },

      interactive_area_page_title: 'ÁREA INTERATIVA',
      interactive_area_section_title: 'Área Interativa',
      interactive_area_enabled_label: 'Habilitado',
      interactive_area_disabled_label: 'Desabilitado',
      interactive_area_posts_shortcut: 'Posts',
      interactive_area_quizzes_shortcut: 'Quizzes',
      interactive_area_polls_shortcut: 'Enquetes',
      interactive_area_predictions_shortcut: 'Palpites',
      interactive_area_modal_title: 'Posts',
      interactive_area_modal_confirm_prefix: 'Tem certeza que deseja habilitar este componente?',
      interactive_area_modal_confirm_disabled: 'Tem certeza que deseja desabilitar este componente?',
      interactive_area_enable_action: 'habilitar',
      interactive_area_disable_action: 'desabilitar',
      interactive_area_enable_success: 'Área interativa habilitada com sucesso',
      interactive_area_disable_success: 'Área interativa desabilitada com sucesso',
      interactive_area_enable_error: 'Ocorreu um erro ao habilitar área interativa. Recarregue a página e tente novamente.',
      interactive_area_disable_error: 'Ocorreu um erro ao desabilitar área interativa. Recarregue a página e tente novamente.',
    },

    login: {
      components: {
        login_form_container: {
          login_form_title: 'ENTRAR',
          login_form_description: 'Insira seu e-mail e senha nos campos abaixo:',
          login_form_email_label: 'E-mail *',
          login_form_email_placeholder: 'seu@email.com',
          login_form_password_label: 'Senha *',
          login_form_required_fields: '* Campos obrigatórios',
          login_form_error_title: 'Ocorreu um erro ao acessar o sistema, tente novamente em alguns instantes.',
          login_form_error_description: 'Verifique usuário e senha',
          login_form_button_enter: 'Acessar',
          login_form_forgot_password: 'Esqueci minha senha',
        },
      },

      schemas: {
        login_form: {
          required: 'Campo obrigatório',
          invalid_email: 'Deve ser um email válido',
        },

        messages: {
          required: 'Campo obrigatório',
          min_password_size: 'Deve conter no mínimo 8 caracteres',
          required_password_characters: 'Não satisfaz os requisitos necessários',
          invalid_password_confirmation: 'As senhas não são iguais',
        },

        two_factor: {
          required: 'Campo obrigatório',
        },
      },

      forgot_password: {
        forgot_password_title: 'Recuperar senha',
        forgot_password_description: 'Digite seu e-mail de acesso no campo abaixo:',
        forgot_password_email_label: 'E-mail *',
        forgot_password_required_fields: '* Campos obrigatórios',
        forgot_password_back_link: 'Voltar',
        forgot_password_submit_button: 'Confirmar',
        forgot_password_error_title: 'Houve um erro ao recuperar senha.',
        forgot_password_error_description: 'Verifique o e-mail',
      },

      forgot_password_confirm_code: {
        forgot_password_confirm_title: 'Recuperar senha',
        forgot_password_confirm_description_prefix: 'Enviamos um código de recuperação para o email',
        forgot_password_confirm_description_suffix: '. Insira-o abaixo:',
        forgot_password_confirm_code_label: 'Código *',
        forgot_password_confirm_required_fields: '* Campos obrigatórios',
        forgot_password_confirm_resend_code: 'Reenviar código:',
        forgot_password_confirm_back_link: 'Voltar',
        forgot_password_confirm_submit_button: 'Confirmar',
        forgot_password_confirm_resend_success: 'Código reenviado.',
        forgot_password_confirm_error_title: 'Houve um erro ao recuperar senha.',
        forgot_password_confirm_error_description: 'Verifique o código',
        forgot_password_confirm_resend_error_title: 'Houve um erro ao reenviar código.',
        forgot_password_confirm_resend_error_description: 'Verifique seu e-mail',
      },

      forgot_password_send: {
        forgot_password_send_title: 'Definir nova senha',
        forgot_password_send_description_prefix: 'Enviamos um código de recuperação para o email',
        forgot_password_send_description_suffix: '. Insira-o abaixo:',
        forgot_password_send_new_password_label: 'Digite sua nova senha',
        forgot_password_send_confirm_password_label: 'Confirme sua nova senha',
        forgot_password_send_required_fields: '* Campos obrigatórios',
        forgot_password_send_back_link: 'Voltar',
        forgot_password_send_submit_button: 'Confirmar',
        forgot_password_send_success: 'Senha alterada com sucesso.',
        forgot_password_send_error_title: 'Houve um erro ao recuperar senha.',
        forgot_password_send_error_description: 'Verifique o código',
      },

      two_factor_auth: {
        two_factor_title: 'Verificação em duas etapas',
        two_factor_description: 'Abra seu e-mail para obter o código de verificação dois fatores.',
        two_factor_code_label: 'Código',
        two_factor_back_link: 'Voltar',
        two_factor_submit_button: 'Verificar',
        two_factor_success: 'Acesso efetuado com sucesso',
        two_factor_error_title: 'Houve um erro ao efetuar validar código de autenticação em dois fatores.',
        two_factor_error_description: 'Verifique o código',
      },
    },

    partners: {
      action_section: {
        components: {
          partners_actions_filters_box: {
            partners_filters_title: 'Filtros',
            partners_filters_partner_label: 'Parceiro:',
            partners_filters_all_option: 'Todos',
            partners_filters_action_label: 'Ação:',
            partners_filters_action_benefit: 'Clube de Benefícios',
            partners_filters_action_banner: 'Banner na Home',
            partners_filters_action_product: 'Produto na Loja',
            partners_filters_status_label: 'Situação:',
            partners_filters_clear_button: 'Limpar filtros',
          },

          partner_action_table: {
            partner_table_created_at_header: 'DATA DA CRIAÇÃO',
            partner_table_partner_name_header: 'PARCEIRO',
            partner_table_action_type_header: 'TIPO DE AÇÃO',
            partner_table_description_header: 'DESCRIÇÃO',
            partner_table_period_header: 'PERÍODO',
            partner_table_period_separator: ' a ',
            partner_table_status_header: 'SITUAÇÃO',
            partner_table_total_reach_header: 'ALCANCES',
            partner_table_total_impressions_header: 'IMPRESSÕES',
            partner_table_total_clicks_header: 'CLIQUES',
            partner_table_ctr_header: 'CTR',
            partner_table_actions_header: 'Açoes',
            partner_table_actions_menu_label: 'Mostrar mais ações',
            partner_table_edit_action: 'Editar ação',
            partner_table_edit_partner: 'Editar parceiro',
          },

          partner_edit_modal: {
            partner_edit_title: 'Editar parceiro',
            partner_edit_name_label: 'Nome*:',
            partner_edit_name_helper: '(Máx. de caracteres: 30)',
            partner_edit_image_label: 'Imagem*:',
            partner_edit_cancel_button: 'Cancelar',
            partner_edit_save_button: 'Salvar alterações',
            partner_edit_success: 'Parceiro alterado com sucesso!',
            partner_edit_error: 'Não foi possível alterar o parceiro. Tente novamente.',

            schema: {
              required: 'Campo obrigatório',
              required_file: 'Extensão inválida. Utilize .jpg, .jpeg ou .png',
            },
          },
        },

        partner_section_title: 'AÇÕES',
        partner_section_reach_label: 'ALCANCES',
        partner_section_impressions_label: 'IMPRESSÕES',
        partner_section_clicks_label: 'CLIQUES',
        partner_section_ctr_label: 'CTR',
        partner_section_error_partner_not_found: 'Parceiro não encontrado.',
      },

      partners_section: {
        components: {
          partner_create_modal: {
            partner_create_title: 'Editar parceiro',
            partner_create_name_label: 'Nome*:',
            partner_create_name_helper: '(Máx. de caracteres: 30)',
            partner_create_image_label: 'Imagem*:',
            partner_create_cancel_button: 'Cancelar',
            partner_create_save_button: 'Salvar',
            partner_create_success: 'Parceiro criado com sucesso!',
            partner_create_error: 'Não foi possível criar o parceiro. Tente novamente.',

            schema: {
              required: 'Campo obrigatório',
              required_file: 'Extensão inválida. Utilize .jpg, .jpeg ou .png',
              required_image: 'Imagem obrigatória',
              required_image_size: 'Imagem muito grande. Limite de 2MB',
            },
          },

          partner_edit_modal: {
            partner_edit_title: 'Editar parceiro',
            partner_edit_name_label: 'Nome*:',
            partner_edit_name_helper: '(Máx. de caracteres: 30)',
            partner_edit_image_label: 'Imagem*:',
            partner_edit_cancel_button: 'Cancelar',
            partner_edit_save_button: 'Salvar alterações',
            partner_edit_success: 'Parceiro alterado com sucesso!',
            partner_edit_error: 'Não foi possível alterar o parceiro. Tente novamente.',

            schema: {
              required: 'Campo obrigatório',
              required_file: 'Extensão inválida. Utilize .jpg, .jpeg ou .png',
            },
          },

          partners_filters_box: {
            partners_filters_title: 'Filtros',
            partners_filters_partner_label: 'Parceiro:',
            partners_filters_clear_button: 'Limpar filtros',
          },

          partners_table: {
            partners_table_created_at_header: 'Data de criacao',
            partners_table_name_header: 'Nome',
            partners_table_active_actions_header: 'Acoes ativas',
            partners_table_total_reach_header: 'Total de alcance',
            partners_table_total_impressions_header: 'Total de impressoes',
            partners_table_total_clicks_header: 'Total de cliques',
            partners_table_ctr_header: 'CTR',
            partners_table_actions_header: 'Açoes',
            partners_table_actions_menu_label: 'Mostrar mais ações',
            partners_table_edit_partner: 'Editar parceiro',
            partners_table_delete_partner: 'Excluir parceiro',
          },
        },

        partners_section_error_partner_not_found: 'Parceiro não encontrado.',
        partners_section_delete_confirm_title: 'Excluir parceiro',
        partners_section_delete_confirm_description_start: 'Tem certeza que deseja excluir o parceiro ',
        partners_section_delete_confirm_description_end: '?',
        partners_section_delete_success: 'Parceiro deletado com sucesso!',
        partners_section_delete_error: 'Ocorreu um erro ao deletar o parceiro. Recarregue e tente novamente.',
      },

      breadcrumb: {
        partners_label1: 'PARCEIROS',
      },

      partners_title: 'PARCEIROS',
      partners_add_partner_button: 'Adicionar parceiro',
      partners_add_action_button: 'Adicionar ação',
      partners_banner_home_menu: 'Banner na home',
      partners_store_product_menu: 'Produto na loja',
      partners_benefits_club_menu: 'Clube de Benefícios',
    },

    profile: {
      components: {
        profile_registration_data_tab_content: {
          profile_registration_data_tab_content_title: 'Dados cadastrais',
          profile_registration_data_tab_content_document_label: 'Documento',
          profile_registration_data_tab_content_name_label: 'Nome',
          profile_registration_data_tab_content_email_label: 'E-mail',
          profile_registration_data_tab_content_phone_label: 'Telefone',
          profile_registration_data_tab_content_save_button: 'Salvar alterações',
          profile_registration_data_tab_content_avatar_success_toast: 'Imagem de perfil alterada com sucesso',
          profile_registration_data_tab_content_avatar_error_toast:
            'Houve um erro ao alterar a imagem de perfil. Tente novamente',
          profile_registration_data_tab_content_update_success_toast: 'Perfil atualizado com sucesso',
          profile_registration_data_tab_content_update_error_toast: 'Houve um erro ao atualizar seu perfil. Tente novamente',

          schema: {
            required: 'Campo obrigatório',
            required_document: 'Documento inválido',
            required_email: 'E-mail inválido',
          },
        },

        security_tab_content: {
          security_tab_content_title: 'Alterar senha',
          security_tab_content_current_password_label: 'Digite sua senha atual',
          security_tab_content_new_password_label: 'Digite sua nova senha',
          security_tab_content_confirm_password_label: 'Confirme sua nova senha',
          security_tab_content_submit_button: 'Alterar senha',
          security_tab_content_success_toast: 'Senha alterada com sucesso',
          security_tab_content_error_toast: 'Houve um erro ao alterar a senha. Tente novamente',

          schema: {
            required: 'Campo obrigatório',
            required_min: 'Deve conter no mínimo 8 caracteres',
            required_request: 'Não satisfaz os requisitos necessários',
            required_password: 'As senhas não são iguais',
            required_newpass: 'A nova senha não deve ser igual à atual',
          },
        },
      },

      breadcrumb: {
        profile_label1: 'MEUS DADOS',
      },

      profile_page_title: 'MEUS DADOS',
      profile_registration_data_tab: 'Dados cadastrais',
      profile_security_tab: 'Segurança',
    },

    application_challenge: {
      components: {
        challenge_filters_box: {
          challenge_filters_box_title: 'Filtros',
          challenge_filters_box_challenge_label: 'Desafio:',
          challenge_filters_box_team_label: 'Time:',
          challenge_filters_box_team_all_option: 'Todos',
          challenge_filters_box_status_label: 'Situação:',
          challenge_filters_box_status_all_option: 'Todas',
          challenge_filters_box_interactivity_label: 'Interação:',
          challenge_filters_box_interactivity_all_option: 'Todos',
          challenge_filters_box_clear_filters_button: 'Limpar filtros',
        },

        challenge_table: {
          challenge_table_created_at_header: 'DATA DA CRIAÇÃO',
          challenge_table_starts_in_header: 'DATA DE INÍCIO',
          challenge_table_team_header: 'TIME',
          challenge_table_title_header: 'TÍTULO',
          challenge_table_total_participants_header: 'PARTICIPAÇÕES',
          challenge_table_winner_header: 'VENCEDOR',
          challenge_table_winner_empty: '0',
          challenge_table_status_header: 'SITUAÇÃO',
          challenge_table_interactivity_header: 'INTERAÇÃO',
          challenge_table_interactivity_not_started: 'Não iniciado',
          challenge_table_finish_button: 'Encerrar desafio',
          challenge_table_actions_header: 'Açoes',
          challenge_table_view_details_action: 'Editar',
          challenge_table_delete_action: 'Excluir',
          challenge_table_more_actions_label: 'Mostrar mais ações',
        },
      },

      breadcrumb: {
        challenge_label1: 'APLICATIVO',
        challenge_label2: 'DESAFIOS',
      },

      application_challenge_page_title: 'DESAFIOS',
      application_challenge_create_button: 'Criar desafio',
      application_challenge_label: 'Desafios',
      application_challenge_enabled_label: 'Habilitado',
      application_challenge_disabled_label: 'Desabilitado',
      application_challenge_description:
        'O Desafio é um super quiz com perguntas de múltipla escolha, tempo limitado para cada resposta e eliminação imediata em caso de erro ou tempo esgotado. Apenas o primeiro usuário que acertar todas as perguntas corretamente vence o desafio. Você pode personalizar o conteúdo, tempo por pergunta e as mensagens exibidas em cada etapa do quiz. ',
      application_challenge_important: 'Importante:',
      application_challenge_one: 'só é possível ter um desafio ativo por vez.',
      application_challenge_total_challenges_label: 'TOTAL DE DESAFIOS',
      application_challenge_total_participants_label: 'PARTICIPAÇÕES',
      application_challenge_winners_label: 'VENCEDORES',
      application_challenge_enable_success_toast: 'Desafios habilitada com sucesso',
      application_challenge_enable_error_toast: 'Ocorreu um erro ao habilitar desafios. Recarregue a página e tente novamente.',
      application_challenge_disable_success_toast: 'Desafios desabilitada com sucesso',
      application_challenge_disable_error_toast:
        'Ocorreu um erro ao desabilitar desafios. Recarregue a página e tente novamente.',
      application_challenge_delete_success_toast: 'Desafio deletado com sucesso!',
      application_challenge_delete_error_toast: 'Ocorreu um erro ao deletar o desafio. Recarregue e tente novamente.',
      application_challenge_delete_modal_title: 'Excluir desafio',
      application_challenge_delete_modal_description: 'Tem certeza que deseja excluir o desafio "{{title}}"?',
      application_challenge_app_area_modal_title: 'Desafios',
      application_challenge_app_area_modal_description_enable: 'Tem certeza que deseja habilitar este componente?',
      application_challenge_app_area_modal_description_disable: 'Tem certeza que deseja desabilitar este componente?',
      application_challenge_app_area_not: 'Não iniciado',
    },

    challenges_details: {
      page_title: 'Desafios',

      create_title: 'Criar desafio',
      edit_title: 'Detalhes do desafio',
      switch_published: 'Publicado',
      button_end_challenge: 'Encerrar desafio',

      breadcrumb: {
        label_1: 'Aplicativo',
        label_2: 'Desafios',
        label_3: 'Detalhes',
      },

      schema: {
        at_least_one_question: 'Adicione pelo menos uma pergunta',
        at_least_two_alternatives: 'Adicione pelo menos duas alternativas',
        correct_alternative: 'Selecione a alternativa correta',
      },

      toasts: {
        create_success: 'Desafio criado com sucesso',
        create_error: 'Houve um erro ao criar o desafio. Tente novamente',
        edit_success: 'Alterações salvas com sucesso',
        edit_error: 'Houve um erro ao salvar alterações. Tente novamente',
        get_by_uuid_error: 'Houve um erro. Tente novamente',
        publish_success: 'Desafio habilitado com sucesso',
        publish_error: 'Houve um erro ao habilitar desafio. Tente novamente',
        unpublish_success: 'Desafio desabilitado com sucesso',
        unpublish_error: 'Houve um erro ao desabilitar desafio. Tente novamente',
        close_success: 'Desafio encerrado com sucesso',
        close_error: 'Houve um erro ao encerrar o desafio. Tente novamente',
      },

      tabs: {
        tab_1: {
          title: 'Informações',
          input_title_label: 'Título do desafio',
          input_team_label: 'Time',
          input_title_placeholder: 'Desafio do Intervalo',
          input_description_label: 'Descrição',
          input_description_helptext: 'Divulgação do desafio, regras e prêmios para o vencedor',
          input_description_placeholder:
            'Seja o primeiro a responder corretamente 20 perguntas no menor tempo possível e dispute um prêmio exclusivo!',
          input_limit_label: 'Tempo limite por pergunta (em segundos)',
          input_limit_helptext: 'Tempo que o participante terá para responder cada pergunta',
          input_limit_placeholder: '10 segundos',
          switch_start_at_label: 'Definir data de início do desafio',
          switch_start_at_helptext:
            'Ao publicar o desafio com data de início definida, ele aparecerá na Página Inicial com um contador regressivo até seu início. Caso não defina uma data, será publicado imediatamente, já aberto para participação dos usuários',
          input_date_label: 'Data',
          input_date_placeholder: '20/04/2025 16:50',
        },

        tab_2: {
          title: 'Perguntas',
          title_label: 'Perguntas (mínimo de 2)',
          title_helper: '(Máx. de caracteres: 100)',
          image_label: 'Imagem',
          input_question_label: 'Pergunta {{number}}',
          input_alternative_label: 'Alternativa {{number}}',
          button_add_question: 'Adicionar pergunta',
          button_add_alternative: 'Adicionar alternativa',
          button_save: 'Salvar pergunta',
          button_cancel: 'Cancelar pergunta',
        },

        tab_3: {
          title: 'Mensagens',
          input_incorrect_label: 'Resposta incorreta',
          input_incorrect_helptext: 'Mensagem exibida quando o participante errar alguma pergunta',
          input_time_label: 'Tempo esgotado',
          input_time_helptext: 'Mensagem exibida quando terminar o tempo para responder a pergunta',
          input_other_winner_label: 'Vencido por outro participante',
          input_other_winner_helptext: 'Mensagem exibida quando outro joogador vence o desafio antes do participante',
          input_winner_label: 'Participante vencedor',
          input_winner_helptext: 'Mensagem exibida para parabenizar o jogador que completar o desafio primeiro',
        },
      },
    },
  },
};
